{
	"admin": {
		"components": {
			"quizTakenChartTSX": {
				"month": "MONTH",
				"noQuiz": "Number of Asynchronous Assessments",
				"totalQuiz": " Total Asynchronous Assessments Taken",
				"totalLive": " Total Live Sessions Joined",
				"reportBtn": "Get Report",
				"chartQuiz": "Asynchronous Assessments taken",
				"chartLive": "Live sessions joined"
			},
			"reportHeaderTSX": {
				"severe": "Severe",
				"major": "Major",
				"minor": "Minor",
				"none": "Info",
				"na": "N/A",
				"report": "Institution Report",
				"description": "Administrators can view insights into the number of downloaded extensions and assessments taken, as well as access a comprehensive overview of the top flagged courses.",
				"averageFlag": "Average Flag Level",
				"firstTimeDownload": "First-Time Extension Downloads",
				"totalDownload": "Total Extension Downloads & Updates"
			},
			"topFlaggedCoursesTSX": {
				"title": "Top Flagged Courses",
				"description": "View the top flagged courses in your institution for this term, categorized by severe, major, and minor.",
				"topFlagCourse": "Top Flagged Courses - ",
				"severe": "Severe",
				"major": "Major",
				"minor": "Minor",
				"rank": "Rank",
				"course": "Course",
				"code": "Code",
				"num": "Number of Flags",
				"result": "Proctoring Results"
			},
			"institutionReportTSX": {
				"allAccounts": "All Accounts",
				"courseAnalytics": "Course Analytics",
				"selectCourseTxt": "View a list of Verity-enabled courses and select a course to view its report.",
				"courseName": "Course Name",
				"courseCode": "Course Code",
				"testTakersProctored": "Test-Takers Proctored",
				"flaggedEvents": "Flagged Events",
				"integrityScore": "Integrity Score",
				"avgFlagLevel": "Average Flag Level",
				"viewReport": "View Report",
				"viewReportAlt": "View report for {{courseName}}",
				"searchByCourseName": "Search by course name",
				"noResultTxt": "No Results Found",
				"longReportTxt": "The report is taking longer than expected to generate. Please check back in an hour.",
				"select": "Select",
				"switch": "Switch",
				"searchBy": "Search by",
				"nameOrID": "name or ID",
				"refresh": "Refresh",
				"refreshTitle": "Refresh Report",
				"refreshDesc": "Refreshing a report may take up to an hour. Are you sure you want to continue?",
				"refreshError": "Something went wrong while refreshing the report. Please try again."
			}
		}
	},
	"authentication": {
		"components": {
			"passwordInputTSX": {
				"noPasswordError": "Password must be provided",
				"noElementError": "Password is must include all required elements",
				"notMatchError": "Passwords do not match",
				"label": "Password",
				"retryLabel": "Retype password"
			},
			"passwordChecklistTSX": {
				"lowerCase": "Lowercase letter",
				"upperCase": "Uppercase letter",
				"num": "Number",
				"symbol": "Symbol"
			},
			"passwordStrengthTSX": {
				"veryWeak": "Very weak",
				"weak": "Weak",
				"moderated": "Moderate",
				"strong": "Strong",
				"veryStrong": "Very strong"
			},
			"searchBarTSX": "Search",
			"AuditLogEventText": {
				"events": {
					"error": "Error",
					"auth:refresh-token:received": "Refresh token received",
					"auth:account-id:received": "Account ID received",
					"auth:auth-code:requested": "Requested new auth code",
					"auth:auth-code:created": "New auth code created",
					"auth:auth-code:received": "Auth code received",
					"auth:refresh-token:refreshed": "Refresh token refreshed",
					"auth:refresh-token:stored": "Refresh token stored",
					"auth:refresh-token:cleared": "Refresh token cleared",
					"auth:authenticated-page:opened": "Authenticated page opened",
					"auth:authenticated-page:detected": "Page to authenticate detected",
					"auth:authenticated-page:authenticate-message:sent": "Sent message to authenticate page",
					"auth:authenticated-page:authenticate-message:received": "Received message for authenticating page",
					"auth:authenticated-page:auth-code:sent": "Sent auth code message for authenticating page",
					"auth:authenticated-page:auth-code:received": "Received auth code message for authenticating page",
					"auth:authenticated-page:auth-code:exchanged": "Exchanged received auth code",
					"auth:authenticated-page:authenticated": "Authenticated new page",
					"auth:authenticated-page:authentication-skipped": "Skipped authenticating new page",
					"assessment:edit:detected": "Assessment edit page detected",
					"assessment:edit:verity-checkbox:injection-skipped": "Verity checkbox not injected",
					"assessment:edit:verity-checkbox:injected": "Verity checkbox injected",
					"assessment:edit:verity-checkbox:initial-configuration-received": "Initial Verity configuration loaded",
					"assessment:edit:configuration-modal:opened": "Configuration modal opened",
					"assessment:edit:configuration-modal:save-started": "Saving configuration modal started",
					"assessment:edit:configuration-modal:save-finished": "Configuration modal saved",
					"assessment:edit:configuration-modal:closed": "Configuration modal closed",
					"assessment:edit:verity-checkbox:status-changed": "Verity checkbox updated",
					"assessment:edit:save-button:replacement-skipped": "Assessment save button not replaced",
					"assessment:edit:save-button:replaced": "Assessment save button replaced",
					"assessment:edit:save-button:clicked": "Replacement assessment save button clicked",
					"assessment:edit:save-button:save-started": "Started saving Verity configuration",
					"assessment:edit:save-button:save-finished": "Verity configuration saved",
					"assessment:edit:save-button:original-clicked": "Original assessment save button clicked",
					"assessment:take:start:detected": "Assessment start page detected",
					"assessment:take:start:injection-skipped": "Assessment page elements not injected",
					"assessment:take:start:returned-to-start-page": "Navigated back to start assessment page",
					"assessment:take:start:start-button:disabled": "Start assessment button disabled",
					"assessment:take:start:start-button:enabled": "Start assessment button enabled",
					"assessment:take:start:start-button:replacement-skipped": "Start assessment button not replaced",
					"assessment:take:start:start-button:replaced": "Start assessment button replaced",
					"assessment:take:start:start-button:clicked": "Replacement start assessment button clicked",
					"assessment:take:start:start-button:original-not-clicked": "Original start assessment button not clicked",
					"assessment:take:start:start-button:original-clicked": "Original start assessment button clicked",
					"assessment:take:start:preview-dialog:opened": "Preview Mode dialog opened",
					"assessment:take:start:preview-dialog:closed": "Preview Mode dialog closed",
					"assessment:take:start:notified-lms": "Notified LMS to start assessment",
					"assessment:take:start:third-party:start-dialog:opened": "Start third-party assessment dialog opened",
					"assessment:take:start:third-party:start-dialog:closed": "Start third-party assessment dialog closed",
					"assessment:take:start:third-party:context:set": "Third-party assessment context set",
					"assessment:take:start:third-party:context:consumed": "Third-party assessment context consumed",
					"assessment:take:start:third-party:password:fill-enabled": "Enabled manual filling of third-party assessment password",
					"assessment:take:start:third-party:password:fill-disabled": "Disabled manual filling of third-party assessment password",
					"assessment:take:session:started": "Proctoring session started",
					"assessment:take:session:finished": "Proctoring session ended",
					"assessment:take:session:interrupt:created": "Interrupt created",
					"assessment:take:session:interrupt:updated": "Interrupt updated",
					"assessment:take:session:interrupt:deleted": "Interrupt removed",
					"assessment:take:session:limiter:navigation:blocked": "Blocked navigation",
					"assessment:take:session:live:joined": "Live session joined",
					"assessment:take:session:live:left": "Live session left",
					"assessment:take:session:recorder:user-media:started": "User media recording started",
					"assessment:take:session:recorder:user-media:stopped": "User media recording stopped",
					"assessment:take:session:recorder:display:started": "Display recording started",
					"assessment:take:session:recorder:display:stopped": "Display recording stopped",
					"assessment:take:session:recorder:face:initialization:started": "Face recorder warmup started",
					"assessment:take:session:recorder:face:initialization:finished": "Face recorder warmup finished",
					"assessment:take:session:recorder:face:started": "Face recording started",
					"assessment:take:session:recorder:face:stopped": "Face recording stopped",
					"assessment:take:session:recorder:object:initialization:started": "Object recorder warmup started",
					"assessment:take:session:recorder:object:initialization:finished": "Object recorder warmup finished",
					"assessment:take:session:recorder:object:started": "Object recording started",
					"assessment:take:session:recorder:object:stopped": "Object recording stopped",
					"assessment:take:setup:not-started": "Proctoring setup not started",
					"assessment:take:setup:started": "Proctoring setup page opened",
					"assessment:take:setup:component-initialization:started": "Component initialization started",
					"assessment:take:setup:component-initialization:finished": "Component initialization finished",
					"assessment:take:setup:cancel-clicked": "Cancel setup button clicked",
					"assessment:take:setup:cancelled": "Proctoring setup cancelled",
					"assessment:take:setup:finish-clicked": "Finish setup button clicked",
					"assessment:take:setup:finished": "Proctoring setup finished",
					"assessment:take:password:detected": "Assessment password page detected",
					"assessment:take:password:fill-skipped": "Password not filled",
					"assessment:take:password:filled": "Password filled",
					"assessment:take:password:submit-button:click-skipped": "Submit password button not clicked",
					"assessment:take:password:submit-button:clicked": "Submit password button clicked",
					"assessment:take:password:incorrect": "Incorrect password detected",
					"assessment:take:end:submit-detected": "Submit assessment detected",
					"assessment:take:end:not-matched": "Request did not match submit",
					"assessment:take:end:manually-ended": "Manual end assessment button clicked",
					"assessment:take:end:notified-lms": "Notified LMS of assessment end",
					"assessment:take:end:uploading-page:opened": "Uploading page opened",
					"assessment:take:end:finished-page:opened": "Finished page opened",
					"assessment:take:end:finished-page:closed": "Finished page closed",
					"browser:closed": "Browser closed",
					"browser:disposed": "Application disposed",
					"browser:tool:registration:started": "Tool registration started",
					"browser:tool:registration:finished": "Tool registered",
					"browser:tool:deregistered": "Tool deregistered"
				},
				"authenticationTSX": {
					"from": "From",
					"tabUrl": "Tab URL",
					"accountId": "Account ID",
					"refreshFailed": "Refresh token refresh failed"
				},
				"assessment": {
					"interceptionDetailsTableTSX": {
						"interceptor": "Interceptor",
						"lms": "LMS",
						"canvas": "Canvas",
						"BlackboardLearn": "Blackboard",
						"moodle": "Moodle",
						"desire2learn": "D2L",
						"assessmentType": "Assessment type",
						"classicQuiz": "Classic quiz",
						"newQuiz": "New quiz",
						"location": "Location",
						"assignment": "Assignment",
						"courseType": "Course type",
						"original": "Original",
						"ultra": "Ultra",
						"version": "Version",
						"specialHostname": "Special hostname",
						"thirdPartyPlatform": "Third-party platform",
						"strategy": "Strategy",
						"variant": "Variant",
						"urlPatterns": "URL patterns",
						"inPageUrlPatterns": "In-page URL patterns",
						"frameName": "Frame name",
						"url": "URL",
						"methods": "Methods"
					},
					"edit": {
						"verityCheckboxTSX": {
							"checkboxChecked": "Verity checkbox checked",
							"checkboxUnchecked": "Verity checkbox unchecked"
						},
						"configurationModalTSX": {
							"saveFailed": "Saving configuration modal failed",
							"message": "Message"
						},
						"saveButtonTSX": {
							"saveFailed": "Saving Verity configuration failed"
						}
					},
					"take": {
						"start": {
							"previewDialogTSX": {
								"withProctoring": "Start quiz with proctoring selected",
								"withoutProctoring": "Start quiz without proctoring selected"
							}
						},
						"session": {
							"interruptTSX": {
								"interruptCreated": "{{kind}} interrupt created",
								"interruptUpdated": "{{kind}} interrupt updated",
								"interruptDeleted": "{{kind}} interrupt removed"
							}
						},
						"setupTSX": {
							"componentInitializationStarted": "{{component}} initialization started",
							"componentInitializationFinished": "{{component}} initialization finished"
						},
						"passwordTSX": {
							"password": "Password"
						},
						"end": {
							"indexTSX": {
								"field": "Field",
								"required": "Required",
								"found": "Found"
							},
							"finishedPageTSX": {
								"type": "Type",
								"method": "Method"
							}
						}
					}
				},
				"browser": {
					"toolTSX": {
						"registrationStarted": "{{tool}} tool registration started",
						"registered": "{{tool}} tool registered",
						"deregistered": "{{tool}} tool deregistered"
					}
				},
				"detailsTSX": {
					"reason": "Reason",
					"elementName": "Element name",
					"elementSelector": "Element selector",
					"permission": "Permission"
				}
			}
		},
		"containers": {
			"courseSelectorTSX": {
				"label": "Course",
				"none": "[None]"
			},
			"createUserModalTSX": {
				"emailError": "Email must be provided",
				"titleInvite": "Invite User",
				"cancel": "Cancel",
				"next": "Next",
				"descriptionInvite": "Please enter the email of the user to invite.",
				"label": "Email",
				"nameError": "Name must be provided",
				"toastError": "Failed to create account",
				"toastSuccess": "User created",
				"titleUser": "Invite User",
				"back": "Back",
				"finish": "Finish",
				"accExist": "The user will be added to the existing account with email ",
				"accNotExist": "Edit the details of the new user.",
				"name": "Name",
				"addUserPermissionError": "You do not have permission to add a user to this account",
				"createAccPermissionError": "You do not have permission to add a user to this account",
				"unknownError": "An unknown error occurred while trying to create the user"
			},
			"editRolesListTSX": {
				"edit": "Edit",
				"roleDeleted": "Role deleted",
				"roleDeleteFail": "Failed to delete role",
				"delete": "Delete",
				"titleEntry": "Edit Role",
				"save": "Save",
				"roleUpdated": "Role updated",
				"roleUpdateFail": "Failed to update role",
				"role": "Role",
				"roleDescription": "Failed to load roles. Please refresh the page to try again.",
				"searchLabel": "Search Roles",
				"noResult": "No results were found",
				"noRole": "There are no roles yet. Click Create to create one.",
				"name": "Name",
				"description": "Description",
				"actions": "Actions",
				"roleEditTitle": "Create Role",
				"create": "Create",
				"roleCreated": "Role created",
				"roleCreateFail": "Failed to create role"
			},
			"editUserModalTSX": {
				"nameError": "Name must not be empty",
				"toastSuccess": "User updated",
				"toastError": "Failed to update user",
				"cancel": "Cancel",
				"save": "Save",
				"email": "Email",
				"name": "Name"
			},
			"editUserRolePickerTSX": {
				"roles": "Roles",
				"add": "Add",
				"description": "Failed to load roles. Please try again.",
				"noRoleAdd": "No roles have been added."
			},
			"instituteSelectorTSX": {
				"label": "Institution",
				"selectInstitute": "Select Institution"
			},
			"roleSelectorTSX": {
				"none": "[None]"
			},
			"applicationsEditorTSX": {
				"applicationDeleted": "Application deployment deleted",
				"applicationDeleteFail": "Failed to delete application deployment"
			},
			"mainMenuTSX": {
				"switchUser": "Switch Active User",
				"profile": "Profile",
				"liveSession": "Live Sessions",
				"popInSessions": "Check-In Sessions",
				"admin": "Admin",
				"proctorManage": "Proctor Management",
				"instituteManage": "Institution Management",
				"auditLogs": "Audit Logs",
				"logOut": "Log Out",
				"homePortal": "Home Portal"
			},
			"proctorGroupEditorTSX": {
				"instituteError": "An institution must be selected",
				"minNoticeError": "Minimum notice cannot be empty or less than zero",
				"minNoticeAutoCancellationError": "Minimum notice cannot be equal to or less than automatic cancellation time",
				"timeEmptyError": "Time to notify backup emails cannot be empty",
				"timeZeroError": "Time to notify backup emails cannot be zero",
				"timeMinError": "Time to notify backup emails must be less than minimum notice",
				"trackCancellationError": "Time to track cancellations cannot be empty or less than zero",
				"autoCancelError": "Time to automatically cancel empty sessions cannot be less than zero",
				"instituteTitle": "Institution Settings",
				"cancel": "Cancel",
				"confirm": "Confirm",
				"institute": "Institution",
				"minNoticeLabel": "Minimum notice before session start [hours]",
				"minNoticeHelper": "Instructors must create the session this many hours in advance of its scheduled start time",
				"inactiveLabel": "Notify admins when there are no proctors for [minutes]",
				"inactiveHelper": "Admins will be notified this many minutes after no proctor is in a session",
				"inactiveNotificationIntervalLabel": "Interval between no proctor emails [minutes]",
				"inactiveNotificationIntervalHelper": "Email alerts when there are no proctors will be resent at intervals of this many minutes",
				"inactiveNotificationCountLabel": "Maximum no proctor emails",
				"inactiveNotificationCountHelper": "Send at most this many emails about no proctors being in a session",
				"trackCancellationHelper": "Cancellations within this many hours of a session's scheduled start time will be tracked (set to 0 to not track cancellations)",
				"autoCancelLabel": "Cancel empty sessions [hours] before start",
				"autoCancelHelper": "Sessions will be automatically cancelled this many hours before the scheduled start time if no test-takers have registered by this time",
				"edit": "Edit",
				"add": "Add",
				"noInstiAdd": "No institutions have been added.",
				"failLoadProc": "Failed to load proctors. Please try again.",
				"noProctor": "No proctors have been added.",
				"email": "Email",
				"delete": "Delete",
				"editEmail": "Edit Backup Email",
				"noEmail": "No backup emails have been added.",
				"addEmail": "Add Backup Email",
				"nameError": "Name must not be empty",
				"proctorsRequired": "At least one proctor must be assigned.",
				"adminsRequired": "At least one admin must be assigned.",
				"inactiveError": "Time to notify admins cannot be less than zero",
				"inactiveNotificationIntervalEmptyError": "Interval between emails must not be empty",
				"inactiveNotificationIntervalValueError": "Interval between emails must be at least 1 minute",
				"inactiveNotificationCountError": "Number of emails must be at least 1",
				"roleError": "Role names must be unique",
				"name": "Name",
				"ownerInsti": "Owner institution",
				"proctors": "Proctors",
				"allowInstitute": "Allowed Institutions",
				"admins": "Admins",
				"failLoadAdmins": "Failed to load admins. Please try again.",
				"noAdmins": "No admins have been added.",
				"settings": "Settings"
			},
			"proctorAvailModalTSX": {
				"avail": "Available",
				"unavail": "Unavailable",
				"loadFail": "Failed to load proctor availability. Please refresh the page to try again.",
				"proctAvail": "Proctoring Availability",
				"cancel": "Cancel",
				"procAvailUpdate": "Proctoring availability updated",
				"updateFail": "Failed to update proctoring availability",
				"save": "Save"
			},
			"roleEditorTSX": {
				"privi": "Privileges",
				"failPrivi": "Failed to load privileges. Please try again.",
				"inherit": "Inherits from",
				"title": "Select Parent",
				"save": "Save",
				"nameError": "Name must not be empty",
				"roleError": "Role names must be unique",
				"cancel": "Cancel",
				"name": "Name",
				"description": "Description",
				"ownerInsti": "Owner institution",
				"limitInsti": "Limit to institution",
				"limitCourse": "Limit to course"
			},
			"sessionDetailModalTSX": {
				"edits": "Edits:",
				"filterStu": "Filter by Test-Taker",
				"allStu": "[All Test-Takers]",
				"studentNotes": "Test-Taker Notes",
				"proctorDetails": "Proctor Details",
				"proctorEvents": "Proctor Sessions",
				"sessions": "Sessions",
				"start": "Start",
				"end": "End",
				"notes": "Notes",
				"loadFailTitle": "Failed to load live session details",
				"loadFail": "Failed to load live session details. Please try again.",
				"loadNotesFail": "Failed to load notes. Please try again.",
				"loadSessionsFail": "Failed to load sessions. Please try again.",
				"proctorHeader": "Proctor:",
				"noProctors": "There are no proctors for this live proctoring session.",
				"noProctorSessions": "There are no proctor sessions documented for this live proctoring session.",
				"noNotes": "There are no notes for this live proctoring session.",
				"noProctorNote": "No notes have been added for this proctor.",
				"proctorNoteUpdated": "Proctor note updated",
				"updateProctorNoteFail": "Failed to update proctor note."
			},
			"simpleRolesListTSX": {
				"noRole": "No roles available",
				"title": "Select Role"
			},
			"simpleUsersListTSX": {
				"noUser": "No users available",
				"title": "Select User"
			},
			"simpleAssessmentsListTSX": {
				"assessment": "Assessment",
				"lmsCourseId": "LMS Course ID",
				"lmsAssessmentId": "LMS Assessment ID",
				"noAssessment": "No assessments found",
				"title": "Select Assessment"
			},
			"usersListTSX": {
				"edit": "Edit",
				"userDeleted": "User deleted",
				"userDeleteFail": "Failed to delete user",
				"delete": "Delete",
				"viewAvail": "View Availability",
				"resendEmail": "Resend Invitation Email",
				"users": "Users",
				"create": "Create",
				"loadFail": "Failed to load users. Please refresh the page to try again.",
				"searchLabel": "Search Users",
				"noResult": "No results were found",
				"noUser": "There are no users yet. Click Create to create one.",
				"id": "ID",
				"name": "Name",
				"email": "Email",
				"actions": "Actions",
				"securityPin": "Security PIN",
				"deleteUser": "Delete User",
				"confirmDeleteUser": "Are you sure you want to delete {{userName}}?",
				"alsoDeleteAccount": "Also delete the associated account",
				"cancel": "Cancel"
			},
			"accountsListTSX": {
				"accounts": "Accounts",
				"search": "Search Accounts",
				"loadingFailed": "Failed to load accounts. Please refresh the page to try again.",
				"noResults": "No results were found",
				"noAccounts": "There are no accounts yet. Create a user to create one.",
				"id": "ID",
				"type": "Type",
				"email": "Email",
				"users": "User Count",
				"actions": "Actions",
				"delete": "Delete",
				"deleteAccount": "Delete Account",
				"confirmDeleteAccountEmail": "Are you sure you want to delete the account with email {{email}}?",
				"confirmDeleteAccount": "Are you sure you want to delete this account?",
				"cancel": "Cancel",
				"accountDeleted": "Account deleted",
				"deleteAccountFailed": "Failed to delete account"
			},
			"proctorHoursReportModalTSX": {
				"downloadHours": "Download Proctor Hours Report",
				"startDate": "Start Date",
				"endDate": "End Date",
				"proctorId": "Proctor ID",
				"proctorName": "Proctor Name",
				"hours": "Hours",
				"invalidDates": "Invalid date range",
				"downloadFailed": "Failed to download proctor data."
			}
		},
		"routes": {
			"acceptProcPageTSX": {
				"noLive": "Live proctoring session not found.",
				"noPermit": "You are not permitted to accept this proctoring session. Please check that your selected user is in the proctor group the session is assigned to.",
				"alreadyAccept": "A user has already accepted the proctoring session.",
				"unknownError": "An unknown error occurred",
				"processing": "Processing...",
				"acceptProc": "Proctoring Session Accepted",
				"acceptSuccess": "You have successfully accepted the session",
				"acceptError": "Error Accepting Proctoring Session",
				"backToLive": "Back to Live Sessions"
			},
			"adminPageTSX": {
				"admin": "Admin"
			},
			"forgotPasswordPageTSX": {
				"emailError": "Email must be provided",
				"noAccountError": "No account was found for that email address",
				"formError": "Email address is not well-formed",
				"unknownError": "An unknown error occurred.",
				"recoverPassword": "Password Recovery",
				"email": "Email",
				"submit": "Submit"
			},
			"forgotPasswordSuccessPageTSX": {
				"send": "Email sent",
				"description": "An email containing a link to reset your password has been sent to your email address.",
				"login": "Login"
			},
			"loginPageTSX": {
				"emailError": "Email must be provided",
				"passwordError": "Password must be provided",
				"invalid": "Invalid username or password.",
				"lockAcc": "The account has been locked.",
				"notVerified": "Email has not been verified. Please verify your email before logging in.",
				"unknown": "An unknown error occurred.",
				"platform": "YuJa Verity Test Proctoring Platform",
				"forgot": " If you do not remember your password, click on 'Forgot your password'.",
				"noAttempt": "You have no attempts remaining. Please try again later. If you do not remember your password, click on 'Forgot your password'.",
				"email": "Email",
				"password": "Password",
				"login": "Login",
				"forgotPassword": "Forgot your password?",
				"createAcc": "Create a new account"
			},
			"noAccessPageTSX": {
				"accessDeny": "Access Denied",
				"noPermission": "You do not have permission to access this page.",
				"return": "Return to Profile"
			},
			"proctorManagementPageTSX": {
				"edit": "Edit",
				"deleteGroup": "Proctor group deleted",
				"deleteFail": "Failed to delete proctor group",
				"delete": "Delete",
				"title": "Edit Proctor Group",
				"save": "Save",
				"groupUpdated": "Proctor group updated",
				"updateFail": "Failed to update proctor group",
				"procGroup": "Proctor Groups",
				"loadFail": "Failed to load proctor groups. Please refresh the page to try again.",
				"searchProc": "Search Proctor Groups",
				"noResult": "No results were found",
				"noGroup": "There are no proctor groups yet. Click Create to create one.",
				"name": "Name",
				"actions": "Actions",
				"createGroup": "Create Proctor Group",
				"create": "Create",
				"groupCreated": "Proctor group created",
				"createFail": "Failed to create proctor group",
				"proctorHours": "Proctor Hours Report"
			},
			"profilePageTSX": {
				"passwordError": "Current password must be provided",
				"passwordChange": "Password changed",
				"passwordIncorrect": "Current password is incorrect",
				"unknownError": "An unknown error occurred while trying to update the password",
				"changePassword": "Change Password",
				"cancel": "Cancel",
				"save": "Save",
				"currentPassword": "Current password",
				"profile": "Profile",
				"email": "Email:",
				"name": "Name:",
				"password": "Password:",
				"timezoneColon": "Timezone:",
				"proctoringAvailability": "Proctoring Availability",
				"editAvailability": "Edit Availability",
				"profileUpdated": "Profile updated",
				"failUpdateProfile": "Failed to update profile"
			},
			"registerPageTSX": {
				"noEmail": "Email must be provided",
				"fixError": "Please fix the above errors to continue.",
				"formatError": "Email address is not well-formed",
				"alreadyError": "There is already an account with this email",
				"unknownError": "An unknown error occurred.",
				"registerError": "Error registering account.",
				"accRegistration": "Account Registration",
				"email": "Email",
				"register": "Register"
			},
			"registerSuccessPageTSX": {
				"accRegistered": "Account registered",
				"description": "You must first verify your email before signing in. Please check your email for a link to verify it.",
				"login": "Login"
			},
			"resetPasswordPageTSX": {
				"fixError": "Please fix the above errors to continue.",
				"invalidError": "The link is invalid. Please create a new link by resetting your password again.",
				"resetPassword": "Reset Password",
				"updatePassword": "Update Password"
			},
			"resetPasswordSuccessPageTSX": {
				"updatePassword": "Password updated",
				"description": "You may now log in using your new password.",
				"login": "Login"
			},
			"userSelectionPageTSX": {
				"userChange": "Active user changed",
				"userError": "Error changing active user",
				"selectUser": "Select Active User",
				"noUser": "There are no users associated with your account. Please contact your administrator.",
				"logout": "Logout"
			},
			"verifyEmailPageTSX": {
				"processing": "Processing...",
				"emailVerify": "Email verified",
				"successVerify": "Your email has been verified successfully. You may now log in.",
				"verifyError": "Error verifying email",
				"contactSupport": "Please contact support if this issue persists.",
				"login": "Login"
			},
			"auditLogsPageTSX": {
				"auditLogs": "Audit Logs",
				"institute": "Institution",
				"allInstitutes": "[All Institutions]",
				"selectUser": "Select User",
				"selectedUser": "Selected User",
				"platform": "Platform",
				"allPlatforms": "[All Platforms]",
				"extension": "Extension",
				"lockdown": "Lockdown",
				"installationId": "Installation ID",
				"fingerprint": "Fingerprint",
				"logType": "Log type",
				"after": "After",
				"before": "Before",
				"time": "Time",
				"client": "Client",
				"user": "User",
				"event": "Event",
				"context": "Context",
				"tab": "Tab",
				"page": "Page",
				"parentFrames": "Parent frames",
				"id": "ID",
				"position": "Position",
				"url": "URL",
				"incognito": "Incognito",
				"ipAddress": "IP address",
				"browser": "Browser",
				"name": "Name",
				"version": "Version",
				"userAgent": "User agent",
				"device": "Device",
				"os": "OS",
				"osVersion": "Version",
				"architecture": "Architecture",
				"mobile": "Mobile",
				"resolution": "Display resolution",
				"language": "Language",
				"timezone": "Timezone",
				"errorLoading": "Error loading audit logs",
				"noLogs": "No audit logs",
				"noResults": "No search results"
			}
		},
		"hooks": {
			"useResendVerificationEmailTS": {
				"emailResent": "Email resent",
				"sendFail": "Failed to send email"
			}
		}
	},
	"download": {
		"lockdown": {
			"title": "Is This Your First Time Using YuJa Verity Lockdown?",
			"subtitle": "Please follow the steps below to help you get started.",
			"1": {
				"incompleteTitle": "Download the Verity Lockdown App",
				"completeTitle": "Verity Lockdown successfully installed.",
				"body": "The Lockdown App is supported for Windows and Mac operating systems.",
				"win": "Download the Lockdown App for Windows.",
				"mac": "Download the Lockdown App for Mac.",
				"winButton": "Windows",
				"macButton": "Intel Mac",
				"macArmButton": "M-Series Mac"
			},
			"2": {
				"incompleteTitle": "Take Your Assessment",
				"completeTitle": "You're all set! Navigate to your assessment to begin. Good luck!"
			},
			"stillQuestion": "Still have questions? Click here to go to the",
			"help": "Help Center"
		},
		"mobile": {
			"title": "Is This Your First Time Using YuJa Verity Mobile?",
			"subtitle": "Please follow the steps below to get started.",
			"1": {
				"incompleteTitle": "Download the Verity Mobile App",
				"completeTitle": "Verity Mobile successfully installed.",
				"body": "The Verity Mobile App is available on iOS and Android.",
				"win": "Download the Verity Mobile App for iOS.",
				"mac": "Download the Verity Mobile App for Android.",
				"winButton": "Download for Android",
				"macButton": "Download for iOS"
			},
			"2": {
				"incompleteTitle": "Launch the App to Take Your Assessment",
				"completeTitle": "You’re all set! Once you’ve launched the app, log in to your Learning Management System and access your assessment within your course."
			},
			"stillQuestion": "Still have questions? Click here to go to the",
			"help": "Help Center"
		},
		"inMobile": {
			"title": "Is This Your First Time Using YuJa Verity Mobile?",
			"title1": "Is This Your First Time Using",
			"title2": "YuJa Verity Mobile?",
			"subtitle": "Follow the steps below to take your assessment.",
			"1": {
				"incompleteTitle": "Download the Verity Mobile App",
				"completeTitle": "The Verity Mobile app has been successfully installed.",
				"body": "The Verity mobile app is available on iOS and Android.",
				"win": "GET IN ON",
				"mac": "Download on the",
				"winButton": "Google Play",
				"macButton": "App Store"
			},
			"2": {
				"incompleteTitle": "Launch the App to Take Your Assessment",
				"completeTitle": "Launch the App to Take Your Assessment",
				"body": "You’re all set! Once you’ve launched the app, log in to your Learning Management System and access your assessment within your course. "
			},
			"stillQuestion": "Still have questions? Click here to go to the",
			"help": "Help Center"
		}
	},
	"instituteConfig": {
		"components": {
			"uploadAgreementTSX": {
				"uploadSucceed": "Upload Succeeded",
				"uploadFail": "Upload failed. Please try again.",
				"examAgree": "Exam Agreement",
				"current": "Current:",
				"upload": "Upload:",
				"submit": "Submit"
			}
		},
		"instituteConfigTSX": {
			"title": "Institution Report",
			"viewReport": "View Institution Report"
		}
	},
	"instructor": {
		"components": {
			"reports": {
				"title": "Assessment Severity Chart",
				"description": "View the number of flagged test-takers for the assessment.",
				"lastUpdated": "Last updated:",
				"never": "Never",
				"refresh": "Refresh",
				"date": "Date: ",
				"severe": "Severe",
				"major": "Major",
				"minor": "Minor",
				"noFlags": "No Flags",
				"testTaker": "Test-Taker",
				"severityLevel": "Severity Levels",
				"noSeverityData": "No Severity Data Available",
				"attempts": "Attempts",
				"month": "Month",
				"typeTitle": {
					"institution": "Institution Report",
					"course": "Course Report",
					"assessment": "Assessment Report",
					"usage": "Usage Report"
				},
				"typeDesc": {
					"institution": "A summary of your institution's overall Verity usage.",
					"course": "A summary of your course's overall Verity usage.",
					"assessment": "A summary of your assessment's overall Verity usage."
				},
				"ariaLabels": {
					"calendarStartInput": "Filter start date, enter date",
					"calendarEndInput": "Filter end date, enter date",
					"calendarStartDialog": "Select start date for filter",
					"calendarEndDialog": "Select end date for filter",
					"usageReportChart": "Usage Report Chart"
				},
				"integrity": {
					"breakdown": {
						"title": "Integrity Score Breakdown",
						"scoreScale": "Score scale",
						"scoreScaleDesc": "0-100. Higher means fewer integrity concerns.",
						"highRiskRange": "High risk 0-49",
						"thresholdRange": "Threshold 50-69",
						"goodRange": "Good 70-100",
						"belowThresholdNote": "Below 70 requires review.",
						"highRisk": "High Risk",
						"atThreshold": "At Threshold",
						"good": "Good",
						"howCalculated": "How is the score calculated?",
						"howCalculatedDesc": "Every attempt starts at 100 points. Each flag lowers the score — more serious flags cost more points.",
						"minorFlag": "Minor flag",
						"minorPoints": "-1 pt each",
						"minorDesc": "Score stays in the 70-99 range with only minor flags.",
						"majorFlag": "Major flag",
						"majorPoints": "-2 pt each",
						"majorDesc": "Score drops into the 30-68 range once a major flag occurs.",
						"severeFlag": "Severe flag",
						"severePoints": "-5 pt each",
						"severeDesc": "Score drops into the 0-25 range once a severe flag occurs."
					},
					"topEventTypes": {
						"title": "Top event types",
						"totalEvents": "{{count}} total events",
						"footnote": "Showing the top 5 categories.",
						"noData": "No flagged events in this period."
					},
					"tabs": {
						"overview": "Overview",
						"trendAnalytics": "Trend & Analytics",
						"attempts": "Attempts",
						"analytics": "Analytics",
						"flagAnalysis": "Flag Analysis",
						"aiSummary": "AI Summary"
					},
					"institutionView": {
						"courseAnalytics": {
							"title": "Courses",
							"description": "Every course proctored in this period. Select a row to open its course report.",
							"courseName": "Course Name",
							"lmsCourseId": "LMS Course ID",
							"numberOfStudents": "Test-takers",
							"numberOfAssessments": "Assessments",
							"integrityScore": "Integrity Score"
						}
					},
					"courseView": {
						"proctoringSessions": {
							"title": "Proctoring sessions to review",
							"description": "{{count}} proctoring sessions across every assessment in this course.",
							"testTaker": "Test-taker",
							"assessment": "Assessment",
							"attemptNumber": "Attempt",
							"integrityScore": "Integrity score",
							"searchPlaceholder": "Search test-taker or assessment",
							"noResults": "No proctoring sessions found."
						},
						"assessmentAnalytics": {
							"title": "Assessments",
							"description": "View the assessments created for this course, and select an assessment to review the results.",
							"assessment": "Assessment",
							"testTakers": "Test-Takers",
							"flaggedEvents": "Flagged Events",
							"integrityScore": "Integrity Score",
							"action": "Action",
							"searchByAssessmentName": "Search by assessment name",
							"noAssessment": "No assessments found"
						}
					},
					"assessmentView": {
						"testTakerAnalytics": {
							"title": "Test-taker attempts",
							"description": "View individual test-taker performance and flagged events for this assessment.",
							"testTaker": "Test-Taker",
							"attempts": "Attempts",
							"status": "Status",
							"startDate": "Start Date",
							"integrityScore": "Integrity Score",
							"action": "Action",
							"searchByTestTakerName": "Search by test-taker name",
							"noTestTaker": "No Test-Takers Found",
							"noSessionsFound": "No proctoring sessions found for this test-taker.",
							"close": "Close"
						},
						"classStands": {
							"title": "Where the class stands",
							"severe": "Test-takers flagged as severe",
							"major": "Test-takers flagged as major",
							"minor": "Test-takers flagged as minor",
							"none": "Test-takers with no flags",
							"testTaker": "test-taker",
							"testTakers": "test-takers",
							"noData": "No test takers in this period."
						}
					},
					"flagAnalytics": {
						"title": "Flag types",
						"description": "Every flag category raised in this period, with its share of total volume and period-over-period movement.",
						"restrictionType": "Restriction Type",
						"anomalyDescription": "Description",
						"flagType": "Flag type",
						"occurrence": "Occurrences",
						"percentOfTotal": "% of total",
						"totalFlaggedEvents": "All Flagged Events",
						"severity": "Severity",
						"trend": "Trend",
						"searchFlagType": "Search flag type",
						"severityOverTime": "Flags by severity over time",
						"issuesFlagged": "Issues flagged",
						"noResults": "No flagged events found"
					},
					"aiSummary": {
						"institution": {
							"title": "Generate Institution Integrity Summary",
							"description": "Create an AI summary of your institution to view key analytics, insights, and overall trends.",
							"subAreasOfImprovement": "Test-takers: ",
							"subAreasForImprovement": "Courses for Improvement"
						},
						"course": {
							"title": "Generate Course Integrity Summary",
							"description": "Create an AI summary of your course to view key analytics, insights, and overall trends.",
							"subAreasOfImprovement": "Test-takers: ",
							"subAreasForImprovement": "Assessments for Improvement"
						},
						"assessment": {
							"title": "Generate Assessment Integrity Summary",
							"description": "Create an AI summary of your assessment to view key analytics, insights, and overall trends.",
							"subAreasOfImprovement": "Attempts: ",
							"subAreasForImprovement": "Test-takers for Improvement"
						},
						"integrityScore": "Integrity Score:",
						"noAreaOfImprovement": "No areas of improvement were identified."
					}
				},
				"canvas": {
					"title": "Overview of Assessment Attempts",
					"description": "Track integrity scores over time to identify trends and measure overall performance.",
					"noMethod": "Select a method to view attempts",
					"allMethodsLabel": "All Methods",
					"integrityScoreLabel": "Integrity Score",
					"automatedLabel": "Automated Proctoring",
					"liveProctoringLabel": "Live Proctoring",
					"liveCheckInLabel": "Live Check-In",
					"srCanvasTitle": "Results of assessment attempts by month and method. ",
					"srCanvasSubtitle": "Showing results for: {{methods}}: ",
					"attemptsForLabel_one": "{{count}} attempt for {{label}}",
					"attemptsForLabel_other": "{{count}} attempts for {{label}}",
					"zeroAttempts": "Zero total attempts",
					"monthSummary": "{{month}}: {{breakdown}}. ",
					"numAssessment_one": "{{count}} assessment",
					"numAssessment_other": "{{count}} assessments",
					"method": "Method",
					"tabs": {
						"graph": "Graph",
						"table": "Table"
					}
				},
				"exportModal": {
					"title": "Export Report",
					"buttons": {
						"openModal": "Export Report",
						"export": "Export",
						"cancel": "Cancel"
					},
					"headers": {
						"export": "Export by:",
						"format": "Format:",
						"email": "Email:",
						"filter": "Filter:"
					},
					"exportRadio": {
						"download": "Direct Download",
						"email": "Email Link"
					},
					"formatRadio": {
						"json": "JSON",
						"csv": "CSV",
						"excel": "Excel"
					},
					"emailPlaceHolder": "Enter email here",
					"descriptionNoDate": "Choose how you want to export your report.",
					"descriptionWithDate": "Choose how you want to export your report and select a preferred date range for it.",
					"errors": {
						"historicalData": "Error fetching historical data",
						"invalidEmail": "Please enter a valid email",
						"emptyEmail": "Email cannot be empty!",
						"fetchingData": "Error getting report data",
						"downloadFail": "Failed to download file",
						"emailAddressRequired": "Email address is required",
						"emailFail": "Failed to send email"
					},
					"downloadSuccess": "The report has been successfully downloaded.",
					"emailSuccess": "The report has been successfully emailed.",
					"currentDateRange": "Current Date Range",
					"specificDateRange": "Historical data for {{year}}",
					"dateRange": "Date Range: {{startMonthYear}} - {{endMonthYear}}"
				},
				"stats": {
					"cumulative": {
						"title": "Cumulative Score",
						"scoreAndFlags": {
							"avgIntegrityScore": "Average Integrity Score",
							"totalFlaggedEvents": "Total Flagged Events",
							"severe": "Severe Flags",
							"major": "Major Flags",
							"minor": "Minor Flags"
						}
					},
					"totals": {
						"title": "Overall Totals",
						"assessment": {
							"avgIntegrityScore": "Average Integrity Score",
							"totalTestTakers": "Total Test-Takers Proctored",
							"numAttempts": "Total Number of Attempts",
							"totalFlaggedEvents": "Total Flagged Events"
						},
						"course": {
							"avgIntegrityScore": "Average Integrity Score",
							"numAttempts": "Total Number of Attempts",
							"avgAttempts": "Average Attempts per Month",
							"totalAssessments": "Total Assessments Proctored",
							"totalTestTakers": "Total Test-Takers Proctored"
						},
						"institution": {
							"avgIntegrityScore": "Average Integrity Score",
							"totalTestTakers": "Total Test-Takers Proctored",
							"totalAssessments": "Total Assessments Proctored",
							"totalFlaggedEvents": "Total Flagged Events"
						}
					},
					"table": {
						"course": {
							"title": "Assessment Analytics",
							"assessmentName": "Assessment Name ",
							"testTaker": "Test-Takers Proctored",
							"flaggedEvents": "Flagged Events",
							"avgIntegrityScore": "Average Integrity Score"
						},
						"institution": {
							"title": "Course Analytics",
							"lmsCourseId": "LMS Course ID",
							"courseName": "Course Name",
							"testTakers": "Test-Takers Proctored",
							"assessmentsProctored": "Assessments Proctored",
							"avgIntegrityScore": "Average Integrity Score"
						},
						"assessment": {
							"title": "Test-Taker Analytics",
							"userID": "User ID",
							"testTaker": "Test-Taker",
							"attempts": "Attempts",
							"status": "Status",
							"startDate": "Start Date",
							"avgIntegrityScore": "Average Integrity Score",
							"unknownStatus": "Unavailable",
							"unknownName": "Unknown Test-Taker"
						}
					},
					"filters": {
						"startMonth": "Start Month",
						"startYear": "Start Year",
						"endMonth": "End Month",
						"endYear": "End Year",
						"subAccount": "Sub Account",
						"noSubAccount": "none",
						"filter": "Filter",
						"value": "Value"
					}
				},
				"usage": {
					"title": "Verity's Monthly Usage Reports",
					"switchtoAdmin": "Switch to Admin View",
					"switchtoAM": "Switch to Account Manager View",
					"getReportsFailed": "Cannot fetch historical usage reports, please check back later",
					"searchReportPlaceHolder": "Search by month and year",
					"reportTitlePlaceholder": "Verity’s Monthly Report",
					"reportImagePlaceholder": "Monthly Report",
					"viewReport": "View Report",
					"download": "Download",
					"amBannerTitle": "CONFIDENTIAL (DO NOT SHARE)",
					"amBannerDesc": "This report is for internal use only. Please do not share any information in this report with clients.",
					"noResult": {
						"noEmailDataTitle": "Monthly Usage Reports Will Appear Here",
						"noEmailDataDesc": "Verity will generate monthly reports that highlight your proctoring usage.",
						"noMatchingResultTitle": "No Matching Results",
						"noMatchingResultDateDesc": "Try adjusting your filters or date range to find what you are looking for.",
						"noMatchingResultSearchDesc": "Try broadening your search criteria to find what you are looking for."
					}
				},
				"summaryCards": {
					"integrityScore": "Integrity Score",
					"totalFlaggedEvents": "Total Flagged Events",
					"totalAssessmentsProctored": "Total Assessments Proctored",
					"totalLiveAttempts": "Total Live Attempts",
					"totalAttempts": "Total Number of Attempts",
					"avgAttemptsPerMonth": "Average Attempts per Month",
					"totalLiveHoursProctored": "Total Live Hours Proctored",
					"totalUsersProctored": "Total Test-Takers Proctored",
					"totalHoursProctored": "Total Hours Proctored",
					"avgProctorHoursPerMonth": "Average Hours Proctored per Month",
					"metricChange": "{{metric}} in {{date}}"
				},
				"severityChart": {
					"title": "Severity Chart",
					"viewHighestFlag": "View the highest flag level detected for assessments in the course.",
					"severityLevels": "Severity Levels",
					"noSeverityData": "No Severity Data Available"
				},
				"completionChart": {
					"title": "Assessment Completion",
					"viewProgress": "View the progress of test-takers as they complete their assessment.",
					"completionLevels": "Completion Levels",
					"complete": "Complete",
					"incomplete": "Incomplete",
					"unavailable": "Complete",
					"pending": "Incomplete",
					"error": "Error",
					"noCompletionData": "No Completion Data Available"
				},
				"course": {
					"assessmentName": "Assessment Name",
					"testTakersProctored": "Test-Takers Proctored",
					"flaggedEvents": "Flagged Events",
					"flagLevel": "Flag Level",
					"viewReport": "View Report",
					"viewReportAriaLabel": "View report for {{quizName}}",
					"searchByAssessmentName": "Search by assessment name",
					"noResultsFound": "No Results Found",
					"assessmentTableHeader": "Assessment Analytics",
					"assessmentTableDescription": "View the assessments created for this course, and select an assessment to review the results.",
					"fetchReportToast": "The report is taking longer than expected to generate. Please check back in an hour.",
					"unknownCourse": "Unknown Course",
					"switchCourse": "Switch Course"
				}
			},
			"quizResultTSX": {
				"numFlag": "Number of Flagged Test-Takers",
				"numNoFlag": "Number of Non-Flagged Test-Takers",
				"quizTake": "Assessments taken",
				"flagLvl": "Flag Level",
				"quizName": "Assessment Name",
				"dateCreated": "Date Created",
				"testTaker": "Test Takers",
				"submit": "Test-Takers Started",
				"submitToday": "Test-Takers Submitted This Day",
				"incomplete": "Test-Takers Not Started",
				"noSubmit": "Did Not Submit This Day",
				"totalSub": "Total Attempts",
				"totalSubToday": "Total Submissions This Day",
				"live": "Live Sessions",
				"liveToday": "Live Sessions This Day",
				"flag": "Flag Breakdown",
				"close": "Close",
				"view": "View",
				"description": "Breakdown of how learners fall into each of the flag levels.",
				"learn": "Learn More",
				"assessments": "Assessments",
				"viewNum": "View how many proctored assessments were submitted and the proctored statistics results.",
				"errorParse": "Error While Parsing Data.",
				"locateError": "Could Not Locate YuJa Verity Extension.",
				"noResult": "No Results Found"
			},
			"studentLiveExperienceTSX": {
				"quizName": "Assessment Name",
				"sessionName": "Session Name",
				"sessionDate": "Session Date",
				"sessionTime": "Session Start Time",
				"attendance": "Attendance",
				"studentName": "Test-Taker Name",
				"sessionRegi": "Sessions Registered",
				"sessionJoined": "Sessions Joined",
				"viewSession": "View Sessions",
				"close": "Close",
				"view": "View",
				"title": "Test-Takers' Live Experience",
				"subtitle": "View the live sessions that test-takers have registered for.",
				"errorParse": "Error While Parsing Data.",
				"locateError": "Could Not Locate YuJa Verity Extension.",
				"noResult": "No Results Found."
			},
			"studentProcExperienceTSX": {
				"quizzes": "Assessments",
				"score": "Score",
				"percentage": "Percentage",
				"attendance": "Attendance",
				"flagLvl": "Flag Level",
				"none": "Info (",
				"minor": "Minor (",
				"major": "Major (",
				"severe": "Severe (",
				"na": "N/A",
				"studentName": "Test-Taker Name",
				"status": "Status",
				"overallG": "Overall Grade",
				"viewDetail": "View Details",
				"close": "Close",
				"view": "View",
				"title": "Test-Takers' Proctoring Experience",
				"subtitle": "View the Proctoring sessions that test-takers have registered for.",
				"errorParse": "Error While Parsing Data.",
				"locateError": "Could Not Locate YuJa Verity Extension.",
				"noResult": "No Results Found."
			},
			"noSessionPageTSX": {
				"title": "No Report Available",
				"description": "Reports will be generated for proctored assessments once they are created."
			}
		}
	},
	"live": {
		"registerTSX": {
			"title": "Verity Live Registration",
			"description": "Select a session below to register for {{assessmentName}}. Only one session can be booked at a time.",
			"placeholder": "Search by session name",
			"defaultName": "live assignment",
			"cancel": "Cancel",
			"footer": {
				"pleaseRegister": "Please select a session to register",
				"alreadyRegistered": "You are Already Registered",
				"selected": "Selected: ",
				"registerNow": "Register Now",
				"updateRegistration": "Update Registration",
				"liveSessionDate": "{{startDate}} {{startTime}} - {{endTime}}",
				"liveSessionMultiDay": "{{startDate}} {{startTime}} - {{endDate}} {{endTime}}"
			},
			"multipleDates": "{{startDate}} - {{endDate}}",
			"sessionTime": "{{startTime}} - {{endTime}}",
			"capacity": "{{numRegistered}}/{{capacity}} filled",
			"registrationBadge": "Registration closes on {{endMonth}} {{endDate}} at {{endTime}}",
			"registrationBadgeWithStartTime": "Registration: {{startMonth}} {{startDate}} {{startTime}} - {{endMonth}} {{endDate}} {{endTime}}",
			"tooltip": {
				"closed": "The registration window for this session has ended.",
				"full": "All slots for this session are filled. You can’t register at this time.",
				"upcoming": "Registration for this session hasn’t opened yet. You’ll be able to sign up once the window begins."
			},
			"badge": {
				"full": "Full",
				"closed": "Registration Closed",
				"upcoming": "Upcoming",
				"registered": "Registered"
			},
			"filter": {
				"status": "Status",
				"startTime": "Session Start Time",
				"full": "Full",
				"closed": "Registration Closed",
				"upcoming": "Upcoming",
				"registered": "Registered",
				"notRegistered": "Not Registered",
				"startAriaLabel": "Select the starting date for session start time.",
				"endAriaLabel": "Select the ending date for session start time."
			},
			"noSessions": {
				"title": "No Sessions Created",
				"description": "Your instructor has not created any sessions for you to register for and join."
			},
			"registrationEnded": {
				"title": "Registration Closed",
				"description": "The registration for all available sessions has closed."
			},
			"allSessionsEnded": {
				"title": "Assessment Has Ended",
				"description": "The live assessment is no longer available to register for and join."
			},
			"errorLoading": {
				"title": "Unable to Retrieve Sessions",
				"description": "Please refresh the page to try again."
			},
			"notRegistered": {
				"title": "Registration Required",
				"description": "Choose a date and time slot to register for “{{assessmentName}}.”"
			},
			"notStarted": {
				"title": "Session Not Started",
				"description": "You can start the “{{assessmentName}}” assessment once the proctor has entered."
			},
			"ended": {
				"title": "Session Ended",
				"description": "Choose a new date and time slot to register for “{{assessmentName}}.”"
			},
			"registerSuccess": "You have successfully registered for {{assessmentName}}.",
			"startsIn": "Session Starts in",
			"hasNotStarted": "Session Has Not Started",
			"waitingRescheduleDescription": "Please come back when your session starts or reschedule to a new time.",
			"waitingNoRescheduleDescription": "Please come back when your session starts.",
			"reschedule": "Modify Registration",
			"save": "Save",
			"confirmRegistrationEnded": "Confirm Registration",
			"confirmRegistrationEndedText": "The registration window for your current session has passed. If you continue, you will not be able to choose it again. Are you sure you want to update your registration?",
			"confirmRegistration": "Confirm Session Change",
			"confirmRegistrationText": "You are about to change your scheduled session from <b>{{oldTime}}</b> to <b>{{newTime}}</b>. Please confirm if you would like to proceed with this update.",
			"updateRegistration": "Confirm Change",
			"noSearchResultsTitle": "No Matching Session Found",
			"noSearchResultsDescription": "Try adjusting your search or filters to find the session you are looking for.",
			"registerError": "You could not be registered for the session. Please try again."
		}
	},
	"portal": {
		"components": {
			"unsavedChangesModal": {
				"title": "Unsaved Changes",
				"description": "Changes you have made will not be saved. Are you sure you want to leave?",
				"cancel": "Cancel",
				"leave": "Leave"
			},
			"trialTermsModal": {
				"title": "Terms of Service",
				"description": "To continue with your trial, please read and agree to our <a>Terms of Service</a>.",
				"learnMoreAriaLabel": "Learn more about the Terms of Service. (Opens in a new tab).",
				"agree": "I Agree"
			},
			"assessmentPage": {
				"createStandAloneQuizDialog": {
					"indexTSX": {
						"closeButtonPreviewAriaLabel": "Close preview",
						"emptyTable": "Invalid Entries",
						"close": "Close",
						"descriptionBox": "Please ensure that at least one test-taker is added and that all emails provided are valid.",
						"back": "Back",
						"next": "Next",
						"submit": "Submit",
						"generalInformation": "General Information",
						"additionalInformation": "Additional Information",
						"quizName": "Assessment Title",
						"quizNamePrompt": "Enter assessment title",
						"dueDate": "Due Date",
						"dueDateDescription": "The date and time by which this assessment must be submitted.",
						"addiInstru": "Additional Instructions",
						"addiIntruLabel": "Enter additional instructions for test-takers",
						"viewPreviewTitle": "Preview Assessment Details",
						"viewPreviewDescription": "See how the assessment details will appear on the assessment starting page.",
						"viewPreviewButton": "Preview",
						"createInvi": "Create and Invite",
						"createAssessment": "Create Assessment",
						"createAssessmentDescription": "Choose the type of assessment you would like to proctor.",
						"createStandalone": "Create Standalone Assessment",
						"quizDetail": "Assessment Details",
						"addInvi": "Invite Test-Takers",
						"createInstruc": "Create Instructions",
						"editSettings": "Edit Settings",
						"email": "Email",
						"firstName": "First Name",
						"lastName": "Last Name",
						"deleting": "Deleting incomplete standalone assessment...",
						"deleteFailed": "Failed to delete incomplete standalone assessment.",
						"deleteSuccess": "The incomplete standalone assessment has been deleted.",
						"addSuccessBeforeInvites": "The standalone assessment has been created successfully. Please confirm the assessment's proctoring options before email invitations can be sent to test-takers.",
						"addSuccess": "The standalone assessment has been created successfully.",
						"confirm": "Confirm",
						"addFailed": "Failed to create the standalone assessment. Please try again.",
						"partialSaveFail": "The standalone assessment was created, but some settings failed to save. Edit the assessment to try again.",
						"payloadTooBig": "Assessment Details section exceeds the maximum size. Please try to reduce the size of images if applicable.",
						"noDueDate": "Please select a due date and try again.",
						"emailInstructionsTitle": "Email Instructions",
						"emailInstructions": " Provide test-takers with instructions before they start the assessment.",
						"emailInstructionsPlaceHolder": "Enter email instructions",
						"assessmentDetails": "Assessment Details",
						"assessmentDetailsDescription": "These details will be shown to the test-takers once they start the assessment. Modify the template in the editor to get started.",
						"backButtonAriaLabel": "Go back one step",
						"inviteTestTakerDisabledTooltip": "Please add at least one test-taker."
					},
					"standaloneQuizOptionsTSX": {
						"selectStu": "Select Test-Takers",
						"studentList": "Test-Taker List",
						"executeList": "Exempted Test-Taker List",
						"searchName": "Search test-taker name",
						"save": "Save",
						"cancel": "Cancel",
						"procSetting": "Assessment Restrictions",
						"selectOption": "Please select setting options for test-takers during their examinations.",
						"saveSettings": "Save these new proctoring settings as a new profile.",
						"iUnderstand": "I understand, I will not be able to change settings once the exam has started.",
						"mode": "Proctoring Platform",
						"moderateQuiz": "Exemptions",
						"selectStudent": "Please select the test-takers that you wish to exclude proctor requirements.",
						"studentsAdd": "Test-Taker(s) added.",
						"findStudent": "Find Test-Takers",
						"cancelButtonAriaLabel": "Go back to Create Assessments page"
					},
					"inviteeInfoTableTSX": {
						"edit": "Edit",
						"delete": "Delete",
						"failLoadRow": "Failed to Update Row",
						"close": "Close",
						"editRow": "Edit Test-Taker",
						"save": "Save",
						"enter": "Enter ",
						"formatError": "CSV Format Error",
						"csvParseConfirmTitle": "Upload CSV",
						"csvParseConfirmText": "Uploading the CSV file <strong>{{fileName}}</strong> will replace the test-taker information that you have entered. Are you sure you want to continue?",
						"csvParseButtonText": "Replace with CSV",
						"manualAddConfirmTitle": "Manually Add Test-Takers",
						"manualAddConfirmText": "Manually adding test-takers will replace the test-taker information that you have uploaded. Are you sure you want to continue?",
						"manualParseButtonText": "Replace Manually",
						"resolveError": "Please resolve the following errors in the CSV file:",
						"row": "Row ",
						"missHeader": "Missing Header(s): ",
						"browse": "Browse File",
						"action": "Action",
						"manualTitle": "Invite Test Takers Manually to Take the Assessment",
						"manualDesc": "Start adding test-takers who will take the assessment by entering their details.",
						"addRow": "Add Test-Taker",
						"noEmpty": " cannot be empty!",
						"alreadyExist": " already exist!",
						"manualSelect": "Manually Add Test-Takers",
						"downloadCSVTemplate": "Upload a CSV file with the required fields: User Email, First Name, and Last Name. You can download a sample template here: <a>Sample CSV Template (1KB)</a>.",
						"removeCSV": "Remove CSV",
						"dragAndDropCSV": "Drag and Drop CSV",
						"bulkUpload": "Bulk Upload Test-Takers",
						"saveIconDisabled": "Please fix the errors before saving.",
						"saveIconEmpty": "Please add details before saving.",
						"fieldRequired": "This field is required",
						"enterInvitees": "Enter the details for the test-takers you want to invite or upload a CSV file to bulk upload their information.",
						"fileTypeErrorToast": "The test-takers could not be uploaded. Please upload a CSV file and try again.",
						"csvUploadedToast": "The test-takers have been successfully uploaded. Review their details before continuing.",
						"csvRemovedToast": "The uploaded CSV file has been successfully removed.",
						"ariaLabels": {
							"cancelIcon": "Cancel edits",
							"saveIcon": "Save edits",
							"actionsButton": "More actions"
						}
					},
					"standaloneEmailSuccessModal": {
						"title": "Standalone Assessment Created and Invitations Sent",
						"description": "Your standalone assessment has been successfully created, and invitations have been sent to the test-takers you added for this assessment."
					},
					"errors": {
						"invalidEmail": "Invalid email address",
						"emptyEmail": "Email is required",
						"emptyFirstName": "First name is required",
						"nameNoEmpty": "Assessment name cannot be empty!",
						"dateNoEmpty": "Due date cannot be empty!",
						"incompleteDate": "Incomplete date!",
						"datePassed": "Please choose a due date that has not passed."
					}
				},
				"createThirdPartyQuizDialogTSX": {
					"titleBox": "Provide the third-party assessment name, URL and password.",
					"quizName": "Assessment Title",
					"quizNamePlaceholder": "Enter assessment title",
					"urlTitle": "Third-Party Assessment URL",
					"urlDesc": "Enter the URL of the third-party platform where the assessment will be hosted.",
					"urlPlaceholder": "Enter third-party assessment URL",
					"passwordRadioTitle": "Password-Protected Assessment",
					"passwordRadioDesc": "A password is required for your third-party assessment.",
					"yes": "Yes",
					"no": "No",
					"noPasswordWarning": "<b>Important</b>: If no password is set, test-takers may bypass Verity proctoring and access the assessment directly. We <b>highly recommend</b> setting up a password for your assessment to ensure a secure proctored assessment.",
					"passwordTitle": "Assessment Password",
					"passwordDesc": "Enter the <b>exact password</b> created in your third-party assessment. Verity will auto-fill it for test-takers to access their assessments.",
					"passwordPlaceholder": "Enter assessment password",
					"creatingTP": "Creating third-party assessment...",
					"addSuccess": "The third-party assessment has been added successfully.",
					"createFail": "Failed to create the third-party assessment. Please try again.",
					"partialSaveFail": "The third-party assessment was created, but some settings failed to save. Edit the assessment to try again.",
					"createTP": "Create Third-Party Assessment"
				},
				"assessmentsPageHelperTSX": {
					"question1Title": "Disable Copying",
					"question1Description": "Try copying this text and pasting in the box below. Answer \"yes\" without quotes if copying to clipboard is disabled?",
					"question2Title": "New Tab",
					"question2Description": "Try opening a new tab. Answer \"yes\" without quotes if opening a new tab is disabled?",
					"question3Title": "Sample Question",
					"quizPubliFail": "Assessment publication failed",
					"quizCreaFail": "The practice assessment cannot be created. Please check your internet connection and try again.",
					"apiReturnFail": "Assessment Deletion API Return Value failed",
					"nmApiReturnFail": "Deletion API Return Value failed"
				},
				"editQuizOptionPopupTSX": {
					"title": "Setup Proctoring",
					"close": "Close",
					"save": "Apply",
					"saveAsProfile": "Save as Profile",
					"applyMessage": "Proctor settings have been successfully updated.",
					"applyFailedMessage": "Failed to apply proctor settings to the assessment.",
					"applyingChanges": "Applying your proctor settings...",
					"method": "Method",
					"platform": "Platform",
					"configuration": "Configuration",
					"accommodations": "Accommodations",
					"confirmation": "Confirmation",
					"exemptBanner": "Please remember that exempted test-takers are still required to install the Verity Browser Extension or Lockdown App to take the assessment."
				},
				"practiceQuizCompTSX": {
					"createAss": "Creating assessment...",
					"noSupportLms": "Sorry, Verity does not support the Learning Management System being used.",
					"noFeature": "The practice assessment feature has not been set up by your institution's admin.",
					"success": "A practice assessment has been successfully created.",
					"popUp": "Please enable pop-ups in your browser.",
					"auth": "Authentication failed. Please try again. If you receive this error again, please contact YuJa support for help.",
					"lms": "LMS origin undefined",
					"createPracAss": "Create Practice Assessment",
					"quizCreateFail": "The practice assessment cannot be created. Please check your internet connection and try again."
				}
			},
			"liveProctoring": {
				"indexTSX": {
					"liveAssessments": "Live Assessment Hub",
					"tab": {
						"active": "Active",
						"upcoming": "Upcoming",
						"completed": "Completed"
					},
					"tabDescription": {
						"active": " Active assessments are those that have started, allowing proctors to join and monitor them.",
						"upcoming": "Upcoming assessments are those that are ready to begin at their scheduled time.",
						"completed": "Completed assessments have been proctored and are no longer available to join."
					},
					"searchBy": "Search by assessment or session name",
					"loadingFailed": {
						"title": "Could Not Load Sessions",
						"description": "Please refresh the page to try again."
					},
					"noSessions": {
						"active": {
							"title": "No Assessment Available",
							"description": "There are no active live assessments."
						},
						"upcoming": {
							"title": "No Assessment Available",
							"description": "There are no upcoming live assessments."
						},
						"completed": {
							"title": "No Assessment Available",
							"description": "There are no completed live assessments."
						}
					},
					"noResults": {
						"title": "No Results Found",
						"description": "Try adjusting your search criteria."
					},
					"expand": "More details",
					"collapse": "Hide details",
					"actions": "More actions",
					"joinSession": "Join Session",
					"cannotJoin": "You are not assigned to join this session.",
					"joining": "Joining...",
					"joinFailError": "Failed to join the live session. Please try again.",
					"timeRemaining": "Time Remaining",
					"activeStudents": "Active Test-Takers",
					"activeProctors": "Active Proctors",
					"loading": "Loading",
					"endSession": "End Session"
				},
				"liveHelperTSX": {
					"1": "January",
					"2": "February",
					"3": "March",
					"4": "April",
					"5": "May",
					"6": "June",
					"7": "July",
					"8": "August",
					"9": "September",
					"10": "October",
					"11": "November",
					"12": "December",
					"mon": "Monday",
					"tue": "Tuesday",
					"wed": "Wednesday",
					"thu": "Thursday",
					"fri": "Friday",
					"sat": "Saturday",
					"sun": "Sunday"
				},
				"liveInstructorCompsTSX": {
					"activeS": "Active Sessions",
					"noA": "There are no active sessions",
					"upcomingS": "Upcoming Sessions",
					"noU": "You have no upcoming sessions",
					"pendingS": "Pending Sessions",
					"noP": "You have no pending sessions",
					"pastS": "Past Sessions",
					"noPast": "No past sessions available",
					"clickCreate": "Click Create Time Slots to add human proctors to Live Proctored assessments",
					"createSlot": "Create Time Slots",
					"name": "Name",
					"date": "Date",
					"duration": "Duration",
					"action": "Action",
					"viewAll": "View All",
					"view": "View",
					"join": "Join",
					"start": "Start",
					"end": "End",
					"edit": "Edit",
					"delete": "Delete",
					"procRole": "Proctor Roles",
					"procAvail": "Proctors available for the course",
					"email": "Email",
					"viewOccur": "View when upcoming human proctor sessions will occur",
					"procGroup": "Proctor Groups",
					"groupAvail": "Proctor groups available for the course",
					"mo": "Mo",
					"tu": "Tu",
					"we": "We",
					"th": "Th",
					"fr": "Fr",
					"sa": "Sa",
					"su": "Su"
				},
				"liveStuCompsTSX": {
					"stuDashboard": "Test-Taker Dashboard",
					"upcomingA": "Upcoming Assessments",
					"firstTime": "First Time Setup",
					"firstDescription": "To take a proctored assessment for the first time, follow this guide to get started.",
					"help": "Help Center",
					"helpHere": "We are here to help and offer all users with 24/7 live support.",
					"contact": "Contact Us",
					"supportP": "Support Page",
					"name": "Name",
					"liveA": "Live Assessment",
					"dur": "Duration",
					"num": "Available Sessions",
					"action": "Action",
					"selectT": "Time Slots",
					"changeT": "Time Slots",
					"anotherT": "Time Slots",
					"noA": "No assessments are available at the moment"
				},
				"liveStuModalTSX": {
					"date": "Date: ",
					"dur": "Duration: ",
					"days": "days",
					"hours": "hours",
					"spotAvail": "Available Spots: ",
					"spots": " Spots",
					"registered": " Session registered",
					"aboutBegin": "The session is about to begin. If you intend to take your assessment now, kindly select it within the next",
					"aboutBeginMin": "minute(s).",
					"started": "Session has started",
					"selectS": "You have selected the following live-proctored session.",
					"assessmentN": "Assessment Name: ",
					"procG": "Proctor group: ",
					"proctor": "Proctor: ",
					"selectLiveModal": "Select Live Proctored Time Slots",
					"back": "Back",
					"proceed": "Proceed",
					"applyP": "Apply and Proceed",
					"exit": "Exit",
					"selectT": "Select Time Slot",
					"confirm": "Confirmation",
					"working": "Working...",
					"saved": "Saved.",
					"retry": "Error while saving! Please try again."
				}
			},
			"livePopIn": {
				"livePopInPageTSX": {
					"livePopInTitle": "Live Check-In Proctoring",
					"description": "View a list of test-takers currently participating in assessments and access a recording of their live session to review flag levels.",
					"todayDate": "Today’s Date:",
					"selectCourse": "Select Course",
					"searchCourse": "Search by Course",
					"courseCode": "Course Code",
					"courseName": "Course Name",
					"coursesError": "An error occurred. Please try again.",
					"noCourses": "No courses were found",
					"noName": "[No Name]",
					"noCode": "[No Code]",
					"searchTestTaker": "Search by test-taker",
					"filter": "Filter",
					"reportStatus": "Report Status",
					"analyzed": "Analyzed",
					"unanalyzed": "Unanalyzed",
					"severe": "Severe",
					"major": "Major",
					"minor": "Minor",
					"cancel": "Cancel",
					"apply": "Apply",
					"testTaker": "Test-Taker",
					"assessment": "Assessment",
					"startDate": "Start Date",
					"flagLevels": "Flag Levels",
					"actions": "Actions",
					"profilePicture": "profile picture",
					"idVerification": "ID Verification",
					"roomScan": "Room Scan",
					"close": "Close",
					"analyze": "Analyze",
					"resolveFlagged": "Resolve Flagged Issue",
					"livePopIn": "Live Check-In",
					"configuration": "Configuration",
					"noSessions": "No Active Sessions",
					"sessionsWillAppear": "Live Check-in sessions will appear here once they begin.",
					"noResults": "No Results Found",
					"viewConfigSettings": "View Configuration Settings",
					"noProfileSelected": "No profile selected",
					"errorLoading": "Live check-in sessions could not be loaded. Please refresh the page to try again."
				}
			},
			"settings": {
				"saveSuccess": "Verity settings have been successfully saved. You can close this page.",
				"saveFailure": "Unable to save Verity settings",
				"back": "Back",
				"confirm": "Confirm",
				"next": "Next",
				"saveAsProfile": "Save as Profile",
				"instituteAgreementInput": {
					"indexTSX": {
						"pdf": "Drag and drop a PDF file",
						"upload": "Upload PDF",
						"reUpload": "Re-Upload",
						"delete": "Delete",
						"invalid": "Invalid file.",
						"wrong": "Wrong type selected.",
						"tooLarge": "The uploaded Policy Statement PDF file is too large",
						"smaller": ". Please upload a smaller PDF file."
					}
				},
				"instituteGlobalProfile": {
					"profileTableTSX": {
						"name": "Name",
						"scope": "Profile Scope",
						"proctorPlatforms": "Proctoring Platforms",
						"actions": "Actions",
						"default": "Default"
					},
					"profileTileGridTSX": {
						"platform": {
							"extension": "Browser Extension",
							"lockdown": "Desktop",
							"mobile": "Mobile",
							"chromeOs": "Chromebook",
							"browser": "Web Browser"
						}
					},
					"profileFilterTSX": {
						"platform": "Platforms",
						"scope": "Profile Scope"
					},
					"indexTSX": {
						"notSave": "Some profile edits could not be saved.",
						"info": "Automated Proctoring profiles will appear in blue, and Lockdown App profiles will appear in purple.",
						"profileManagementDescription": "Create and manage proctoring profiles. Click <supportLink>here</supportLink> to learn more about proctoring profiles.",
						"designatedProfilesDescription": "When enabled, instructors can only use the profiles listed below and cannot use custom profiles.",
						"designatedProfilesRequireInstitution": "Create an institution profile to enable this option.",
						"designatedProfileRequired": "At least one designated profile is needed.",
						"emptyProfile": "No Default Institution-Wide Profile Added",
						"replaceProfile": "Replace Default Profile",
						"replaceProfilePrompt": "You are about to replace the current default institution-wide profile with: {{profile}}.",
						"replaceProfileContinue": "Would you like to continue?",
						"searchPlaceholder": "Search for institution profiles",
						"searchProfiles": "Search profiles",
						"menuItemAriaLabel": "Open for more options",
						"actionsForProfile": "Actions for {{profileName}}",
						"profileDeleteSuccess": "Your profile has been successfully deleted. Click Save Changes to save your updates.",
						"profileCreateSuccess": "\"{{profileName}}\" has been created. Click Save Changes to apply.",
						"delete": "Delete",
						"edit": "Edit",
						"add": "Add",
						"createProfile": "Create Profile",
						"setAsDefault": "Make Default",
						"unsetDefault": "Remove Default",
						"search": "Search",
						"allProfiles": "All Profiles",
						"institution": "Institution",
						"course": "Course",
						"individual": "Individual",
						"noInstProfileCreated": "No Institution-Wide Profiles Created",
						"noProfileFound": "No Profiles Found",
						"newProfilesWillAppearHere": "New Profiles Will Appear Here",
						"noProctoringProfilesYet": "No proctoring profiles yet.",
						"noDesignatedProfilesAvailable": "No designated profiles available",
						"view": "View",
						"remove": "Remove",
						"noInstProfile": "No Designated Institution-Wide Profiles Added",
						"noProfiles": "No profiles",
						"selectProfile": "Select an institution profile"
					},
					"profileBoxTSX": {
						"create": "Create an Institution-Wide Profile",
						"edit": "Edit",
						"delete": "Delete"
					},
					"profileModalsTSX": {
						"edit": "Edit ",
						"setting": " Settings",
						"cancel": "Cancel",
						"update": "Update",
						"select": "Select the mode and settings you would like to be updated.",
						"mode": "Proctoring Platform",
						"procSetting": "Proctoring Configurations",
						"createProfile": "Create an Institution-Wide Profile",
						"create": "Create",
						"delete": "Delete",
						"chooseName": "Enter a profile name and set up the proctoring configurations for your profile.",
						"profileName": "Profile Name",
						"enterName": "Enter profile name",
						"scope": "Profile Scope",
						"institutionScope": "Institution-wide profile",
						"subAccountScope": "{{type}} profile",
						"courseScope": "Course profile",
						"userScope": "Individual profile",
						"selectCourse": "Enter an LMS course ID or course URL for this profile.",
						"enterCourse": "Enter course ID or URL",
						"currentCourse": "This profile will be created for the current course: {{courseId}}.",
						"selectSubAccounts": "Select one or more {{type}} for this profile.",
						"searchSubAccounts": "Search {{type}}",
						"noSubAccounts": "No {{type}} found",
						"deleteProfile": "Delete Profile",
						"deleteText": "Are you sure you want to delete <b>{{profileName}}</b>?",
						"deleteTextInstitution": "Are you sure you want to delete <b>{{profileName}}</b> from the institution profile list?",
						"deleteTextSubAccount": "Are you sure you want to delete <b>{{profileName}}</b> from the {{type}} profile list?",
						"deleteTextCourse": "Are you sure you want to delete <b>{{profileName}}</b> from the course profile list?",
						"deleteTextIndividual": "Are you sure you want to delete <b>{{profileName}}</b> from the individual profile list?",
						"replaceDefaultProfileTitle": "Replace Default Profile",
						"replaceDefaultProfileText": "You are about to replace the current default institution-wide profile with: <b>{{profileName}}</b>.",
						"replaceDefaultProfileContinue": "Would you like to continue?",
						"no": "No",
						"yes": "Yes"
					},
					"createProfileFlow": {
						"formAriaLabel": "Create proctoring profile",
						"title": "Create Profile",
						"description": "Enter a profile name and complete the setup options.",
						"backToProfiles": "Back to Profiles",
						"profileName": "Profile Name",
						"enterProfileName": "Enter profile name",
						"profileDraftName": "Profile Draft: {{date}} – {{time}}",
						"saveProfile": "Save Profile",
						"steps": {
							"profileScope": "Save Location"
						},
						"profileScope": {
							"title": "Choose where this profile is saved",
							"description": "Select the location where you want to save this profile.",
							"institute": {
								"title": "Institution",
								"description": "The proctoring profile will be available to all users across the institution."
							},
							"subAccount": {
								"description": "The proctoring profile will be available to all users within the selected {{type}}."
							},
							"course": {
								"title": "Course",
								"description": "The proctoring profile will be available to all users enrolled in the selected course."
							},
							"user": {
								"title": "Individual",
								"description": "The proctoring profile will only be available to you and cannot be accessed by others."
							},
							"selectSubAccounts": "Select one or more {{type}} for this profile.",
							"searchSubAccounts": "Search {{type}}",
							"noSubAccounts": "No {{type}} found",
							"selectAllSubAccounts": "Select all {{type}}",
							"subAccountName": "{{type}} Name",
							"subAccountId": "{{type}} ID",
							"selectCourse": "Select one course for this profile.",
							"searchCourses": "Search courses",
							"noCourses": "No courses found",
							"courseLoadError": "Courses could not be loaded.",
							"courseId": "Course ID",
							"courseName": "Course Name",
							"currentCourse": "Current course:",
							"selectCourseAriaLabel": "Select course {{courseId}}",
							"selected": "Selected"
						},
						"review": {
							"description": "Review the profile settings before saving.",
							"savedLocation": "Saved Location",
							"editSavedLocation": "Edit saved location",
							"accessInstitution": "Instructors will have access to this profile at the institution level.",
							"accessCourse": "Instructors in {{course}} will have access to this profile.",
							"accessCourseNoName": "Instructors in the selected course will have access to this profile.",
							"accessUser": "Only you can access this proctoring profile.",
							"accessSubAccount": "Instructors will have access to this profile at the <scope>{{type}} level</scope>",
							"assignTo": "Assign to {{type}}"
						}
					}
				},
				"suffix": {
					"IndexTSX": {
						"default": "Default",
						"changeSuffixLabel": "Change Suffix",
						"updateSuffixLabel": "Update Suffix",
						"cancel": "Cancel",
						"none": "None",
						"updateAndsave": "Update and Save",
						"updating": "Updating",
						"finished": "Finished",
						"description": "Append a label to assessment names so test-takers can identify proctored assessments. Only applies to newly created assessments",
						"learnMore": "Learn more",
						"visualizerRequired": "The {{lmsName}}LMS Visualizer is required to update the suffix.",
						"updateFailedMsg": "The suffix could not be updated for all assessments. Please click Retry.",
						"LMSRequireSuffix": "The LMS Visualizer is required to add the suffix. Learn more.",
						"getCoursesFailed": "Failed to get courses.",
						"noCoursesFound": "No courses found.",
						"waitWarningMsg": "Please wait for the process to complete before closing this modal.",
						"retry": "Retry",
						"courseID": "Course ID",
						"courseName": "Course Name",
						"completedAssessments": "Completed Assessments",
						"suffixUpdate": {
							"add": "Select the desired courses if you would like to add the suffix \"({{suffix}})\" to existing proctored assessments.",
							"remove": "Select the desired courses if you would like to remove the suffix \"({{suffix}})\" from existing proctored assessments.",
							"update": "Select the desired courses if you would like to update the suffix from \"({{old}})\" to \"({{new}})\" for existing proctored assessments.",
							"none": "Select the desired courses if you would like to modify existing proctored assessments."
						},
						"suffixStatus": {
							"add": "The suffix \"({{suffix}})\" {{status}} added to proctored assessments.",
							"remove": "The suffix \"({{suffix}})\" {{status}} removed from proctored assessments.",
							"update": "The suffix \"({{old}})\" {{status}} updated to \"({{new}})\" for proctored assessments."
						}
					}
				},
				"instituteScopeSettings": {
					"IndexTSX": {
						"courseID": "Course ID",
						"courseURL": "Course URL",
						"noCoursesAdded": "No Courses Added",
						"addCourseIdOrUrl": "Add a course ID or URL",
						"add": "Add",
						"remove": "Remove",
						"cancel": "Cancel",
						"save": "Save",
						"removeCourse": "Remove Course",
						"removeCourseConfirmMsg": "Are you sure you want to remove the selected courses?"
					}
				},
				"instituteMethodScopeSettings": {
					"title": "Proctoring Methods",
					"description": "Enable proctoring methods for your desired courses. Instructors can only choose the methods enabled for their courses.",
					"method": {
						"automated": "Automated Proctoring",
						"live": "Live Proctoring",
						"pop-in": "Live Check-In Proctoring",
						"pop-in-post-review": "Live Check-In with Post-Assessment Review"
					},
					"methodShort": {
						"automated": "Automated",
						"live": "Live",
						"pop-in": "Check-In",
						"pop-in-post-review": "Check-In Review"
					},
					"scopeType": "Choose a course scope option",
					"add": "Add",
					"delete": "Delete",
					"sectionTitles": {
						"scope": "Choose where Verity is enabled",
						"method": "Choose proctoring methods",
						"review": "Review and override"
					},
					"reviewDescription": "The selected proctoring methods will be applied to all active courses. Use the table below to override settings for individual courses.",
					"searchCourses": "Search courses",
					"reviewNoResults": "No courses matched this scope.",
					"reviewLoadError": "Failed to load review courses.",
					"radioGroup": {
						"allCourses": "All Active Courses",
						"selectedCourses": "Selected Courses Only",
						"selectedAccounts": "Selected {{lms}} Only",
						"courseNamePrefix": "By Prefix",
						"ariaLabel": "{{scope}} proctoring methods"
					},
					"methodDescription": {
						"automated": "Uses AI-powered monitoring to detect potential academic integrity issues through behavior analysis, real-time alerts, and session recordings.",
						"live": "Join the assessment from start to finish to monitor test-taker activity, answer questions, address concerns, flag suspicious activity, and oversee the session.",
						"pop-in": "Proctors have the option to join the session only when suspicious activity is flagged by Verity’s automated detection.",
						"pop-in-post-review": "Watch proctored recordings while referencing time-stamped reports to validate or resolve flagged incidents, with AI-powered summaries and export functionality."
					},
					"global": {
						"option": "All Active Courses"
					},
					"lmsProvidedCourseId": {
						"option": "Selected Courses Only",
						"addCourse": "Add a Course ID or URL",
						"enterCourse": "Enter a course ID or URL",
						"courseId": "Course ID",
						"courseUrl": "Course URL",
						"courseName": "Course Name",
						"selectAllAriaLabel": "Select all visible selected courses",
						"noResults": {
							"title": "Add a Course ID or URL",
							"description": "Enter a course ID or URL in the space above to add it here."
						}
					},
					"courseNamePrefix": {
						"option": "Courses with Specific Prefixes Only",
						"addCoursePrefix": "Add a Course Prefix",
						"enterCoursePrefix": "Enter a course prefix",
						"coursePrefix": "Course Prefix",
						"count": "Number of Courses Included",
						"selectAllAriaLabel": "Select all prefixes",
						"noResults": {
							"title": "Add a Course Prefix",
							"description": "Enter a prefix in the space above to add it here."
						}
					}
				},
				"chromeOsRequireManagedGuestSession": {
					"title": "Managed Guest Sessions",
					"description": "Require institution-managed Chromebooks",
					"confirmationModal": {
						"continue": "Are you sure you want to continue?",
						"cancel": "Cancel",
						"confirm": "Confirm",
						"enable": {
							"title": "Turn on Managed Guest Session for Chromebooks",
							"description1": "Test-takers will no longer be able to use personal Chromebooks for Lockdown assessments. Only Chromebooks with institution-managed Managed Guest Session enabled will be able to take Lockdown assessments.",
							"note": "Note:",
							"description2": "Before enabling this setting, Managed Guest Session must be enabled on all Chromebooks, otherwise test takers will not be able to take Lockdown assessments on Chromebooks."
						},
						"disable": {
							"title": "Turn off Managed Guest Session for Chromebooks",
							"description": "Test-takers will be able to take Lockdown assessments on Chromebooks without Managed Guest Session enabled. Some proctoring measures may not be applied to these test-takers."
						}
					}
				},
				"infoButton": {
					"ariaLabel": "More information about {{setting}}",
					"close": "Close"
				},
				"enableMFA": {
					"title": "Enable Multi-factor authentication (MFA)",
					"description": "All accounts will require multi-factor authentication (MFA) to sign in."
				},
				"mfaEmailFallback": {
					"title": "Fallback Login by Email Code",
					"description": "Require emailed verification code instead of an authenticator app. For emergencies only.",
					"tooltip": "Turn this on if the usual sign-in verification stops working. When enabled, all users at this institution will receive a verification code by email each time they sign in."
				},
				"platformChatEnabled": {
					"title": "Platform Chat",
					"description": "Enable the YuJa Platform chat for this institution."
				},
				"allowPortalMadeThirdPartyAssessments": {
					"title": "Third-Party Assessment Support",
					"description": "Enable secure proctoring for third-party assessments that are not connected to the LMS"
				},
				"delayRecordingUntilAssessmentStart": {
					"title": "Start Recording After Assessment Begins",
					"description": "Recording starts automatically upon entering assessment, skipping system check"
				},
				"managedGuestSessionRequireIncognito": {
					"title": "Skip Incognito Check",
					"description": "Skip incognito checks in Managed Guest Sessions"
				},
				"allowQuizAttemptOnBrowser": {
					"title": "Permitted Browsers",
					"description": "Select which browsers test-takers can use during an assessment",
					"browsers": {
						"title": "Browser Options",
						"chrome": {
							"label": "Google Chrome",
							"description": "Fully supports all available proctoring features."
						},
						"firefox": {
							"label": "Mozilla Firefox",
							"description": "Some proctoring features are not supported, including screen sharing."
						},
						"safari": {
							"label": "Safari",
							"description": "Some proctoring features are not supported, including screen sharing."
						}
					}
				},
				"sessionRecordingLimit": {
					"title": "Session Recording Limit",
					"description": "Set the maximum recording time for sessions.",
					"enableLimit": "Enable recording limit",
					"hours_one": "{{count}} hour",
					"hours_other": "{{count}} hours",
					"tooltip": "Recordings will automatically end when the limit is reached.",
					"belowMaximumWarningTitle": "Warning: Changing this limit may impact proctoring results.",
					"belowMaximumWarningDescription": "If an assessment exceeds the recording limit, instructors can still view flagged events, but video will only be available up to the selected recording time."
				},
				"proctoringRegistrationNotifications": {
					"title": "Proctoring Registration Notifications",
					"description": "Notify instructors 24 hours before live proctoring events with student registration details.",
					"tooltip": "When enabled, instructors can view proctoring registration status from the Proctoring Assessment page at any time."
				},
				"preferredProctoringSetupUiVersion": {
					"title": "Inline Readiness Check",
					"description": "Enable the new readiness check for the Browser Extension. Turn this off to use their previous version. The Lockdown App and Web Browser proctoring always use the new readiness check."
				},
				"flagLvlConfigTSX": {
					"lose_focus": "Test-taker navigated away from the assessment tab.",
					"copy_paste": "Test-taker attempted to copy or paste content.",
					"web_navigation": "Test-taker visited another website during the assessment.",
					"screenshot": "Test-taker attempted to take a screenshot.",
					"user_media_interrupt": "Disconnecting the webcam or audio pauses the assessment until reconnected. Bypass Mode allows the assessment to continue.",
					"screen_recording_interrupt": "If screen sharing has stopped, it will be flagged, and the assessment is paused until sharing is resumed.",
					"screen_share_inactive": "The test-taker’s shared screen showed no activity for over 10 minutes.",
					"monitor_count_interrupt": "More than one display was connected during the assessment.",
					"speaking_interrupt": "Loud or unexpected audio was detected.",
					"opens_blocked_app": "Test-taker opened a blocked application.",
					"enables_blocked_extension": "Test-taker enabled a browser extension that is not allowed.",
					"restrict_handoff_event_desc": "Test-taker using an Apple device will be required to turn off the Handoff feature on their device.",
					"blocked_navigation": "If a test-taker attempts to access a website that is not allowed, it will be blocked.",
					"upload_incomplete": "The test-taker’s webcam, screen, or audio recording could not be fully uploaded because the proctoring session was closed.",
					"force_stop_proctoring": "Test-taker ended the proctoring session.",
					"no_submission": "Proctoring ended before the assessment was submitted.",
					"connection_lost": "Connection to Verity was interrupted.",
					"missing_student": "Test-taker's face could not be detected. AI Video Analysis must be enabled to use this feature.",
					"wrong_people": "More than one face was detected. AI Video Analysis must be enabled to use this feature.",
					"phone_detected": "A phone was detected in the testing environment. AI Video Analysis must be enabled to use this feature.",
					"computer_detected": "Another computer was detected in the testing environment. AI Video Analysis must be enabled to use this feature.",
					"book_detected": "A book was detected in the testing environment. AI Video Analysis must be enabled to use this feature.",
					"many_objects_detected": "Multiple restricted objects were detected. AI Video Analysis must be enabled to use this feature.",
					"no_proctors": "The proctor left the live session.",
					"block_applications_failed": "If Verity cannot retrieve a list of open applications on the device, it will be flagged.",
					"side_panel_detected": "Test-taker opened the browser side panel.",
					"right_click_blocked": "Test-taker attempted to right-click when it was disabled.",
					"printing_blocked": "Test-taker attempted to print when printing was disabled.",
					"toggled_block_mobile_apps": "Test-taker disables Pinned Mode (Android) or Guided Access (iOS) during the assessment.",
					"decoy_site_viewed": "Test-taker visited a decoy website during the assessment.",
					"face_id_mismatch": "Test-taker's face did not match their submitted ID.",
					"bypassed_ai_detection": "Test-taker skipped AI ID verification and submitted photos manually.",
					"restricted_device_source_connected": "Test-taker connected their mobile device during the assessment.",
					"restricted_device_source_disconnected": "Test-taker disconnected their mobile device during the assessment.",
					"restricted_device_source_unlocked": "Test-taker unlocked their mobile device during the assessment.",
					"restricted_device_source_locked": "Test-taker locked their mobile device during the assessment.",
					"flagged_keyword": "A specified keyword was detected through the microphone.",
					"lose_focus2": "Tab Not Active",
					"copy_paste2": "Copy and Paste",
					"web_navigation2": "Web Navigation",
					"screenshot2": "Screenshot",
					"user_media_interrupt2": "Webcam and Audio",
					"screen_recording_interrupt2": "Screen Share Interrupted",
					"screen_share_inactive2": "Screen Activity Not Detected",
					"monitor_count_interrupt2": "Multiple Displays",
					"speaking_interrupt2": "Audio Detected",
					"opens_blocked_app2": "Blocked Application Opened",
					"enables_blocked_extension2": "Unpermitted Browser Extensions Enabled",
					"restrict_handoff_event_name": "Disable Handoff",
					"blocked_navigation2": "Blocked Navigation",
					"upload_incomplete2": "Recording Upload is Incomplete",
					"force_stop_proctoring2": "Proctoring Ended by Test-Taker",
					"no_submission2": "Proctoring Ended Before Submission",
					"connection_lost2": "Connection Interrupted",
					"missing_student2": "Face Not Detected",
					"wrong_people2": "Additional Faces Detected",
					"phone_detected2": "Phones Detected",
					"computer_detected2": "Computers Detected",
					"book_detected2": "Books Detected",
					"many_objects_detected2": "Multiple Objects Detected",
					"no_proctors2": "Proctor Left Session",
					"block_applications_failed2": "Unable to Detect Applications",
					"side_panel_detected_2": "Monitor Side Panel Activities",
					"right_click_blocked_2": "Attempted to Right Click",
					"printing_blocked_2": "Attempted to Print",
					"toggled_block_mobile_apps_2": "Pinned Mode / Guided Access Toggled",
					"decoy_site_viewed_2": "Visited Decoy Website",
					"face_id_mismatch_2": "Face Not Matched with ID Card",
					"bypassed_ai_detection_2": "AI ID Verification Skipped",
					"restricted_device_source_connected_2": "Mobile Device Connected",
					"restricted_device_source_disconnected_2": "Mobile Device Disconnected",
					"restricted_device_source_unlocked_2": "Guided Access Disabled",
					"restricted_device_source_locked_2": "Guided Access Enabled",
					"flagged_keyword_2": "Keyword Detected",
					"connection_check_fail2": "Internet Connection Issues Detected",
					"connection_check_fail": "Internet upload speed did not meet assessment requirements.",
					"system_resource_fail2": "System Performance Issues Detected",
					"system_resource_fail": "Device performance did not meet assessment requirements.",
					"not_in_geofence2": "Test-Taker Outside Geofence",
					"not_in_geofence": "Test-taker was detected outside the allowed location.",
					"location_unknown2": "Test-Taker Location Not Detected",
					"location_unknown": "Verity could not determine the test-taker's location.",
					"ip_address_out_of_range_2": "Test-Taker IP Address Out of Range",
					"ip_address_out_of_range": "If the test-taker’s IP address is outside the allowed range for this assessment, it will be flagged.",
					"ip_address_unknown_2": "Test-Taker IP Address Not Detected",
					"ip_address_unknown": "Verity could not determine the test-taker's IP address.",
					"extension_list2": "Browser Extensions Detected",
					"extension_list": "If a test-taker enables a browser extension that is not allowed, it will be flagged.",
					"running_applications2": "Running Applications Detected",
					"running_applications": "A list of running applications was captured from the test-taker's device.",
					"collaboration_detected2": "Possible collaboration with another person was detected.",
					"collaboration_detected": "Detected Collaboration",
					"essay_collaboration_detected2": "Detects when students' essay answers show significant text overlap with another student's.",
					"essay_collaboration_detected": "Detected Essay Collaboration",
					"flagEvent": "Flagged Event",
					"description": "Description",
					"flagLvl": "Flag Level",
					"none": "Info",
					"minor": "Minor",
					"major": "Major",
					"severe": "Severe"
				},
				"institutionInformationTSX": {
					"header": "Institution Information",
					"backToInstitutions": "Institutions",
					"saveSuccess": "The institution information has been successfully updated.",
					"saveError": "The institution information could not be updated. Please try again.",
					"disable": "Disable",
					"edit": "Edit ",
					"cancel": "Cancel",
					"disableModal": {
						"title": "Disable Institution Request",
						"body": "Disabling this institution will restrict access and stop all data processing. This action can be highly disruptive to students and faculty if the institution is currently in use. Please ensure the institution is no longer active before proceeding.<br />Once submitted, this request will be reviewed by the Finance team, followed by the Architecture team. If approved, the institution and all associated data will be permanently deleted 30 days after approval.<br /><br />This action can be reversed by contacting the Verity product team at any time before the scheduled deletion date.<br />To confirm, type <b>Disable</b> below:",
						"disablePlaceholder": "Disable",
						"cancel": "Cancel",
						"disable": "Disable",
						"successToast": "The institution has been successfully disabled. Request for institution deletion has been sent to finance.",
						"errorToast": "The institution has failed to be disabled."
					}
				},
				"integrationSettingsTSX": {
					"title": "Integration Settings",
					"description": "Configure how Verity connects to your institution's LMS and authentication systems. Select a connection type to view or update its settings.",
					"connectionTypes": "Connection Types",
					"selectIntegration": "Select Integration",
					"selectAriaLabel": "Select an integration",
					"status": {
						"integrated": "Integrated",
						"notDetected": "Not Detected",
						"enabled": "Enabled",
						"disabled": "Disabled"
					}
				},
				"canvasThemeDownload": {
					"description": "Adding Verity to your Canvas theme assists students with taking Verity assessments and instructors with configuring Verity assessments. To learn about adding Verity to your Canvas theme, please refer to our guide on ",
					"hyperlinkedTxt": "adding Verity to your Canvas Theme",
					"download": "Download Theme"
				},
				"visualizerDownloadTSX": {
					"lmsUnsupported": "LMS is not supported!",
					"downloadVisualizer": "Download Visualizer {{format}}",
					"lmsVisualizer": "LMS Visualizer",
					"visualizerText": "Integrating the LMS Visualizer with {{platformName}} provides an extra layer of security to prevent test-takers from accessing proctored assessments without the Verity Browser Extension. To learn about installing the visualizer, please refer to our guide on the <a>Verity Visualizer</a>.",
					"viewVisualizer": "View Visualizer",
					"verityInstituteId": "Verity Institution ID",
					"copyInstituteId": "Copy the institution ID to the plugin settings",
					"environment": "Environment",
					"copyEnvironment": "Copy the environment to the plugin settings",
					"verityServerUrl": "Verity Server URL",
					"copyServerUrl": "Copy the server URL to the app settings",
					"verityId": "Verity ID",
					"copyVerityId": "Copy the Verity ID to the app settings",
					"visualizerActivity": "LMS Visualizer activity",
					"learnMoreAriaLabel": "Learn more about the LMS Visualizer. (Opens in a new tab)."
				},
				"createProfile": {
					"title": "Create Proctoring Profiles",
					"defaultProfileName": "{{name}} {{index}}",
					"editInstitutionProfile": "Edit Institution-Wide Profile",
					"profileCreateSuccess_one": "Your Institution Profile has been successfully created.",
					"profileCreateSuccess_other": "Your Institution Profiles have been successfully created.",
					"profileCreateError_one": "There was an error creating your Institution Profile. Please try again.",
					"profileCreateError_other": "There was an error creating your Institution Profiles. Please try again.",
					"profileDeleteSuccess": "Your profile has been successfully deleted.",
					"profileDeleteError": "There was an error deleting your profile. Please try again.",
					"profileUpdateSuccess": "Your profile has been successfully updated.",
					"profileUpdateError": "There was an error updating your profile. Please try again.",
					"errorLoadingTitle": "Failed to Retrieve Profiles",
					"errorLoadingDescription": "Please refresh the page to try again.",
					"nextButton": {
						"create": "Create",
						"saveProfiles": "Save Profiles",
						"saveChanges": "Save Changes"
					},
					"stepper": {
						"platform": "Platform",
						"chromebook": "Chromebook",
						"strictness": "Strictness",
						"review": "Suggested Profiles"
					},
					"landing": {
						"title": "Create Proctoring Profiles For Your Institution",
						"description": "YuJa Verity will ask a few questions about your proctoring preferences to generate preset profiles for your institution that best match your institution’s needs.",
						"helpMe": "Help Me Build My Proctoring Profiles",
						"manual": "Setup Proctoring Profile Manually",
						"guideTitle": "Profile Creation Guide"
					},
					"platform": {
						"title": "Which platform should test-takers use to take assessments?",
						"extension": {
							"description": "Best for easier student access while still supporting browser recording and lockdown controls.",
							"subtitle": "This will create 2 profiles for use with Browser Extensions.",
							"mobile": "This will create 2 profiles for Browser Extension or mobile use."
						},
						"lockdown": {
							"description": "Provides the full lockdown experience, allowing Verity to restrict activity across the student’s entire computer.",
							"subtitle": "This will create 2 profiles for use with Desktop Lockdown.",
							"mobile": "This will create 2 profiles for Desktop Lockdown or mobile use."
						},
						"browser": {
							"description": "Best for the fastest start: test-takers are proctored in the assessment tab with nothing to install.",
							"subtitle": "This will create 2 profiles for use with Web Browser."
						},
						"both": {
							"title": "Both Platforms",
							"description": "Includes both Extension and Lockdown for full feature access.",
							"subtitle": "Creates two profiles, one for Browser Extension and one for the Desktop Lockdown App.",
							"mobile": "This will create one profile for Extension or mobile use, and another for Desktop Lockdown or mobile use."
						}
					},
					"chromebook": {
						"title": "Does your institution use Chromebooks?",
						"description": "Chromebooks require ChromeOS Managed Guest Sessions for full Lockdown controls. <a>Learn more about Managed Guest Sessions</a>.",
						"learnMoreAriaLabel": "Learn more about managed guest sessions. (Opens in a new tab).",
						"managedChromebookTitle": "Yes, we provide managed Chromebooks.",
						"managedChromebookDesc": "Allow Chromebooks for Lockdown using Managed Guest Sessions.",
						"personalChromebookTitle": "Yes, and test-takers can also use their own Chromebooks.",
						"personalChromebookDesc": "Allow Chromebooks for Lockdown without Managed Guest Sessions.",
						"noChromebookTitle": "No, we do not want test-takers to use Chromebooks.",
						"noChromebookDesc": "Do not allow Chromebooks for Lockdown assessments.",
						"requireManagedGuestSession": "<b>Require</b> test-takers to use Managed Guest Sessions."
					},
					"strictness": {
						"title": "How strict do you want the assessment to be?",
						"least": "Least Restrictive",
						"average": "Somewhat Restrictive",
						"most": "Most Restrictive",
						"leastDesc": "Includes essential proctoring features with minimal restrictions.",
						"averageDesc": "Includes all Least Restrictive features with added limits.",
						"mostDesc": "Includes all Somewhat Restrictive features with strictest limits.",
						"webcamAudio": "Webcam and Audio Recording",
						"screenRecording": "Screen Recording",
						"roomScanID": "Room Scan and ID Verification",
						"idVerification": "ID Verification",
						"oneScreen": "Allow Only One Screen",
						"recordKeyboard": "Record Keyboard Activity",
						"blockDesktop": "Block Desktop Applications",
						"andMore": "+ {{count}} more",
						"fromLeastStrict": "Everything from Least Restrictive",
						"fromAverage": "Everything from Somewhat Restrictive"
					},
					"review": {
						"title": "Based on your answers, we have created two recommended profiles. Please review and edit them if needed",
						"backToProfiles": "Back to Profiles",
						"recording": "Recording",
						"restrictions": "Restrictions",
						"editProfile": "Edit Profile",
						"viewMore": "View More"
					}
				},
				"userPinTSX": {
					"renegeratePin": "Regenerate PIN"
				},
				"institutionReportEmailTSX": {
					"title": "Monthly Institution Report Email",
					"description": "Receive a monthly email with Verity usage and performance highlights for your institution"
				},
				"lmsApiIntegrationTSX": {
					"accessKeyLabel": "Access Keys",
					"courseIDTitle": "Course ID",
					"courseIDDesc": "Enter Course ID",
					"lmsUnsupported": "LMS is not supported!",
					"discardChanges": "Discard Changes",
					"saveChanges": "Save Changes",
					"saveToastSuccess": "Changes have been successfully saved.",
					"saveToastError": "Failed to save changes.",
					"lmsApiAccess": "LMS API Access",
					"description": "API access is required to establish a connection with your {{lms}} instance so that Verity can retrieve data. To learn more, please refer to our guide on <a>Integrating Verity with {{lms}}</a>.",
					"baseUrl": "Your institution's base URL.",
					"domain": "Domain",
					"domainPlaceholder": "Domain",
					"domainHint": "The Domain is the base URL of your {{lms}} instance (for example, https://). It tells YuJa Verity where to send API requests and connect to your LMS.",
					"lmsApiLink": "LMS API Link",
					"apiEndpoint": "The API endpoint for your institution.",
					"apiEndpointHint": "The LMS API Link is the full endpoint {{lms}} provides for programmatic access to its data. Verity uses this link to retrieve course, user, and enrollment information securely.",
					"apiLinkPlaceholder": "LMS API Link",
					"accessKeys": "Access Keys",
					"accessKeysHint": "Access Keys authorize Verity to interact with {{lms}} on behalf of your institution. They ensure that all API requests are authenticated and secure.",
					"keysDescription": "Allow Verity to retrieve data from your LMS",
					"override": "Override",
					"testInstitutionAccess": "Test Institution Access",
					"testCourseAccess": "Test Course Access",
					"noAccessKeys": "No access keys have been added to your institution. Please add an access key to enable Verity to create and delete assessments.",
					"addAccessKey": "Add Access Key",
					"removeAccessKey": "Remove LMS Access Key",
					"cancel": "Cancel",
					"discardToastSuccess": "Changes have been successfully discarded.",
					"discardToastError": "Failed to discard changes.",
					"discardConfirm": "Are you sure you want to discard all changes?",
					"overrideAccessKey": "Override Access Key",
					"add": "Add",
					"guideHeaderMoodle": "To learn how to obtain your access token, please refer to our guide on <a>Obtaining Moodle Web Service key Token</a>.",
					"guideHeader": "To learn how to obtain your client ID and secret, please refer to our guide on <a>Generating a Client ID and Secret for Verity</a>.",
					"accessKey": "Access Key",
					"institutionAccessKey": "Your institution's API access key",
					"enterAccessKey": "Enter access key",
					"accessKeyEmpty": "Access token is required.",
					"accessKeyValidation": "Access key should only contain valid characters (numbers, letters, dashes, and colons)",
					"clientId": "Client ID",
					"clientIdDescription": "The client ID found in {{lms}}",
					"clientIdRequired": "Client ID is required",
					"clientSecret": "Client Secret",
					"clientSecretDescription": "The client secret found in {{lms}}",
					"clientSecretRequired": "Client secret is required",
					"moodleSuccessToast": "Changes have been made. Please test API access before saving your changes.",
					"lmsSecretSuccessToast": "Changes have been made. Please save your changes to test API access.",
					"lmsSecretSaveToastError": "Failed to save client secrets.",
					"invalidScopeAriaLabel": "Learn more about invalid scope. (Opens in a new tab).",
					"secretKeyAriaLabel": "Learn more about generating a client ID and secret. (Opens in a new tab).",
					"accessKeyAriaLabel": "Learn more about generating an access key. (Opens in a new tab).",
					"apiAccessAriaLabel": "Learn more about integrating Verity with your LMS. (Opens in a new tab).",
					"d2lCorePermissionTitle": "Allow Question Generation (Recommended)",
					"d2lCorePermissionDesc": "Allowing question generation is recommended so Verity can generate and add questions to LMS assessments. Required Permission: <code>Core:*:*</code>"
				},
				"savedGeofencesCourse": {
					"description": "Manage geofence locations for proctored assessments in your course. You can enable this setting when setting up proctoring for an assessment.",
					"button": "Manage Location"
				},
				"integrationDetectedTSX": {
					"detected": "{{integration}} detected in the last 24 hours.",
					"undetected": "{{integration}} not detected in the last 24 hours."
				},
				"lti1p3IntegrationTSX": {
					"title": "LTI 1.3 Integrations",
					"description": "To complete the LTI 1.3 integration process, please refer to our <a>Integrating Verity with {{platformName}} guide</a>. This guide explains how to retrieve your Client ID, Deployment ID, Issuer (ISS), OIDC Endpoint, and JWKS Endpoint.",
					"descriptionAriaLabel": "Learn more about integrating Verity with {{platformName}}. (Opens in a new tab).",
					"ltiLaunch": "LTI Launch",
					"remove": "Remove",
					"addIntegration": "Add New Integration",
					"lmsUnsupported": "LMS is not supported!",
					"required": "{{field}} is required",
					"discardChanges": "Discard Changes",
					"saveChanges": "Save Changes",
					"discardToastSuccess": "Successfully discarded integration settings.",
					"discardToastError": "Failed to discard integration settings.",
					"saveToastSuccess": "Successfully updated integration settings. Changes may take 5 minutes to appear.",
					"saveToastError": "Failed to update integration settings.",
					"removeToastSuccess": "Successfully removed integration settings.",
					"removeToastError": "Failed to remove integration settings.",
					"removeModal": {
						"title": "Remove Integration",
						"body": "Are you sure you want to remove this integration? You will no longer be able to access Verity in this LMS.",
						"cancel": "Cancel",
						"remove": "Remove"
					},
					"clientId": {
						"header": "Client ID",
						"description": "Client ID used for LTI 1.3 Authentication",
						"placeholder": "Client ID",
						"hint": "The Client ID is the unique identifier that {{lms}} assigns to your YuJa Verity LTI developer key. It links your {{lms}} instance to the YuJa Verity tool and authorizes communication between the two systems. When creating the LTI integration, you'll copy this value from {{lms}} and enter it in the YuJa Verity admin settings so {{lms}} knows which external tool is being launched and can securely exchange data."
					},
					"deploymentId": {
						"header": "Deployment ID",
						"description": "Deployment ID used for LTI 1.3 authentication",
						"placeholder": "Deployment ID",
						"hint": "The Deployment ID is the unique identifier Deployment generates when you install the YuJa Verity LTI tool into a specific course or account. It distinguishes this particular installation from other LTI tools or environments. You'll enter the Deployment ID in the YuJa Verity admin settings so the tool can recognize which {{lms}} site (and scope—course or institution) it is connected to and securely exchange data."
					},
					"iss": {
						"header": "ISS",
						"description": "ISS used for LTI 1.3 authentication",
						"placeholder": "ISS",
						"hint": "ISS is a URL that uniquely identifies the {{lms}} platform instance that sends the LTI launch request."
					},
					"oidc": {
						"header": "OIDC Endpoint",
						"description": "OIDC endpoint used for LTI 1.3 authentication",
						"placeholder": "OIDC Endpoint",
						"hint": "The OIDC (OpenID Connect) Endpoint is the {{lms}} URL used to begin the secure sign-in flow for LTI 1.3. When a user launches the YuJa Verity tool, {{lms}} directs the request to this endpoint to start the authentication and authorization process. YuJa Verity uses it to verify user identity and obtain the security tokens needed to complete the LTI launch."
					},
					"jwks": {
						"header": "JWKS Endpoint",
						"description": "JWKS endpoint used for LTI 1.3 authentication",
						"placeholder": "JWKS Endpoint",
						"hint": "The JWKS (JSON Web Key Set) Endpoint is a {{lms}}-hosted URL that provides the public keys {{lms}} uses to sign LTI 1.3 security tokens. YuJa Verity retrieves these keys from the endpoint to validate the authenticity of each launch request and ensure that the data really comes from your {{lms}} instance. This automatic key exchange keeps the integration secure and eliminates the need for manual key management."
					}
				},
				"module": {
					"adminBanner": "Contact your Account Manager to make any adjustments for {{product}}.",
					"verity": "Verity",
					"candidate": "Candidate AI",
					"on": "On",
					"off": "Off",
					"discardChanges": "Discard Changes",
					"saveChanges": "Save Changes",
					"contactSales": "Contact Sales",
					"contactSalesAriaLabel": "Contact Sales. (Opens in a new tab)."
				},
				"candidateModule": {
					"title": "YuJa Candidate AI",
					"description": "The YuJa Candidate AI Interview Module is a proctoring platform built on the core of YuJa Verity’s Proctoring Engines to streamline and advance interview processes for a secure and fair experience. <a>Learn more</a>.",
					"descriptionAriaLabel": "Learn more about YuJa Candidate AI. (Opens in a new tab).",
					"saveToastSuccess": "Success. Changes may take 5 minutes to appear.",
					"saveToastError": "Unable to update addon settings. Please contact support@yuja.com",
					"loadingError": "Unable to load addon settings. Please refresh the page or contact support@yuja.com"
				},
				"verityModule": {
					"title": "Verity Test Proctoring",
					"description": "The YuJa Verity Test Proctoring uses AI and machine learning to deliver secure, scalable online exam monitoring with real-time proctoring, identity verification, and detection of suspicious behavior to support academic integrity. <a>Learn more</a>.",
					"descriptionAriaLabel": "Learn more about Verity Test Proctoring. (Opens in a new tab).",
					"videoTitle": "Verity Test Proctoring Platform Overview",
					"saveToastSuccess": "Success. Changes may take 5 minutes to appear.",
					"saveToastError": "Unable to update addon settings. Please contact support@yuja.com",
					"loadingError": "Unable to load addon settings. Please refresh the page or contact support@yuja.com",
					"oneMethodDisabledTooltip": "Please enable at least one method to save changes.",
					"tab": {
						"tierPackage": "Tier Package",
						"settings": "Settings"
					},
					"tierPackage": {
						"youAreOn": "You are on Package {{number}}",
						"lite": {
							"title": "Lite Package",
							"extension": "Chrome Browser Extension",
							"lockdown": "Desktop Lockdown App for Windows and Mac Devices",
							"disableVirtualCamera": "Disable Virtual Camera, Clipboard, Right-Click, Browser Extensions, File Downloads, Spell Check, and Handoff",
							"closeOpenTabs": "Tab Restrictions, including Close Open Tabs and Disable New Tabs",
							"oneScreenEnforcementMode": "Enforce Single Screen Usage"
						},
						"standard": {
							"title": "Standard Package",
							"includedDesc": "Everything from Verity Lite Package",
							"chromebook": "Chromebook Support through the Chrome Browser Extension",
							"videoRecordingMode": "Automated Recording of Test-Taker Webcam Video",
							"audioRecordingMode": "Automated Recording of Test-Taker Microphone Audio",
							"recordScreen": "Automated Recording of Test-Taker Screen Activity",
							"scanRoom": "Room Scan Capture and Review Module",
							"idVerification": "ID Capture for Instructor Verification"
						},
						"advanced": {
							"title": "Advanced Package",
							"includedDesc": "Everything from Verity Lite & Standard Package",
							"mobile": "Mobile Lockdown App for Taking Assessments on Android and Apple Devices",
							"idVerificationEnableAi": "AI ID Verification",
							"quietEnvironment": "AI-Powered Quiet Environment Monitoring",
							"faceTrackingMode": "AI-Powered Facial Detection Analytics",
							"objectDetectionMode": "AI-Powered Analytics of Suspicious Objects Detection",
							"audioTranscription": "Automated Audio Transcription and Analysis",
							"flaggedKeywords": "Automated Flagged Keywords Detection",
							"mostPopular": "Most Popular"
						}
					},
					"settings": {
						"method": {
							"title": "Method",
							"usageAllocation": "Usage Allocation",
							"tableHeader": {
								"cycle": "Cycle",
								"type": "Type",
								"limit": "Limit",
								"resetDate": "Reset Date"
							},
							"metered": "Metered",
							"unlimited": "Unlimited",
							"limited": "Limited",
							"usageType": {
								"sessions": "Per Session",
								"hours": "Per Hour",
								"user": "Per User",
								"ariaLabel": "Select a usage type",
								"disabledTooltip": "One-Time Pack type automatically matches the Annual selection. Change the Annual type above to update this."
							},
							"cycle": {
								"annual": "Annual",
								"oneTime": "One-Time Pack"
							},
							"limit": {
								"sessions_one": "Session",
								"sessions_other": "Sessions",
								"hours_one": "Hour",
								"hours_other": "Hours",
								"user_one": "User",
								"user_other": "Users",
								"ariaLabel": "Enter a usage limit"
							},
							"resetDataAriaLabel": "Select a reset date for usage allocation",
							"automatedDesc": "YuJa Verity will proctor and monitor the assessment. Review results during or after the assessments.",
							"liveDesc": "Set up an assessment with a scheduled live proctoring session and monitoring support.",
							"liveCheckInDesc": "Allow test-takers to start assessments independently with automated monitoring and proctor alerts for suspicious activity.",
							"liveCheckInPostReviewDesc": "Includes all Live Check-In features, plus a manual review of session recordings after the assessment.",
							"proctorGroup": "Proctored by YuJa Verity",
							"individualProctor": "Proctored by the Institution",
							"proctorLabel": "Select Live Proctored Mode"
						},
						"platform": {
							"title": "Platform",
							"desc": "Manage platform feature access for Verity proctoring.",
							"extensionDesc": "Allow requiring specific browser extensions for proctoring and assessment functionality.",
							"lockdownDesc": "Allow lockdown browsers to restrict access to unauthorized apps, websites, and system functions during assessments.",
							"mobileDesc": "Allow secure assessment completion on mobile devices with full proctoring controls.",
							"chromeDesc": "Allow secure assessment completion on Chromebook Lockdown App with full proctoring controls.",
							"browserDesc": "Allow proctoring in a web browser without installing an app or extension."
						},
						"payment": {
							"title": "Test-Taker Payment and Billing information",
							"subtitle": "Test-Taker Payment",
							"description": "Authorize instructors to require a fee that Test-takers must pay prior to accessing a proctored assessment.",
							"currencyLabel": "Billing Currency",
							"currencySubtitle": "This currency will apply to all fee methods below.",
							"tableHeader": {
								"method": "Method",
								"type": "Type",
								"cost": "Cost"
							},
							"type": {
								"attempt": "Per Attempt",
								"assessment": "Per Assessment",
								"ariaLabel": "Select payment type"
							},
							"currency": {
								"usd": "USD",
								"cad": "CAD",
								"eur": "EUR",
								"gbp": "GBP"
							},
							"price": {
								"label": "{{method}} Price"
							}
						},
						"other": {
							"title": "Others",
							"bypassAiTitle": "Allow Disable AI Bypass Mode",
							"bypassAiDesc": "Enforce strict monitoring protocols by preventing test-takers from using AI features or tools to circumvent proctoring controls.",
							"showAllAssessments": "Show All Assessments",
							"showAllAssessmentsDesc": "Display the \"All Assessments\" tab within the Verity LTI, giving test-takers a centralized view of their upcoming and past exams.",
							"reportLiteTitle": "Report Access for Lite Mode",
							"reportLiteDesc": "Provides access to reports, including Institution, Course, Assessment, and Usage reports, and proctored results."
						},
						"disabledOptions": {
							"title": "Institution-Wide Assessment Settings"
						},
						"demoMode": {
							"title": "Demo Course",
							"enableCleanup": "Automatic Data Cleanup",
							"enableCleanupDescription": "Automatically remove proctoring sessions created after a scheduled date.",
							"enableCleanupHint": "Cleanups run at 5:00AM UTC based on the selected frequency to keep your demo environment clean and up to date. This applies to all courses in the institution.",
							"cutoffTime": "Scheduled Cutoff Date",
							"cutoffTimeDescription": "Select the date that marks the starting point for automated cleanup.",
							"cutoffTimeHint": "Any proctoring sessions created <b>after</b> this date will be eligible for automatic deletion.",
							"cleanupSchedule": "Cleanup Frequency",
							"cleanupScheduleDescription": "Choose how often the system checks for and removes demo proctoring sessions.",
							"cleanupScheduleHint": "Cleanups run daily, weekly, or monthly based on the selected cutoff date.",
							"nextCleanup": "Next Scheduled Cleanup:",
							"nextCleanupDate": "{{localizedDate}} - 5:00 AM (UTC)",
							"frequency": {
								"label": "Frequency",
								"daily": "DAILY",
								"weekly": "WEEKLY",
								"monthly": "MONTHLY"
							},
							"cleanupSummary": "Cleanup Schedule Summary:",
							"cleanupSummaryDescription": "Automated cleanup will run {{freq}}, starting on {{localizedDate}} at 5:00 AM (UTC)."
						}
					}
				}
			},
			"startAssessment": {
				"loadingToast": "Redirecting...",
				"openToast": "Opening...",
				"noThirdPartyUrl": "The third-party assessment has no URL.",
				"extensionError": "Failed to detect the Verity extension. Please ensure the extension is downloaded and try again.",
				"blackboardSupportError": "Blackboard does not support instructors to attempt assessments. Please enter student view and try again.",
				"lmsError": "Unfortunately, Verity does not yet support assessment view for this LMS.",
				"authError": "Authentication failed. Please try again. If you receive this error again, please contact YuJa support for help.",
				"unknownError": "An unknown error occurred."
			},
			"assessmentPageTSX": {
				"header": {
					"title": "Proctored Assessments",
					"description": "View all proctored assessments that have been created for your course."
				},
				"tableAriaLabel": "Proctored Assessments table",
				"createPracticeModal": {
					"title": "Create a Practice Assessment",
					"description": "Create a practice assessment to introduce yourself and your students to Verity."
				},
				"createThirdPartyModal": {
					"title": "Create a Third-Party Assessment",
					"description": "Use Verity's proctor settings to monitor third-party assessments.",
					"btnMessage": "Create Third-Party Assessment"
				},
				"createStandaloneModal": {
					"title": "Create a Standalone Assessment",
					"description": "Create and send proctored assessments to anyone not enrolled in the course.",
					"btnMessage": "Add Standalone Assessment"
				},
				"compatibilityModal": {
					"title": "Proctoring Readiness Check Report",
					"description": "Check your system to ensure all permissions are enabled for your assessment.",
					"btnMessage": "Compatibility Check",
					"hoverMessage": "You will need to download the Verity Browser Extension before starting the compatibility check."
				},
				"assessmentIdModal": {
					"title": "Assessment ID"
				},
				"getDisabledModeText": {
					"text1": "The ",
					"extension": "extension",
					"lockdownApp": "desktop Lockdown App",
					"mobileApp": "mobile Lockdown App",
					"browser": "browser",
					"text2": " proctoring platform has been disabled for your institution. ",
					"text3": "Please edit the assessment settings and select another proctoring platform.",
					"disabled": " (Disabled)"
				},
				"columnList": {
					"usage": "Platform Usage",
					"description": "View the number of assessments created for each platform.",
					"types": "Platform Types",
					"assessmentName": "Assessment",
					"dateCreated": "Date Created",
					"dateUpdated": "Date Updated",
					"verityStatus": "Verity Status",
					"proctoringType": "Platform ",
					"proctoringMethod": "Method",
					"managedIn": "Managed In",
					"publishStatus": "Status",
					"method": {
						"live": "Live",
						"pop-in": "Live Check-In",
						"pop-in-post-review": "Check-In/Review",
						"automated": "Automated"
					},
					"verity": "Verity",
					"assignment": "Assignment",
					"quiz": "Quiz",
					"standalone": "Standalone",
					"published": "Published",
					"unpublished": "Unpublished",
					"popInPostReview": "Live Check-In with Post-Assessment Review",
					"action": {
						"header": "Actions",
						"startAssessment": "Preview Assessment",
						"deleteAssessment": "Delete Assessment",
						"editSettings": "Edit Settings",
						"viewResult": "View Proctoring Results",
						"viewRegistrationStatus": "View Registration Status",
						"startLockdown": "Start Assessment in Lockdown App",
						"checkLockdown": "Check Lockdown App Compatibility",
						"checkCompatibility": "Compatibility check",
						"contentProtection": "Content Protection",
						"activateDecoy": "Activate Decoy",
						"viewDecoy": "View Decoy Activity",
						"tokenNotAvailable": {
							"canvas": "Connect your Verity account by going to User Setup > Browser Extension.",
							"default": {
								"instructor": "LMS API integration is required. Please contact your admin.",
								"admin": "LMS API integration required. Go to Settings > Integration Settings."
							}
						},
						"publish": "Publish Assessment",
						"unpublish": "Unpublish Assessment",
						"syncPassword": "Manage Password"
					},
					"deleteModal": {
						"description": "Are you sure you want to delete the \"{{name}}\" assessment?",
						"authorizing": "Authorizing...",
						"deleting": "Deleting...",
						"cancel": "Cancel",
						"delete": "Delete"
					},
					"unpublishModal": {
						"title": "Unpublish Assessment",
						"description": "This assessment will no longer be visible to students. Are you sure you want to unpublish it?",
						"cancel": "Cancel",
						"unpublish": "Unpublish",
						"errorPublishing": "Failed to publish the assessment. Please try again.",
						"errorUnpublishing": "Failed to unpublish the assessment. Please try again.",
						"successPublishing": "The assessment has been successfully published.",
						"successUnpublishing": "The assessment has been successfully unpublished."
					},
					"extension": "Extension",
					"mobile": "Mobile",
					"lockdown": "Lockdown",
					"mobileAndLockdown": "Mobile & Lockdown",
					"browser": "Web Browser",
					"notProctored": "Not Proctored",
					"redirecting": "Redirecting...",
					"noPlatformData": "No Platform Data Available",
					"moreOptions": "More options"
				},
				"searchBar": {
					"placeHolder": "Search by assessment name",
					"ariaLabel": "Enter assessment names to search",
					"noAssessments": "No assessments available.",
					"noSearchResult": "No search results."
				},
				"editAssessment": {
					"featureError": "Sorry, Verity does not support this feature in the Learning Management System being used.",
					"editError": "Failed to open assessment edit page. Please try again. If you receive this error again, please contact YuJa support for help."
				},
				"deleteAssessment": {
					"deleteToast": "Deleting assessment...",
					"successToast": "The assessment has been successfully deleted from Verity.",
					"successLmsToast": "The assessment has been successfully deleted from Verity and the LMS.",
					"deleteError": "The assessment could not be deleted. Please try again.",
					"lmsError": "The assessment has been deleted from Verity, but is still available in the course.",
					"setupError": "The delete assessment feature has not been set up by your institution's admin.",
					"authError": "You did not authorize Verity when deleting the assessment.",
					"popupError": "Please enable pop-ups in your browser."
				},
				"syncPassword": {
					"title": "Manage Assessment Password",
					"description": "The password in Verity and the LMS must match for test takers to access the assessment. Override the Verity password if there is a mismatch.",
					"noLmsHeader": "Email Instructor to Update Password",
					"password": {
						"title": {
							"verity": "Current Verity Password",
							"lms": "Detected LMS Password",
							"match": "Current Verity Password",
							"noLmsPassword": "Current Verity Password"
						},
						"subtitle": {
							"verity": "Outdated password is stored in Verity.",
							"lms": "Current password is sourced from the LMS.",
							"match": "The password currently set in the LMS matches the Verity password. No action is required.",
							"noLmsPassword": "We could not retrieve the assessment access code from the LMS. Please contact the instructor to reset the access code or send them the email."
						}
					},
					"confirmSync": {
						"title": "Confirm Password Override",
						"description": "Are you sure you want to update the Verity password? This will permanently overwrite the current Verity access code to match the LMS."
					},
					"confirmSendEmail": {
						"title": "Confirm Send Email",
						"description_one": "Are you sure you would like to send an email to the instructor?",
						"description_other": "Are you sure you would like to send an email to the instructors?",
						"defaultInstructorName": "[Instructor Names]",
						"label": "Send Email To"
					},
					"button": {
						"sync": "Override Verity Password",
						"syncing": "Overriding...",
						"sendEmail": "Send Email",
						"sendingEmail": "Sending...",
						"cancel": "Cancel",
						"close": "Close",
						"confirm": "Confirm"
					},
					"toast": {
						"success": "The <strong>{{title}}</strong> password has been successfully updated.",
						"loadError": "Failed to retrieve the LMS password.",
						"syncError": "Failed to sync the password. Please try again.",
						"alreadySynced": "The password in Verity is already the same as the password in the LMS.",
						"noPassword": "The assessment is not password protected in the LMS.",
						"emailSent": "The email has been sent successfully.",
						"emailSentPlural": "The emails have been sent successfully.",
						"emailPartialFailure": "Sent to {{sentCount}} of {{totalCount}} recipients. Some emails could not be delivered.",
						"emailError": "Failed to send the email. Please try again."
					}
				},
				"createAssessment": "Create Assessment",
				"assessmentType": {
					"header": "Assessment Type",
					"lms": "LMS",
					"third-party": "Third-Party",
					"standalone": "Standalone",
					"verityAssignment": "Assignment",
					"verityQuiz": "Quiz"
				},
				"platform": {
					"header": "Platforms",
					"extension": "Extension",
					"lockdown": "Lockdown",
					"mobile": "Mobile",
					"chromeOs": "Chromebook",
					"browser": "Web Browser",
					"notProctored": "Not Proctored"
				},
				"methods": "Methods",
				"introductoryVideo": {
					"header": "Create Your First Proctored Assessment",
					"description": "Create an assessment in {{lmsName}}, then apply proctoring settings to choose how to monitor test-takers and which restrictions to turn on. <a>Learn more</a>.",
					"linkText": "Create a Proctored Assessment in {{lmsName}}",
					"videoTitle": "{{lmsName}} Proctored Assessment Tutorial for Instructors",
					"popover": {
						"header": "Create a Proctored Assessment in {{lmsName}}",
						"description": "View <a>step-by-step instructions</a> instead."
					}
				}
			},
			"registrationStatusPageTSX": {
				"header": {
					"title": "Registration Status",
					"titleWithName": "Registration Status: {{name}}",
					"description": "View the test-takers who have registered for a proctoring session for this assessment."
				},
				"columnList": {
					"testTakerName": "Test-Taker Name",
					"sessionDate": "Session Date",
					"timeSlot": "Time Slot",
					"unknownStudent": "Unknown Student"
				},
				"filter": {
					"sessionDate": "Session Date",
					"startAriaLabel": "Select the starting date for the session date.",
					"endAriaLabel": "Select the ending date for the session date."
				},
				"searchBar": {
					"placeHolder": "Search by test-taker name",
					"ariaLabel": "Enter test-taker names to search",
					"noRegistrations": "No test-takers have registered for a proctoring session yet.",
					"noSearchResult": "No search results."
				}
			},
			"studentAssessmentPageTSX": {
				"title": "Assessment Hub",
				"tab": {
					"all": "All Assessments",
					"active": "Active",
					"upcoming": "Upcoming",
					"scheduleRequired": "Schedule",
					"completed": "Completed"
				},
				"description": {
					"all": "You can click Start to begin your assessment or click Schedule to register for a live assessment.",
					"active": "You can click Start to begin an assessment that is available for you to join.",
					"upcoming": "You can edit your time slot for upcoming scheduled live assessments.",
					"scheduleRequired": "You can click Schedule to sign up for live sessions you have not registered for yet.",
					"completed": "If the assessment allows multiple attempts, click Reattempt to try again. You may also reschedule missed live assessments if there are additional sessions available."
				},
				"searchAssessments": "Search assessments",
				"nonLiveDate": "Date established through the course.",
				"scheduleRequired": "Please schedule your live proctored assessment.",
				"allSessionsEnded": "All time slots have ended. You can no longer schedule this assessment.",
				"allRegistrationEnded": "Registration for this assessment has closed. You can no longer schedule it.",
				"platform": {
					"extension": "Extension",
					"lockdown": "Lockdown App",
					"lockdownOrMobile": "Lockdown or Mobile App",
					"extensionOrMobile": "Extension or Mobile App"
				},
				"liveSession": "Live Session",
				"start": "Start",
				"reattempt": "Reattempt",
				"startButtonAriaLabel": "Start {{assessment}}. Opens in a new tab",
				"reattemptButtonAriaLabel": "Reattempt {{assessment}}. Opens in a new tab",
				"wrongPlatform": "The device or browser being used is not supported for this assessment.",
				"chromeOsDisabled": "Your instructor has allowed only Windows or Mac devices for this assessment. Chromebooks are not supported.",
				"schedule": "Schedule",
				"editSchedule": "Edit Schedule",
				"registrationEnded": "Unable to edit schedule. No open sessions are available.",
				"noAvailableSessions": "There are no sessions available for you to reschedule your live assessment.",
				"checkCompatibility": "Compatibility check",
				"compatibilityAriaLabel": "Start compatibility check for {{assessment}}. Opens in a new tab.",
				"noAssessments": {
					"all": {
						"title": "No Assessments Available",
						"description": "Assessments have not yet been created for this course."
					},
					"active": {
						"title": "No Assessments Available",
						"description": "There are no assessments ready for you to take."
					},
					"upcoming": {
						"title": "No Upcoming Assessments",
						"description": "There are no upcoming live assessments, or you have not scheduled one."
					},
					"scheduleRequired": {
						"title": "No Assessment to Schedule",
						"description": "There are no live assessments for which you need to register."
					},
					"completed": {
						"title": "No Assessments Completed",
						"description": "Assessments have not yet been completed for this course."
					}
				},
				"noResults": {
					"title": "No Results Found",
					"description": "Try adjusting your search criteria and filters."
				},
				"errorLoading": {
					"title": "Failed to Retrieve Assessments",
					"description": "Please refresh the page to try again."
				},
				"registerLiveSessionPageTSX": {
					"requireRegistration": "Registration Required",
					"chooseTimeSlot": "Please choose a session to register for your live proctored assessment.",
					"registerSuccess": "You have successfully registered for “{{assessmentName}}.” If it has not started, you can still make changes in the Upcoming tab."
				},
				"introductoryVideo": {
					"header": "Getting Started with Verity",
					"description": "Watch the tutorial video to learn how to take an assessment with Verity. Then go to the Assessment Hub to view assessments that your instructor has created for you to complete. <a>Learn more</a>.",
					"descriptionNoAssessments": "Watch the tutorial video to learn how to take an assessment with Verity. Once your instructor creates an assessment, it will be available here. <a>Learn more</a>.",
					"button": "Go to Assessment Hub",
					"linkText": "Take an Assessment with Verity",
					"videoTitle": "{{lmsName}} Proctored Assessment Tutorial for Students",
					"popover": {
						"header": "Taking an Assessment",
						"description": "<a>Learn more</a> about how to complete the Proctoring Readiness Check before taking your assessments in this video."
					}
				}
			},
			"assessmentInProgress": {
				"compatibilityTitle": "Compatibility Check in Progress",
				"compatibilityBody": "A compatibility check for another assessment is already in progress. Please try again once the compatibility check has been completed."
			},
			"createAssessmentPageTSX": {
				"createAssessment": "How do you want to create your assessment?",
				"practiceAssessment": {
					"title": "Mock Assessment",
					"description": "A demo session for test-takers to check their setup and become familiar with the proctoring experience."
				},
				"thirdPartyAssessment": {
					"title": "Third-Party Assessment",
					"description": "A proctored assessment that allows test-takers to access an assessment on a third-party platform with Verity proctoring."
				},
				"standaloneAssessment": {
					"title": "Standalone Assessment",
					"description": "A proctored assessment that test-takers can access via a direct link without logging into {{lms}}.",
					"descriptionNoLms": "A proctored assessment that test-takers can access via a direct link without logging into an LMS."
				},
				"verityAssessment": {
					"title": "Verity Assessment",
					"description": "Create, deliver, and grade proctored assessments in one place, with automatic publishing to {{lms}}."
				},
				"recommendedBadge": "Recommended",
				"redirecting": "Redirecting...",
				"openingLmsPageFailed": "Verity could not access the assessment creation page for your LMS. Please manually navigate to the page.",
				"backButtonAriaLabel": "Go Back to Proctored Assessments",
				"back": "Back",
				"next": "Next"
			},
			"installExtensionModalTSX": {
				"title": "YuJa Verity Setup"
			},
			"contentProtectionPageTSX": {
				"title": "Content Protection",
				"description": "Content Protection detects potential assessment leaks online and lets you request DMCA (Digital Millennium Copyright Act) removal.",
				"scanAndCheck": {
					"title": "1. Scan and Check",
					"description": "Scan the assessment to retrieve its questions, then let Verity’s Content Protection check the web for leaked or similar content.",
					"scanButton": {
						"scan": "Scan Assessment",
						"cancel": "Cancel Scan",
						"rescan": "Rescan"
					},
					"scanFailed": {
						"title": "Scanning Failed",
						"description": "We couldn’t complete the scan. Please click ‘Rescan’ to try again."
					},
					"scanInProgress": {
						"title": "Scanning in Progress",
						"description": "Scanning assessments for potential leaks across multiple platforms.",
						"getSources": "Questions Scanned: <b>{{numScanned}}/{{total}}</b>",
						"estimatedTime": "Estimated Time Remaining: <b>{{localizedTime}}</b>"
					},
					"scanIncomplete": {
						"title": "Scan is Incomplete",
						"description": "The scan was unable to retrieve {{numRetrieved}} of {{totalQuestions}} questions. Click <b>Rescan</b> to try again or upload the questions instead.",
						"toast": "Scan incomplete. Try again or add questions manually.",
						"status": "Incompleted"
					},
					"scanComplete": {
						"status": "Complete ({{total}} questions scanned)",
						"lastScanDate": "Last scan completed on {{localizedDate}}",
						"toast_one": "{{count}} question in your assessment have been successfully scanned.",
						"toast_other": "{{count}} questions in your assessment have been successfully scanned."
					},
					"noQuestions": {
						"title": "Your Assessment Appears to Be Missing Questions",
						"description": "Please ensure your assessment includes text-based questions for Verity to scan, and then try again."
					},
					"upload": {
						"title": "Upload Questions to Scan and Check",
						"description": "Download the <a>CSV template (1 KB)</a> and fill in any missing questions that Verity was not able to retrieve during the scan. Then upload and scan the file to start checking your questions.",
						"dragAndDrop": "Drag and Drop CSV File",
						"chooseFileButton": "Choose File",
						"upload": "Upload & Scan",
						"removeCSV": "Remove CSV",
						"removeCSVSuccess": "The uploaded CSV file has been successfully removed.",
						"errors": {
							"fileType": "The questions could not be uploaded. Please upload a CSV file and try again.",
							"missingHeaders": "Missing \"{{headerName}}\" header",
							"noQuestions": "Questions are required",
							"tooManyQuestions_one": "Verity expected {{count}} question, but received {{actual}}. Only the first question will be uploaded.",
							"tooManyQuestions_other": "Verity expected {{count}} questions, but received {{actual}}. Only the first {{count}} will be uploaded."
						},
						"success": "The questions have been successfully uploaded. Please review before continuing.",
						"questionPlaceholder": "Enter Question",
						"disabledSaveTooltip": "Question is required",
						"column": {
							"questionNumber": "Question Number",
							"question": "Questions",
							"action": "Actions"
						},
						"csv": {
							"fileName": "Questions-for-Scan-and-Check",
							"header": "Questions",
							"row1": "How many sides does a triangle have?",
							"row2": "What is the square root of 81?"
						}
					}
				},
				"review": {
					"title": "2. Review and Send Takedown Requests",
					"beforeScanDescription": "Review a detailed report showing which questions may be compromised and which are safe to use.",
					"afterScanDescription": "After scanning your assessment, some questions may require further review. Please check the report and click the button to request removal.",
					"beforeScanTooltip": "Scan the assessment",
					"searchFieldPlaceholder": "Search by question name",
					"emptyTitle": "Try different Question Name or Type",
					"emptyDescription": "No matches found. Please check a different question list or modify the question name and try again.",
					"noTypeQuestionsTitle": "Review Other Categories",
					"noCompromisedDescription": "No scanned questions were identified as compromised. Check the Frequently Used and Unique Questions tabs for more details.",
					"noFrequentlyUsedDescription": "No scanned questions were identified as Frequently Used. Check the Compromised and Unique Questions tabs for more details.",
					"noUniqueDescription": "No scanned questions were identified as Unique. Check the Compromised and Frequently Used Questions tabs for more details.",
					"qNumber": "Q{{number}}",
					"accessibility": {
						"expand": "Expand sources for Question {{number}}: {{question}}",
						"collapse": "Collapse sources for Question {{number}}: {{question}}",
						"linkAriaLabel": "See source {{sourceNum}} for question {{questionNum}}. Opens in a new tab."
					},
					"compromisedQuestions": {
						"title": "Compromised Questions",
						"description": "These questions were found on external websites and may be compromised. You may submit a DMCA (Digital Millennium Copyright Act) takedown request for them.",
						"disclaimer": "Disclaimer: DMCA Takedown requests are <b>optional</b> and do not guarantee complete removal of leaked content.",
						"sourcesFound": "<b>{{number}}</b> Compromised Source Found",
						"questionTakedownButton": "Submit Takedown Request",
						"sourceNumber": "Source {{number}}",
						"noEmail": "We couldn’t find an associated email. Please submit a removal request via <a>Google’s Report Content form</a>.",
						"googleReportFormAriaLabel": "Submit a removal request via Google's report content form. Opens in a new tab."
					},
					"freqUsedQuestions": {
						"title": "Frequently Used Questions",
						"description": "These questions are widely available online. We recommend editing or rephrasing them.",
						"foundInXWebsites": "Found in <b>{{number}}</b> Websites",
						"viewTopXWebsites": "View the top {{number}} related sites found in online search results."
					},
					"uniqueQuestions": {
						"title": "Unique Questions",
						"description": "These questions were not detected in any online searches. They are considered unique and unlikely to be found by students on the web."
					},
					"dmcaModal": {
						"title": "Submit Takedown Request",
						"description": "Submitting a DMCA takedown request is a serious action that requires careful consideration. To request a takedown, copy the email address and message template below, then send your request.",
						"emailAddress": "Email Address",
						"subject": "Subject",
						"subjectValue": "DMCA Takedown Notice",
						"message": "Message",
						"emailGreetings": "Hello ExampleBlog Support,",
						"emailBody1": "I am the copyright owner of the content titled <b>\"{{question}}\"</b>. I have a good-faith belief that the material in question infringes my copyright and has been used without authorization.",
						"emailBody1Plain": "I am the copyright owner of the content titled \"{{question}}\". I have a good-faith belief that the material in question infringes my copyright and has been used without authorization.",
						"emailBody2": "Copyrighted work: \"{{question}}\"",
						"emailBody3": "Infringing URL: <a>{{questionURL}}</a>",
						"emailBody3Plain": "Infringing URL: {{questionURL}}",
						"emailBody4": "Found on: {{localizedDate}}",
						"emailConclusion": "Please remove the infringing material and confirm when done.",
						"emailClosing": "Thanks",
						"cancelButton": "Cancel",
						"copyButtonTooltip": "Copy {{value}}"
					}
				}
			},
			"assessmentDecoyModalTSX": {
				"title": "Activate Decoy",
				"activatedTitle": "Decoy Activated",
				"activated": "Activated",
				"description": "Verity creates a secure decoy website without exposing its URL. Any test-taker who visits it will be automatically flagged below.",
				"activatedDescription": "Verity is ready to monitor activity. If a test-taker searches for your exam questions online and visits the decoy site, it will be flagged and appear below automatically.",
				"activate": "Activate Decoy",
				"activateFailed": "Decoy could not be activated. Please try again.",
				"activateSuccess": "The decoy website for “{{assessmentName}}” has been successfully activated.",
				"deactivate": "Deactivate",
				"deactivateFailed": "Decoy could not be deactivated. Please try again.",
				"deactivateSuccess": "The decoy website has been successfully deactivated.",
				"steps": {
					"stepLabel": "Step {{stepNumber}}",
					"completed": "Completed",
					"inProgress": "In Progress",
					"activating": {
						"title": "Activate Decoy Website",
						"description": "Verity scans your assessment questions and creates a decoy website."
					},
					"monitoring": {
						"title": "Monitor Activity",
						"description": "Verity monitors the decoy website during proctoring sessions."
					},
					"flagging": {
						"title": "Flag Actions",
						"description": "Test-takers visits during a proctoring session are flagged and listed."
					}
				},
				"confirmDeactivate": {
					"title": "Deactivate Decoy",
					"description": "Are you sure you want to deactivate the decoy website for this assessment?",
					"cancel": "Cancel",
					"deactivate": "Deactivate"
				},
				"activating": {
					"title": "Retrieving Assessment Questions",
					"description": "This process may take a moment."
				},
				"deactivating": {
					"title": "Deactivating Decoy Website",
					"description": "You can leave this page while we deactivate the decoy website."
				},
				"noQuestions": {
					"title": "Assessment Question Required",
					"description": "To create a decoy website, add at least one question to your assessment and try again."
				},
				"activity": {
					"title": "Decoy Website Activity",
					"description": "Review test-takers who visited the decoy website during the proctoring session below."
				},
				"noActivity": {
					"title": "Monitoring Is Active",
					"description": "Test-taker visits during a proctoring session will appear here."
				},
				"noFilteredActivity": {
					"title": "No Matching Results",
					"description": "Try broadening your search criteria to find what you are looking for."
				},
				"activityLoadingFailed": {
					"title": "Unable to Display Decoy Website Activity",
					"description": "The activity on your decoy website could not be displayed. Try refreshing the page to view it."
				},
				"searchBy": "Search by test-taker or question",
				"filterDate": "Filter by Date",
				"startDate": "Filter start date, enter date",
				"startDateSelect": "Select start date for filter",
				"endDate": "Filter end date, enter date",
				"endDateSelect": "Select end date for filter",
				"student": "Test-Taker",
				"question": "Question",
				"ipAddress": "IP Address",
				"time": "Date & Time"
			},
			"verityAssessmentTSX": {
				"successToastPublish": "The Verity Assessment has been saved and published successfully.",
				"successToastNoPublish": "The Verity Assessment has been saved.",
				"successToastUpdate": "The Verity Assessment has been updated successfully.",
				"partialSaveFail": "The Verity Assessment was saved, but some settings failed to save. Edit the assessment to try again.",
				"verityAssessmentStepFailToast": "Please resolve the errors in the {{stepName}} step before proceeding.",
				"errorToast": {
					"DB_FAIL": "Failed to create the assessment. Please try again.",
					"NO_COURSE": "Failed to create the assessment. Please re-select a course and try again.",
					"UPLOAD_SIZE": "Failed to upload instructions. One or more files exceed the maximum size limit of {{size}}MB.",
					"UPLOAD_FAIL": "Failed to upload instructions. Please try again."
				},
				"save": "Save",
				"saveAndPublish": "Save and Publish",
				"title": "Create a Verity Assessment",
				"assessmentType": {
					"title": "What type of assessment do you want to create?",
					"quizTitle": "Quiz",
					"quizDesc": "A structured set of questions completed within the platform for quick evaluation.",
					"assignmentTitle": "Assignment",
					"assignmentDesc": "An open-ended assessment where test-takers submit files like essays or papers."
				},
				"questions": {
					"questionTextPlaceholder": "Question {{quesionIdx}} Text",
					"selectType": "Select Question Type",
					"addQuestion": "Add Question",
					"generateWithAi": "Generate With AI",
					"regenerate": "Regenerate",
					"aiGradingBadge": "AI Grading",
					"duplicateQuestion": "Duplicate Question",
					"deleteQuestion": "Delete Question",
					"correctionPoints_one": "{{count}} point",
					"correctionPoints_other": "{{count}} points",
					"categories": {
						"autoGraded": {
							"label": "Auto-Graded",
							"description": "Responses are scored automatically against the correct answers you define."
						},
						"manualGraded": {
							"label": "Manually Graded",
							"description": "Responses require an instructor to review and assign a grade."
						}
					},
					"MultipleChoice": {
						"label": "Multiple Choice",
						"description": "Ask a question with options to choose from.",
						"defaultOption_one": "Option A",
						"defaultOption_two": "Option B"
					},
					"TrueFalse": {
						"label": "True or False",
						"description": "Provide a statement that is either true or false."
					},
					"Matching": {
						"label": "Matching",
						"description": "Ask participants to match items together."
					},
					"FillInTheBlank": {
						"label": "Fill in the Blank",
						"description": "Provide a statement with blanks to fill in."
					},
					"Essay": {
						"label": "Essay",
						"description": "Ask participants to provide a detailed, open-ended text response."
					},
					"Ordering": {
						"label": "Ordering",
						"description": "Ask participants to arrange a list of items into the correct sequence."
					},
					"AudioRecording": {
						"label": "Recording",
						"description": "Have participants respond by recording audio or video."
					},
					"FileSubmission": {
						"label": "File Upload",
						"description": "Ask participants to upload one or more files, such as a PDF or Word document."
					},
					"DragAndDrop": {
						"label": "Drag & Drop",
						"description": "Have participants drag and place items into their correct positions."
					},
					"Dropdown": {
						"label": "Dropdown",
						"description": "Let participants pick the correct answer from a dropdown for each blank."
					},
					"Spreadsheet": {
						"label": "Spreadsheet",
						"description": "Test participants' ability to complete a spreadsheet with the correct values."
					},
					"Coding": {
						"label": "Coding",
						"description": "Assess programming skills with a hands-on, written code response."
					},
					"howTo": {
						"label": "How to:",
						"description": "Create a question within the assessment.",
						"watchVideo": "Watch Video"
					},
					"aiGenerator": {
						"title": "Assessment Generation",
						"subtitle": "Automatically generate assessment questions based on your course content.",
						"formTitle": "Describe what you want to generate",
						"header": "What questions would you like generated?",
						"descriptionPlaceholder": "Describe the question content and difficulty that you would like to be generated",
						"defaultDescription": "Create questions based on the provided course material.",
						"numberOfQuestions": "Number of Questions",
						"generate": "Generate Questions",
						"cancel": "Cancel",
						"generateError": "Failed to generate questions. Please try again.",
						"noTokenError": "Please connect your LMS account before generating questions from course content.",
						"loading": {
							"title": "Generating questions...",
							"subtitle": "Analyzing course material",
							"progress": "{{value}} of {{max}}"
						},
						"extracting": {
							"title": "Finding Course Material",
							"subtitle": "Retrieving files from your course content..."
						},
						"selecting": {
							"title": "Select your course material",
							"subtitle": "Review the retrieved course files. Deselect any you do not want included in question generation."
						}
					},
					"editor": {
						"questionTypeLabel": "Question Type",
						"previewQuestion": "Preview Question",
						"editQuestion": "Back to Editor",
						"questionNumberLabel": "Question {{number}}",
						"allowMultipleAnswer": "Allow Multiple Answers",
						"pointsLabel": "Points",
						"customPointsLabel": "Custom Points",
						"minPointsError": "Question needs to be worth at least 1 point.",
						"pointsUnit": "Points",
						"ungraded": "Ungraded",
						"correctionPoints_one": "{{count}} Point",
						"correctionPoints_other": "{{count}} Points",
						"custom": "Custom",
						"questionPlaceholder": "Ask your question here...",
						"optionLabel": "Option",
						"orderingItemLabel": "Item {{number}}",
						"addOption": "Add Option",
						"addItem": "Add Item",
						"addBlank": "Add Blank",
						"deleteOptionLabel": "Delete option",
						"matching": {
							"premise": "Premise",
							"correctResponse": "Correct Response",
							"distractor": "Distractor",
							"addMatchingPair": "Add Matching Pair",
							"addDistractor": "Add Distractor",
							"premisePlaceholder": "Enter premise {{index}}",
							"responsePlaceholder": "Enter response {{index}}",
							"deletePair": "Delete matching pair",
							"deleteDistractor": "Delete distractor",
							"defaultPremise": "Option {{index}}",
							"defaultResponse": "Response {{index}}"
						},
						"fitb": {
							"defaultQuestionText": "Ready to jump in? Just fill in the {{blank}} to complete this statement.",
							"defaultAnswer": "blank",
							"correctAnswers": "Correct Answer",
							"correctAnswersDesc": "Enter the answer participants can provide to receive credit. Add additional answers if needed.",
							"blankLabel": "Blank {{id}}",
							"answerPlaceholder": "Enter a correct response",
							"deleteAnswer": "Delete Correct Answer",
							"addAnotherAnswer": "Add Another Answer",
							"addBlankTooltip": "Insert a blank field"
						},
						"dragAndDrop": {
							"blankLabel": "Drop Field {{id}}",
							"addBlankButton": "Add Drop Field",
							"correctAnswers": "Correct Answer",
							"correctAnswersDesc": "Add the correct answer for each blank. Students will be graded based on these answers.",
							"answerPlaceholder": "Enter a correct response",
							"deleteAnswer": "Delete Correct Answer",
							"incorrectAnswerTitle": "Include Incorrect Answer",
							"incorrectAnswerDesc": "To make the question more challenging, you can add incorrect answers for the blank below.",
							"incorrectAnswerPlaceholder": "Enter incorrect word here",
							"addIncorrectAnswer": "Add",
							"deleteIncorrectAnswer": "Delete incorrect answer"
						},
						"dropdown": {
							"blankLabel": "Dropdown {{id}}",
							"addBlankButton": "Add Dropdown",
							"correctAnswers": "Correct Answer",
							"correctAnswersDesc": "Add the correct answer for each blank. Students will select an answer from the available options.",
							"answerPlaceholder": "Enter a correct response",
							"deleteAnswer": "Delete Correct Answer",
							"incorrectAnswerTitle": "Include Incorrect Answer",
							"incorrectAnswerDesc": "To make the question more challenging, add incorrect answers for the blank below.",
							"incorrectAnswerPlaceholder": "Enter incorrect word here",
							"addIncorrectAnswer": "Add",
							"deleteIncorrectAnswer": "Delete incorrect answer"
						},
						"audioRecording": {
							"recordingModeLabel": "Set The Recording Type",
							"recordingModeAriaLabel": "Recording type",
							"modeAudio": "Audio Recording",
							"modeVideo": "Video Recording",
							"maxLengthLabel": "Set The Maximum Recording Length",
							"maxLengthAriaLabel": "Maximum recording length",
							"unitAriaLabel": "Maximum recording length unit",
							"minLengthLabel": "Set The Minimum Recording Length",
							"minLengthAriaLabel": "Minimum recording length",
							"minUnitAriaLabel": "Minimum recording length unit",
							"unitSecond": "Second",
							"unitMinute": "Minute"
						},
						"fileSubmission": {
							"maxFilesLabel": "How Many Files Can Be Uploaded",
							"maxFilesHint": "(Max {{max}} Files)",
							"maxFilesAriaLabel": "Maximum number of files",
							"maxFileSizeLabel": "File Size",
							"maxFileSizeHint": "(Max {{max}} MB For Each File)",
							"maxFileSizeAriaLabel": "Maximum file size in megabytes",
							"acceptedFormatsLabel": "Accepted File Formats",
							"selectFormats": "Select Formats"
						},
						"spreadsheet": {
							"columnLabel": "Column",
							"rowLabel": "Row",
							"columnAriaLabel": "Number of columns",
							"rowAriaLabel": "Number of rows",
							"tableSetupTitle": "Table Setup",
							"tableSetupDescFill": "Enter information in cells participants can view, and mark cells blank for participants to complete.",
							"tableSetupDescSet": "Check the cells participants must fill in, then type the correct answer. Participant entries are graded against these values.",
							"setCorrectAnswersLabel": "Set correct answers",
							"cellPlaceholder": "Enter Content",
							"cellCheckboxAriaLabel": "Mark Row {{row}}, Column {{column}} as a cell participants must complete"
						},
						"presets": {
							"MultipleChoice": [
								{
									"questionText": "Which word is a color?",
									"correctOption": "Blue",
									"options": ["Blue", "Chair"]
								},
								{
									"questionText": "Which of these is a fruit?",
									"correctOption": "Apple",
									"options": ["Apple", "Table"]
								},
								{
									"questionText": "Which animal can fly?",
									"correctOption": "Bird",
									"options": ["Bird", "Turtle"]
								},
								{
									"questionText": "Which item is used for writing?",
									"correctOption": "Pencil",
									"options": ["Pencil", "Pillow"]
								},
								{
									"questionText": "Which of these is a type of weather?",
									"correctOption": "Rain",
									"options": ["Rain", "Bicycle"]
								}
							],
							"TrueFalse": [
								{
									"questionText": "10 + 5 = 14.",
									"correctAnswer": "False"
								},
								{
									"questionText": "A triangle has three sides.",
									"correctAnswer": "True"
								},
								{
									"questionText": "20 is greater than 15.",
									"correctAnswer": "True"
								}
							],
							"FillInTheBlank": [
								{ "questionText": "A baby dog is called a [Blank 1] .", "answer": "puppy" },
								{ "questionText": "A baby cat is called a [Blank 1] .", "answer": "kitten" },
								{ "questionText": "A person who teaches students is called a [Blank 1] .", "answer": "teacher" },
								{ "questionText": "A person who writes books is called an [Blank 1] .", "answer": "author" },
								{ "questionText": "A place where books are kept is called a [Blank 1] .", "answer": "library" },
								{ "questionText": "A word that means the opposite of hot is [Blank 1] .", "answer": "cold" }
							],
							"Matching": [
								{
									"questionText": "Match the baby animal with its correct name:",
									"pairs": [
										{
											"premise": "Baby cat",
											"response": "Kitten"
										},
										{
											"premise": "Baby dog",
											"response": "Puppy"
										},
										{
											"premise": "Baby cow",
											"response": "Calf"
										},
										{
											"premise": "Baby sheep",
											"response": "Lamb"
										}
									]
								}
							],
							"Essay": [
								{
									"questionText": "Explain how the human immune system fights a virus."
								},
								{
									"questionText": "Evaluate the pros and cons of remote work."
								},
								{
									"questionText": "Discuss the impact of social media on society."
								}
							],
							"Ordering": [
								{
									"questionText": "Put these days of the week in order.",
									"options": [
										{
											"text": "Tuesday",
											"order": 1
										},
										{
											"text": "Thursday",
											"order": 3
										},
										{
											"text": "Saturday",
											"order": 5
										},
										{
											"text": "Wednesday",
											"order": 2
										},
										{
											"text": "Friday",
											"order": 4
										}
									]
								},
								{
									"questionText": "Arrange these words in alphabetical order (A to Z).",
									"options": [
										{
											"text": "Banana",
											"order": 2
										},
										{
											"text": "Apple",
											"order": 1
										},
										{
											"text": "Donut",
											"order": 4
										},
										{
											"text": "Cherry",
											"order": 3
										}
									]
								},
								{
									"questionText": "Arrange these numbers from smallest to largest.",
									"options": [
										{ "text": "15", "order": 3 },
										{ "text": "3", "order": 1 },
										{ "text": "42", "order": 4 },
										{ "text": "8", "order": 2 }
									]
								}
							],
							"AudioRecording": [
								{ "questionText": "Record a 30-second introduction about yourself and your background." },
								{ "questionText": "Explain in your own words how photosynthesis works." },
								{ "questionText": "Describe your favorite book and why you enjoyed it." }
							],
							"FileSubmission": [
								{ "questionText": "Upload your completed lab report." },
								{ "questionText": "Submit your project proposal document." },
								{ "questionText": "Upload your assignment file for review." }
							],
							"Coding": [
								{ "questionText": "Write a function that returns the sum of two numbers." },
								{ "questionText": "Write a function that reverses a string." },
								{ "questionText": "Write a function that checks if a number is prime." }
							],
							"DragAndDrop": [
								{
									"questionText": "A baby dog is called a [Blank 1], and a baby cat is called a [Blank 2].",
									"options": [
										{ "text": "puppy", "blankId": 1, "weightage": 0.5 },
										{ "text": "kitten", "blankId": 2, "weightage": 0.5 },
										{ "text": "cub" }
									]
								},
								{
									"questionText": "The closest planet to the sun is [Blank 1], and the largest planet is [Blank 2].",
									"options": [
										{ "text": "Mercury", "blankId": 1, "weightage": 0.5 },
										{ "text": "Jupiter", "blankId": 2, "weightage": 0.5 },
										{ "text": "Mars" }
									]
								}
							],
							"Dropdown": [
								{
									"questionText": "An apple is a type of [Blank 1], and a car is a type of [Blank 2].",
									"blanks": [
										{
											"blankId": 1,
											"options": [
												{ "text": "fruit", "weightage": 0.5 },
												{ "text": "animal", "weightage": 0 }
											]
										},
										{
											"blankId": 2,
											"options": [
												{ "text": "vehicle", "weightage": 0.5 },
												{ "text": "fruit", "weightage": 0 }
											]
										}
									]
								},
								{
									"questionText": "Distance is measured in [Blank 1], and weight is measured in [Blank 2].",
									"blanks": [
										{
											"blankId": 1,
											"options": [
												{ "text": "meters", "weightage": 0.5 },
												{ "text": "seconds", "weightage": 0 }
											]
										},
										{
											"blankId": 2,
											"options": [
												{ "text": "kilograms", "weightage": 0.5 },
												{ "text": "liters", "weightage": 0 }
											]
										}
									]
								}
							],
							"Spreadsheet": [
								{
									"questionText": "Fill in the missing total in the table below.",
									"rows": [
										[{ "text": "Jan Units" }, { "text": "Feb Units" }, { "text": "Total" }],
										[{ "text": "120" }, { "text": "90" }, { "text": "210", "isGradeCell": true, "weightage": 1 }]
									]
								},
								{
									"questionText": "Fill in the missing average score in the table below.",
									"rows": [
										[{ "text": "Test 1" }, { "text": "Test 2" }, { "text": "Average" }],
										[{ "text": "80" }, { "text": "90" }, { "text": "85", "isGradeCell": true, "weightage": 1 }]
									]
								}
							]
						},
						"aiGrading": {
							"setupButton": "Setup AI Grading",
							"configureButton": "Configure AI Grading",
							"drawerTitle": "Setup AI Grading",
							"enableLabel": "Enable AI Grading",
							"enableDescription": "Automatically grade responses using AI and your grading guidelines.",
							"on": "On",
							"off": "Off",
							"guidelineLabel": "Grading Guideline:",
							"guidelinePlaceholder": "e.g., “Answer must include A, B, and C. Give 0 points if any are missing.”",
							"cancel": "Cancel",
							"saveChanges": "Save Changes",
							"guidelineRequiredTooltip": "Please enter grading guidelines to save changes."
						},
						"toolbar": {
							"undo": "Undo",
							"redo": "Redo",
							"bold": "Bold",
							"italic": "Italic",
							"underline": "Underline",
							"textColor": "Text Color",
							"highlightColor": "Highlight Color",
							"insertFormula": "Insert Formula",
							"clearFormatting": "Clear Formatting"
						},
						"error": {
							"noQuestionType": "Question {{questionNo}}: Please select a question type.",
							"emptyQuestionText": "Question {{questionNo}}: Please provide a question text.",
							"noOptions": "Question {{questionNo}}: Please provide at least two options for Multiple Choice questions.",
							"noItems": "Question {{questionNo}}: Please provide at least two items for Ordering questions.",
							"emptyOptionText": "Question {{questionNo}}: Please fill in Option {{optionNo}}.",
							"noQuestion": "Question text cannot be empty.",
							"noCorrectOption": "Question {{questionNo}}: Please select the correct option.",
							"emptyFitbBlanks": "Question {{questionNo}}: Please insert at least one blank into the question.",
							"emptyFitbAnswer": "Question {{questionNo}}: Please fill in the answer for Blank {{blankId}}.",
							"emptyMatchingPremise": "Question {{questionNo}}: Please fill in Premise:{{premiseNo}}",
							"emptyMatchingResponse": "Question {{questionNo}}: Please fill in Response:{{responseNo}}",
							"emptyOrderingItemText": "Question {{questionNo}}: Please fill in Item {{itemNo}}",
							"emptyDragAndDropBlanks": "Question {{questionNo}}: Please add at least one Drop Field into the question.",
							"emptyDragAndDropAnswer": "Question {{questionNo}}: Please fill in the answer for Drop Field {{blankId}}.",
							"emptyDropdownBlanks": "Question {{questionNo}}: Please add at least one Dropdown into the question.",
							"emptyDropdownAnswer": "Question {{questionNo}}: Please fill in the answer for Dropdown {{blankId}}.",
							"noGradedCells": "Question {{questionNo}}: Please select at least one cell for participants to complete.",
							"emptySpreadsheetAnswer": "Question {{questionNo}}: Enter a correct answer for cell {{cell}} to continue.",
							"emptySpreadsheetAnswers": "Question {{questionNo}}: Enter correct answers for all selected cells ({{cells}}) to continue."
						}
					}
				},
				"assessmentDetails": {
					"courseGrade": {
						"title": "Course and Grade",
						"selectCourse": "Select Course",
						"courseError": "Please choose a course",
						"selectCourseDesc": "Select a course to sync this assessment with.",
						"syncText": "Sync With Gradebook",
						"module": "Module",
						"moduleDesc": "Select a D2L Brightspace module.",
						"noModule": "The selected course does not have a module. Please create a module to continue.",
						"createModule": "Create Module",
						"create": "Create",
						"createDesc": "Enter a module name to create it in this course.",
						"modulePlaceholder": "Enter module name",
						"cancel": "Cancel",
						"moduleError": "Please choose a module",
						"moduleCreateSuccess": "{{name}} has been successfully created.",
						"moduleCreateError": "Failed to create {{name}}. Please try again.",
						"section": "Section",
						"sectionDesc": "Select a Moodle section.",
						"noSection": "The selected course does not have a section. Please create a section to continue.",
						"createSection": "Create Section",
						"createSectionDesc": "Enter a section name to create it in this course.",
						"sectionPlaceholder": "Enter section name",
						"sectionError": "Please choose a section",
						"assignmentMaxScore": "Points",
						"assignmentMaxScorePlaceholder": "Enter maximum points",
						"assignmentMaxScoreError": "Please enter a number between 0 and 1000."
					},
					"generalInfo": {
						"title": "General Information",
						"assessmentTitle": "Assessment Title",
						"assessmentTitlePlaceholder": "Enter assessment title",
						"assessmentTitleError": "Assessment title cannot be empty.",
						"defaultTitle": "Draft: {{date}} - {{time}}",
						"assessmentDesc": "Assessment Description (Optional)",
						"assessmentDescSubtitle": "Provide a description of the assessment to participants.",
						"assessmentDescPlaceholder": "Describe the assessment..."
					},
					"timing": {
						"title": "Availability and Timing",
						"assessmentDuration": "Set Assessment Duration",
						"assessmentDurationDesc": "Choose the total time a student needs to complete the test.",
						"hours": "Hours",
						"minutes": "Minutes",
						"dueDate": "Assessment Due Date",
						"dueDateDesc": "Choose the date and time the assessment releases.",
						"late": "Allow Late Submissions",
						"lateDesc": "Decide if students can still submit after the due date has passed.",
						"acceptSubmission": "Accept submission by",
						"error": {
							"noStartDate": "Start date is required.",
							"noEndDate": "End date is required.",
							"endBeforeStart": "End date must be after start date.",
							"startInPast": "Start date cannot be in the past.",
							"endInPast": "End date cannot be in the past.",
							"noLateSubmissionDate": "Late submission date is required when late submissions are allowed.",
							"lateSubmissionBeforeEnd": "Late submission date must be after due date.",
							"lateSubmissionInPast": "Late submission date cannot be in the past.",
							"invalidHourInput": "Please enter a valid number for hours.",
							"invalidMinuteInput": "Please enter a valid number for minutes.",
							"invalidHour": "Hours must be greater than or equal to 0.",
							"invalidMinute": "Minutes must be between 0 and 59.",
							"noDuration": "Assessment duration is required."
						},
						"startDateAriaLabel": "Select the date and time when the assessment will be available.",
						"endDateAriaLabel": "Select the date and time when the assessment will no longer be available."
					},
					"delivery": {
						"title": "Question Delivery",
						"shuffle": "Shuffle Questions",
						"qPerPage": "Questions Per Page"
					},
					"submission": {
						"title": "Attempts and Submission",
						"multiple": "Allow Multiple Attempts",
						"multipleDesc": "Allow test-takers to take assessments more than one time.",
						"unlimited": "Unlimited",
						"fileFormat": "Restrict File Formats",
						"fileFormatDesc": "Enable and enter file formats to restrict submissions, or disable to allow all file types.",
						"fileFormatPlaceholder": "Add allowed file formats",
						"showScore": "Show Score After Submission",
						"showScoreDesc": "Test-takers will see their score immediately after completing the quiz.",
						"gradeBook": "Score Publishing",
						"gradeBookDesc": "Select which attempts should be synced to the Verity gradebook.",
						"first": "First Attempt",
						"latest": "Most Recent Attempt",
						"highest": "Attempt with Highest Score"
					}
				},
				"addInstructions": {
					"description": "Enter or upload your instructions below, and include any supporting media if needed. (Optional)",
					"placeholder": "Input instructions",
					"addMedia": "Attach Files",
					"addMediaTooltip": "Max {{number}} allowed.",
					"uploadedFile": "Uploaded File",
					"fileTooLarge": "File too large. Max Size: {{size}}.",
					"tooManyFiles": "Too many files. Max {{number}} allowed."
				},
				"review": "Assessment Details",
				"backToReview": "Back to Review"
			},
			"settingsPageTSX": {
				"noSettings": "No settings available.",
				"discardChange": "Discard Changes",
				"saveChange": "Save Changes",
				"resetting": "Resetting...",
				"resetInstitute": "All unsaved institution settings have been discarded successfully.",
				"resetThirdParty": "All unsaved third party settings have been discarded successfully.",
				"resetCourse": "All unsaved course settings have been discarded successfully.",
				"resetScope": "All unsaved scope settings have been discarded successfully.",
				"resetProfiles": "All unsaved proctoring profile changes have been discarded successfully.",
				"resetUser": "All unsaved user settings have been discarded successfully.",
				"saving": "Saving settings...",
				"saveInstitute": "Your institution settings have been successfully saved.",
				"saveThirdParty": "Your third party settings have been successfully saved.",
				"saveScope": "Your scope settings have been successfully saved.",
				"saveProfiles": "Your proctoring profiles have been successfully saved.",
				"saveUser": "Your user settings have been successfully saved.",
				"saveCourse": "Your course settings have been successfully saved.",
				"duplicateCourse": "The course already exists in Verity’s scope settings.",
				"emptyCourse": "Please enter a course ID or URL to include in the Scope Settings.",
				"addCourse": "The course has been successfully added to Verity’s scope settings.",
				"removeCourse": "{{numOfCourse}} been successfully deleted from Verity’s scope settings.",
				"selectAllCourses": "Select all courses",
				"selectCourse": "Select course",
				"errorSave": "Your settings could not be saved. ",
				"checkConnect": "Please check your internet connection and try again. If this issue persists, please contact YuJa Support.",
				"help": " If you receive this error again, please contact YuJa support for help.",
				"defaultError": "An error occurred while adding the course.",
				"invalidUrl": "Please enter a valid URL.",
				"invalidCourse": "Please enter a valid course ID.",
				"invalidProtocol": "Please enter a URL starting with HTTPS."
			},
			"settingsSearch": {
				"placeholder": "Search setting",
				"label": "Search settings",
				"summary": "{{matches}} across {{tabs}}",
				"matchCount_one": "{{count}} Match",
				"matchCount_other": "{{count}} Matches",
				"tabCount_one": "{{count}} Tab",
				"tabCount_other": "{{count}} Tabs",
				"resultCount_one": "{{count}} Result",
				"resultCount_other": "{{count}} Results",
				"noResults": "No settings match your search"
			},
			"portalTopBarTSX": {
				"openNewTab": "Open in new tab",
				"setup": "User Setup",
				"browserExtension": "Browser Extension",
				"lockdownApp": "Desktop Lockdown App",
				"mobileApp": "Mobile Lockdown App",
				"verity": "Verity",
				"verityLogoAriaLabel": "YuJa Verity",
				"course": "Course",
				"switchCourse": "Switch course",
				"switchCourseDescription": "Select a course from the list below to switch.",
				"signOut": "Sign Out"
			},
			"portalMenuTSX": {
				"portalMenu": "Portal menu",
				"navAriaLabel": "Sidebar navigation"
			},
			"portalBannerTSX": {
				"close": "Close"
			},
			"backBannerTSX": {
				"back": "Back"
			},
			"visualizerBannerTSX": {
				"setupGuideBanner": {
					"label": "Complete the required setup steps to enable Verity to successfully proctor assessments.",
					"button": "Complete Setup"
				},
				"visualizerBanner": {
					"label": "LMS Visualizer activity not detected in the last 24 hours. This could mean there were no visits to a Verity-enabled course, or the integration is not working correctly.",
					"button": "View Integration"
				}
			},
			"feedbackButtonTSX": {
				"feedback": "Feedback",
				"modalHeader": "Provide Feedback",
				"satisfactionHeader": "How satisfied are you with our product?",
				"categoryHeader": "Please select the feedback category.",
				"summaryHeader": "Provide us with a summary of your feedback.",
				"summaryPlaceholder": "Write your summary here",
				"detailsHeader": "Would you like to share any additional thoughts?",
				"detailsPlaceholder": "Please give as much detail as you can about your idea or suggestion. We'll reach out to you.",
				"feedbackErrorHeader": "Unfortunately your feedback could not be recorded at this time.",
				"feedbackErrorDescription": "If this happens again please contact support@yuja.com.",
				"feedbackSubmittedHeader": "Thank You!",
				"feedbackSubmittedDescription": "We appreciate your feedback.",
				"cancel": "Cancel",
				"submit": "Submit",
				"close": "Close",
				"satisfactionLevel": {
					"poor": "Poor",
					"satisfied": "Satisfied",
					"good": "Good",
					"excellent": "Excellent"
				},
				"feedbackCategory": {
					"suggestion": "Suggestion",
					"bug": "Bug",
					"comment": "Comment",
					"other": "Other"
				}
			},
			"eventBannerTSX": {
				"previousButton": "Previous Event Banner",
				"nextButton": "Next Event Banner",
				"closeButtonAriaLabel": "Close",
				"ariaLabel": "Event Banners"
			},
			"quickSetupGuideTSX": {
				"closeToast": "The Quick Setup Guide can be found in your profile card at the top-right corner.",
				"noQuizCreated": "No setup quiz has been created yet. Please create a quiz using the setup guide and try again."
			},
			"videoPopoverTSX": {
				"howTo": "How to: ",
				"watchVideo": "Watch Video",
				"popoutButtonAriaLabel": "Open external link",
				"closeButtonAriaLabel": "Close"
			},
			"supportModalTSX": {
				"title": "YuJa Support Is Here to Help",
				"subtitle": "For product assistance or general inquiries, please select one of the support options below.",
				"liveChat": {
					"title": "Live Chat",
					"description": "Connect with a support representative in real time for immediate assistance.",
					"buttonText": "Start Chat"
				},
				"sendEmail": {
					"title": "Send Email",
					"description": "Submit your question and a member of our support team will respond shortly.",
					"buttonText": "Send Inquiry"
				},
				"productDocs": {
					"title": "Product Docs",
					"description": "Access product guides, technical documentation, and frequently asked questions.",
					"buttonText": "Visit Help Center"
				},
				"callSupport": {
					"title": "Call Support",
					"description": "Contact a support representative available 24/7 for assistance.",
					"buttonText": "Call Us"
				},
				"callUs": {
					"title": "Call Us",
					"subtitle": "When contacting YuJa Support by phone, you will be asked to provide an access code to verify your request.",
					"accessCodeText": "Please have the access code ready for your call.",
					"accessCodeButton": "Access Code: {{code}}",
					"accessCodeUnavailable": "Access Code: Unavailable",
					"number": "{{number}} (Toll Free)",
					"usAndCanada": "US and Canada",
					"unitedKingdom": "United Kingdom",
					"netherlands": "Netherlands",
					"international": "International",
					"fallback": ""
				}
			},
			"mobileWorkflowScreen": {
				"authentication": {
					"incompleteTitle": "Connect With Canvas",
					"completeTitle": "Connected With Canvas",
					"incompleteDescription": "Press the button below to connect your account with Canvas. ",
					"completeDescription": "Your Verity account is connected with Canvas",
					"buttonText": "Connect"
				},
				"download": {
					"title": "Download the Verity App",
					"description": "If you do not already have the Verity app on your device, download it for iOS or Android to get started."
				},
				"launch": {
					"title": "Launch the Verity App",
					"description": "Press the button below to launch the Verity app and begin your assessment.",
					"buttonText": "Launch App"
				},
				"leave": {
					"title": "Mobile Unsupported",
					"description": "This assessment cannot be taken on a mobile device. To continue, please switch to a supported platform such as the browser extension or the desktop lockdown application."
				},
				"openAppInstructions": "Once the app is installed, press the button below to launch it.",
				"openAppButton": "Launch App",
				"support": "Still having trouble? Contact YuJa Support"
			},
			"roster": {
				"title": "Roster Management",
				"description": "View and manage users, roles, and permissions across your platform.",
				"statistics": {
					"totalUsers": "Total Users",
					"totalAdmins": "Total Admins",
					"totalInstructors": "Total Instructors",
					"totalStudents": "Total Test-Takers"
				},
				"search": {
					"placeHolder": "Search by LMS user ID or email"
				},
				"filter": {
					"roles": {
						"title": "User Type",
						"state": {
							"ADMIN": "Admin",
							"INSTRUCTOR": "Instructor",
							"STUDENT": "Test-Taker",
							"INVALID": "N/A"
						}
					},
					"lock": {
						"title": "Locked Status",
						"state": {
							"locked": "Locked",
							"unlocked": "Not Locked"
						}
					}
				},
				"table": {
					"headers": {
						"lmsUserId": "LMS User ID",
						"email": "Email",
						"name": "Name",
						"role": "User Role",
						"courses": "Courses",
						"locked": "Locked Status",
						"actions": "Actions"
					},
					"row": {
						"invalid": "-",
						"locked": "Locked",
						"unlocked": "Not Locked",
						"allCourses": "All",
						"searchCourses": "Search courses",
						"noCoursesFound": "No courses found",
						"role": {
							"verity": {
								"ADMIN": "Admin",
								"INSTRUCTOR": "Instructor",
								"STUDENT": "Test-taker",
								"INVALID": "N/A"
							},
							"candidate": {
								"ADMIN": "Admin",
								"INSTRUCTOR": "Interviewer",
								"STUDENT": "Candidate",
								"INVALID": "N/A"
							}
						},
						"notLtiSaml": "This user is not in the LMS or SAML roster.",
						"mfaTooltip": {
							"enabled": "MFA is enabled for this user.",
							"disabled": "MFA is not enabled for this user."
						},
						"actions": {
							"resetMFA": "Reset MFA",
							"resettingMFA": "Resetting",
							"edit": "Edit"
						},
						"mfaReset": {
							"success": "MFA has been reset for {{name}}.",
							"error": "Couldn't reset MFA. Please try again."
						}
					},
					"error": {
						"noResults": "No Users Found",
						"noResultsDescription": "Try adjusting your search criteria and filters.",
						"errorLoading": "Roster Not Available",
						"errorLoadingDescription": "The roster could not be loaded at this time. Please refresh the page and try again."
					}
				},
				"createUser": {
					"createUser": "Create User",
					"description": "Enter email, name, and select a role for the new user. An email will be sent to them to complete the sign-up process.",
					"email": "Email",
					"emailFormatError": "Enter a valid email",
					"firstName": "First Name",
					"firstNameRequiredError": "First name is required",
					"lastName": "Last Name",
					"role": "User Role",
					"cancel": "Cancel",
					"create": "Create",
					"createSuccess": "{{name}} has been successfully created.",
					"emailExists": "User with this email has already been created.",
					"createFail": "This user could not be created. Please try again.",
					"errors": {
						"serviceUnavailable": "Service unavailable. Please try again.",
						"fetchUserInfoFailed": "Failed to fetch linked user info. Please try again.",
						"userExistsInInstitution": "User already exists in this institution.",
						"roleConfigFailed": "Role configuration failed to load. Please try again.",
						"emailAlreadyRegistered": "Email already registered. Contact support to add.",
						"genericCreationFailed": "User creation failed. Please try again.",
						"partialFailure": "User creation failed. Contact support before retrying.",
						"welcomeEmailFailed": "User created, but welcome email failed. Use 'Forgot Password' to set the password."
					}
				},
				"editUser": {
					"title": "Edit User",
					"email": "Email",
					"emailFormatError": "Enter a valid email",
					"firstName": "First Name",
					"firstNameRequiredError": "First name is required",
					"lastName": "Last Name",
					"role": "User Role",
					"cancel": "Cancel",
					"save": "Save Changes",
					"updateSuccess": "{{name}} has been successfully updated.",
					"updateFailed": "This user could not be updated. Please try again.",
					"lockedStatus": "Locked Status",
					"off": "Off",
					"on": "On"
				}
			},
			"integrationSettings": {
				"saml": {
					"main": {
						"header": "SSO Integration",
						"fields": {
							"allowAuthenticationViaSSO": {
								"title": "Allow Authentication Via SSO",
								"subTitle": "If enabled, users will be able to authenticate via SSO",
								"toggle": {
									"on": "Enabled",
									"off": "Disabled"
								}
							},
							"metadataLocation": {
								"title": "Metadata Location",
								"subTitle": "The URL to retrieve the Identity Provider's metadata"
							},
							"nameIdFormat": {
								"title": "Name ID Format",
								"subTitle": "The Name ID format"
							}
						}
					},
					"identityProvider": {
						"header": "Identity Provider Information",
						"fields": {
							"entityId": {
								"title": "Entity ID",
								"subTitle": "The unique identifier for the Identity Provider"
							},
							"signingCertificateFingerprint": {
								"title": "Signing Certificate SHA-1 Fingerprint",
								"subTitle": "The SHA-1 fingerprint of the X.509 public certificate"
							},
							"singleSignOnServiceLocation": {
								"title": "Single Sign On Service Location",
								"subTitle": "The URL to receive the SAML authentication request"
							}
						}
					},
					"serviceProvider": {
						"header": "Service Provider Information",
						"fields": {
							"issuer": {
								"title": "Issuer",
								"subTitle": "The URL that uniquely identifies the Verity Service Provider",
								"copy": "Copy Issuer"
							},
							"assertionConsumerUrl": {
								"title": "Assertion Consumer URL",
								"subTitle": "The URL to receive the SAML assertion response",
								"copy": "Copy Assertion Consumer URL"
							}
						}
					},
					"attributeMapping": {
						"header": "User Provisioning",
						"fields": {
							"name": {
								"title": "Name Attribute",
								"subTitle": "The SAML attribute for the user's name"
							},
							"email": {
								"title": "Email Attribute",
								"subTitle": "The SAML attribute for the user's email"
							},
							"role": {
								"title": "Role Attribute",
								"subTitle": "The SAML attribute for the user's role"
							}
						}
					},
					"roleMapping": {
						"header": "Role Mapping",
						"fields": {
							"ADMIN": {
								"title": "Admin Mapping",
								"subTitle": "The role mapped to an administrator in Verity"
							},
							"INSTRUCTOR": {
								"title": "Instructor Mapping",
								"subTitle": "The role mapped to an instructor in Verity"
							},
							"STUDENT": {
								"title": "Test-Taker Mapping",
								"subTitle": "The role mapped to a test-taker in Verity"
							}
						}
					},
					"ltiCrossLinking": {
						"header": "Cross Integration with LTI 1.3",
						"fields": {
							"samlAttribute": {
								"title": "SSO Linking Attribute",
								"subTitle": "The SAML attribute for the ID used for mapping users across platforms"
							},
							"ltiAttribute": {
								"title": "LTI 1.3 Linkage Custom Field",
								"subTitle": "The LTI 1.3 custom field containing the ID used for mapping users across platforms"
							},
							"emailFallback": {
								"title": "Fallback to email",
								"subTitle": "If enabled, fallback to email address to link users when no linkage attribute matches."
							}
						}
					},
					"toast": {
						"success": "Your SAML integration settings have been successfully saved.",
						"error": "Your SAML integration settings could not be saved.",
						"discard": "Your SAML integration settings have been successfully discarded."
					}
				}
			},
			"selectCourseModalTSX": {
				"title": "Select Course",
				"id": "Course ID",
				"name": "Course Name",
				"search": "Search for course",
				"cancel": "Cancel",
				"noResults": "No Courses Found."
			},
			"takeAssessment": {
				"exemptedTitle": "Verity Assessment",
				"submit": "Submit Assessment",
				"start": "Start Assessment",
				"yourAttemptsInfinite": "Your Attempts ({{count}})",
				"yourAttempts": "Your Attempts ({{count}}/{{max}})",
				"attemptNumber": "Attempt {{number}}",
				"attemptTime": "Submitted: {{date}} at {{time}}",
				"noFiles": "No Files Uploaded",
				"submittedFiles": "Submitted Files",
				"assignmentSubtitle": "Review the instructor’s instructions carefully before uploading your response.",
				"uploadTitle": "Your Response",
				"uploadSubtitle": "Upload your response as a file by directly uploading a file from your computer or use the QR code to upload it from a mobile device.",
				"yourFiles": "Your Files ({{count}})",
				"yourFilesDesc": "Upload up to {{count}} Files (max 10MB each)",
				"acceptedFormats": "Accepted file formats: {{formats}}",
				"acceptedFormatsAny": "Accepted file formats: Any",
				"maxFilesUploadedTitle": "Maximum Files Uploaded",
				"maxFilesUploadedDesc": "You have uploaded the maximum number of files allowed for this assessment ({{count}}).",
				"uploadFile": "Choose File to Upload",
				"qrCodeTitle": "Scan QR Code",
				"qrCodeDesc": "Scan the QR Code to upload your response.",
				"error": {
					"noAssessmentFound": "Something went wrong and we couldn't find your assessment. Please try again.\nIf the issue persists, contact your instructor or YuJa Support for help.",
					"isDeleted": "This assessment has been deleted by your instructor and is no longer available.",
					"notPublished": "This assessment is not published yet. Please wait for your instructor to publish it.",
					"beforeStart": "Your assessment has not started yet. Please wait for the availability window to open.",
					"afterEnd": "The assessment due date has passed and submissions are no longer accepted.",
					"sessionStarts": "Assessment Opens In",
					"attemptsExceeded": "You have reached the maximum number of attempts allowed for this assessment.",
					"proctoringStartFail": "There was an issue starting your proctoring session. Please try again. If this issue persists, contact your instructor or YuJa Support for help.",
					"loading": "Setting up your assessment. Please wait a moment.",
					"wrongPlatform": "This assessment cannot be taken on this device or browser."
				},
				"lateSubmission": "This assessment’s due date has passed, and your submission will be marked as late.",
				"assessment": "Assessment",
				"course": "Course",
				"details": "Details",
				"finishTitle": "Your Assessment Is Complete",
				"finishSubtitle": "Your response has been submitted successfully. You may now close this tab or return to your assessments.",
				"finishButton": "View Attempts",
				"uploadFail": "Upload failed. Please try again.",
				"uploadFailToastTitle": "File Could Not Be Uploaded",
				"uploadFailToast": "Something went wrong while uploading your file. Try again. If the issue continues, contact your instructor for assistance.",
				"uploadFailMaxFilesToast": "You have exceeded the maximum number of files allowed for this assessment. Please review your files and try again.",
				"someFilesFailedTitle": "Some Files Need Review",
				"someFilesFailedDesc": "Some files could not be uploaded. Please try again.",
				"fileTypeNotAllowedFileError": "File type not supported.",
				"connectionErrorFileError": "Upload interrupted. Check your connection and try again.",
				"fileTypeNotAllowedToastTitle": "File Type Not Supported",
				"fileTypeNotAllowedToastDesc": "This file type is not accepted for this question. Upload a file using one of the supported formats.",
				"assessmentWindowClosedToastTitle": "Assessment Window Has Closed",
				"assessmentWindowClosedToastDesc": "The submission window for this assessment has ended, so files can no longer be uploaded.",
				"accessDeniedToastTitle": "Unable to Access This Assignment",
				"accessDeniedToastDesc": "We could not verify your access to this assignment. Sign in with the correct account and try again.",
				"connectionErrorToastTitle": "File Upload Interrupted",
				"connectionErrorToastDesc": "Your file could not be uploaded due to a connection issue. Check your connection and try uploading the file again.",
				"yourResult": "Your Result",
				"pendingGrade": "Pending Grade",
				"pendingGradeDescription": "This attempt is under review. Please check back later for your results.",
				"questionType": {
					"MultipleChoice": "Multiple Choice",
					"TrueFalse": "True / False",
					"FillInTheBlank": "Fill in the Blank",
					"Matching": "Matching",
					"Essay": "Essay",
					"Ordering": "Ordering",
					"AudioRecording": "Recording",
					"FileSubmission": "File Submission",
					"DragAndDrop": "Drag & Drop",
					"Dropdown": "Dropdown",
					"Spreadsheet": "Spreadsheet",
					"Coding": "Coding"
				},
				"timer": {
					"endsIn": "Assessment Ends in {{time}}",
					"endsIn_prefix": "Assessment Ends in",
					"daysUnit": "day",
					"daysUnit_other": "days",
					"hoursUnit": "hr",
					"hoursUnit_other": "hrs",
					"minutesUnit": "min",
					"minutesUnit_other": "mins",
					"secondsUnit": "sec",
					"secondsUnit_other": "secs"
				},
				"questions": {
					"removeAnswerLabel": "Remove answer",
					"editor": {
						"fitb": {
							"answerPlaceholder": "Enter your answer here"
						},
						"essay": {
							"answerLabel": "Enter your answer here"
						},
						"spreadsheet": {
							"cellPlaceholder": "Enter Answer"
						},
						"coding": {
							"answerPlaceholder": "// Type your code here"
						},
						"fileSubmission": {
							"chooseFileTitle": "Click to choose file to upload",
							"toUpload": "Upload up to {{max}} MB({{formats}})",
							"maxFilesReached": "You've reached the maximum of {{max}} files",
							"invalidFormat": "File type not accepted",
							"fileTooLarge": "File must be less than {{max}} MB",
							"uploadFailed": "Upload failed, please try again"
						},
						"audioRecording": {
							"startHint": "Click the Start Recording button below to record your response.",
							"startRecording": "Start Recording",
							"cancelRecording": "Cancel Recording",
							"stopRecording": "Stop Recording",
							"minLengthRequired": "Record at least {{min}} before stopping",
							"pauseRecording": "Pause recording",
							"resumeRecording": "Resume recording",
							"discardRecording": "Discard recording",
							"processingRecording": "Processing Recording",
							"processingRecordingDesc": "Your recording is being processed and will be uploaded shortly.",
							"recordingSubmitted": "Audio recording submitted",
							"recordingSavedHint": "Recording saved. Play back to confirm, or retake.",
							"recordingFailed": "Recording failed, please try again",
							"micPermissionDenied": "Microphone access is blocked. Click the camera/lock icon in your browser's address bar, allow microphone access, then try again.",
							"micNotFound": "No microphone was found. Connect a microphone and try again.",
							"micInUse": "Your microphone is being used by another app. Close it and try again.",
							"mediaPermissionDenied": "Camera and microphone access is blocked. Click the camera/lock icon in your browser's address bar, allow access, then try again.",
							"mediaNotFound": "No camera or microphone was found. Connect a camera and microphone, then try again.",
							"mediaInUse": "Your camera or microphone is being used by another app. Close it and try again.",
							"tryAgain": "Try Again",
							"retake": "Retake",
							"reRecording": "Re-recording",
							"playAudio": "Play",
							"pauseAudio": "Pause",
							"replayAudio": "Replay",
							"deleteRecordingAnswer": "Delete Audio",
							"durationSeconds": "{{count}}-second",
							"durationMinutes": "{{count}}-minute",
							"autoStoppedMaxLength": "You reached the {{max}} limit. Recording stopped automatically."
						}
					},
					"fitb": {
						"instruction_one": "Fill in the blank to complete the statement.",
						"instruction_other": "Fill in the blanks to complete the statement."
					},
					"dragAndDrop": {
						"instruction_one": "Drag the correct answer into the blank to complete the statement.",
						"instruction_other": "Drag the correct answers into the blanks to complete the statement."
					},
					"dropdown": {
						"instruction_one": "Complete the statement using the dropdown.",
						"instruction_other": "Complete the statement using the dropdowns.",
						"selectPlaceholder": "Select..."
					}
				},
				"proctoring": {
					"startFailed": {
						"title": "Unable to Start Assessment",
						"devicePermission": "Your browser has blocked access to: {{capabilities}}. Allow access in your browser settings, then try again.",
						"devicePolicy": "This page is not permitted to access: {{capabilities}}. Ask your institution for help if the restriction persists.",
						"deviceUnsupported": "This browser cannot provide: {{capabilities}}. Try a supported browser or device.",
						"deviceUnavailable": "Could not access the required capabilities: {{capabilities}}. Check your browser permissions and device support, then try again.",
						"registrationRequired": "Register for a live session before starting this assessment. Open Assessments to choose a session.",
						"viewAssessments": "Open Assessments",
						"generic": "Proctoring could not be started. Please try again.",
						"live": "We could not connect to live proctoring. Check your connection and your scheduled session, then try again.",
						"retry": "Try Again"
					},
					"browserBlocked": {
						"title": "Browser not available for this assessment",
						"browserNotPermitted": "Your institution has not permitted this browser for this assessment. Open it in an allowed browser.",
						"browserUnsupported": "This browser is not supported for this assessment. Open it in a supported browser."
					},
					"uiCrashed": "The proctoring controls stopped responding. Refresh the page to restore the controls.",
					"tools": {
						"assistance": "Help Center",
						"calculator": "Calculator",
						"whiteboard": "Whiteboard",
						"reference": "Reference Material",
						"chat": "Chat",
						"raiseHand": "Raise Hand",
						"lowerHand": "Lower Hand",
						"zoomIn": "Zoom in",
						"zoomOut": "Zoom out"
					},
					"interrupt": {
						"userMedia": {
							"coreModalTitleBoth": "Select Camera and Microphone",
							"coreModalTitleCameraOnly": "Select Camera",
							"coreModalTitleMicrophoneOnly": "Select Microphone",
							"video": "Camera Source",
							"audio": "Microphone Source",
							"cancel": "Cancel",
							"confirm": "Confirm",
							"cameraSwitched": "Camera changed. We are re-checking your video — you can keep working.",
							"audioSwitched": "Microphone changed. We are re-checking your audio — you can keep working.",
							"cameraFailedTitle": "Camera Has Failed",
							"cameraFailedSubtitle": "The camera failed to load. Please try using a different camera.",
							"cameraNotFoundTitle": "Camera Not Found",
							"cameraNotFoundSubtitle": "Please connect a camera to your device. Once it is detected, it will be auto-selected.",
							"audioFailedTitle": "Microphone Has Failed",
							"audioFailedSubtitle": "The microphone failed to load. Please try using a different microphone.",
							"audioNotFoundTitle": "Microphone Not Found",
							"audioNotFoundSubtitle": "Please connect a microphone to your device. Once it is detected, it will be auto-selected.",
							"videoNotAllowedError": "The camera could not be accessed. Please ensure the browser has camera permissions enabled and check device settings, then try again.",
							"audioNotAllowedError": "The microphone could not be accessed. Please ensure the browser has microphone permissions enabled and check device settings, then try again.",
							"audioNoVolumeError": "Volume cannot be detected from your audio device. Please try selecting it again or connect to a new audio device.",
							"camera": "Camera",
							"microphone": "Microphone"
						},
						"displayRecording": {
							"coreModalTitle": "Screen Sharing Stopped",
							"coreModalMessage": "Your screen sharing stopped. Please click Share Screen to continue.",
							"buttonText": "Share Screen"
						},
						"faceRecording": {
							"title": "Face Not Detected",
							"description": "Please align your face within the camera frame to continue.",
							"action": "I Confirm My Face Is Visible",
							"alert": "You can proceed without your face in view, though this may impact your assessment status."
						},
						"speaking": {
							"title": "Audio Warning",
							"description": "Your assessment requires you to be in a quiet environment. Please refrain from activities such as speaking that may cause audio disturbances.",
							"understood": "I understand",
							"stopShowing": "Do not show it again"
						},
						"restrictedDevice": {
							"title": "Mobile Device Restriction Required",
							"description": "Scan the QR code with the Verity Mobile Lockdown App, then follow the steps on your device to continue with the assessment."
						},
						"sidePanel": {
							"title": "Side Panel Activity Detected",
							"description": "We have detected activity in your browser’s side panel, and this has been flagged to your instructor. Please keep the side panel closed during your assessment.",
							"acknowledge": "I understand"
						}
					},
					"scratchNotes": {
						"title": "Work Attachments",
						"instruction": "Take a picture of your notes and other attachments to submit with your assessment.",
						"previewLoading": "Starting camera preview…",
						"permissionError": "Camera access is blocked. Allow camera access in your browser settings, then try again.",
						"cameraUnavailable": "No camera is available. Connect a camera, allow access, and try again.",
						"previewFailed": "The camera preview could not start. Check that your camera is connected and allowed, then try again.",
						"retry": "Try Again",
						"captureFailed": "The photo could not be captured. Check the camera preview and try again.",
						"take": "Take Photo",
						"retake": "Retake Photo",
						"another": "Add Another",
						"upload": "Upload",
						"uploading": "Uploading",
						"skip": "Skip",
						"failed": "Some attachments could not be uploaded. Try again, or skip to finish without them."
					},
					"gate": {
						"title": "This assessment opens in its own tab",
						"description": "Verity needs a dedicated browser tab to access your camera, microphone, and screen for proctoring.",
						"open": "Launch Assessment",
						"reopen": "Reopen Assessment",
						"opened": "The assessment is open in another tab.",
						"blocked": "Your browser blocked the new tab. Allow pop-ups for this site and try again.",
						"badge": "Web Browser",
						"closed": "The assessment tab has closed. You can reopen it to view your attempts or start an available attempt."
					},
					"toolbar": {
						"title": "Verity Proctoring Toolbar",
						"recording": "Recording",
						"more": "More Options",
						"move": "Move Toolbar",
						"moveWindow": "Move {{title}} Window",
						"moveInstructions": "Use the arrow keys to move the toolbar. Hold Shift to move farther.",
						"toolsInstructions": "Use Left and Right Arrow to move between tools. Press Enter to open a tool.",
						"brand": "Verity",
						"recordingNotice": "This session is being recorded.",
						"recordingInterrupted": "Recording interrupted",
						"collapse": "Collapse toolbar",
						"expand": "Expand toolbar",
						"minimize": "Minimize",
						"close": "Close",
						"scrollBack": "Show previous tools",
						"scrollForward": "Show more tools"
					},
					"complete": {
						"title": "Your assessment is complete",
						"description": "Your answers have been submitted. You can close this tab once your recording has finished uploading.",
						"score": "Score {{earned}} / {{total}}",
						"uploading": "Uploading your recording ({{count}} remaining)",
						"uploadComplete": "Your recording has been uploaded",
						"uploadIncomplete": "Some of your recording could not be uploaded. Your instructor has been notified.",
						"return": "Return to attempts",
						"safeToClose": "It is now safe to close this browser tab.",
						"keepOpen": "Do not close this tab until your recording finishes uploading.",
						"keepOpenFinishing": "Please keep this tab open while Verity finishes your assessment.",
						"finalizing": "Finalizing your assessment",
						"finalizingDescription": "Your answers are saved. Verity is finishing the remaining assessment steps.",
						"incompleteTitle": "Your answers have been submitted",
						"incompleteDescription": "Your response was saved, but Verity could not finish uploading all of your proctoring data. Contact your instructor for assistance."
					},
					"chat": {
						"empty": "Messages from your proctor will appear here.",
						"placeholder": "Message your proctor",
						"send": "Send message"
					},
					"start": {
						"badge": "Pre-Assessment Setup",
						"title": "Verity Proctoring Pre-Assessment Check",
						"description": "Before you begin, Verity guides you through a quick check to confirm your device and environment are ready for the assessment. This takes only a few minutes.",
						"assessmentName": "Assessment Name",
						"courseName": "Course Name",
						"instructions": "Assessment Instructions",
						"start": "Begin Setup",
						"viewAttempts": "View Attempts",
						"loading": "Loading assessment"
					}
				},
				"finishing": "Finishing your assessment",
				"finishingSubtitle": "Your answers are saved. Your recording is still uploading — this only takes a moment."
			},
			"uploadFilesTSX": {
				"verityAssessment": "Verity Assessment",
				"landingPage": {
					"title": "Upload Your Response",
					"description": "Verify your details below, then upload your files to submit your assessment",
					"course": "Course",
					"assignment": "Assignment",
					"name": "Student Name",
					"uploadFiles": "Upload Files",
					"chooseFiles": "Choose Files"
				},
				"imageListPage": {
					"title": "<b>Review Your Files</b> ({{count}}/{{max}})",
					"addAFile": "Add a File",
					"removeFile": "Remove File",
					"replaceFile": "Replace File",
					"warningTitle": "Some files need review",
					"warningDescription": "Some files could not be uploaded. Please try again."
				},
				"reviewFilePage": {
					"title": "Review your Response",
					"description": "Please review your file carefully before submitting. Once submitted, it cannot be submitted again.",
					"warningTitle": "Please Review Carefully",
					"warningDescription": "Submissions are final and cannot be resubmitted.",
					"openInNewTab": "Open file in new tab",
					"downloadFile": "Download file"
				},
				"progressPage": {
					"title": "Uploading your response",
					"description": "Your responses are being securely uploaded. Do not close this page, please hang tight.",
					"progress": "<b>{{numUploaded}}</b> of {{total}} completed..."
				},
				"finishPage": {
					"title": "Response Submitted",
					"description": "Your response has been submitted successfully.",
					"closePage": "You can now close this page.",
					"maxFiles": "You have reached the maximum number of files allowed for this assessment."
				},
				"button": {
					"landingPage": "Continue",
					"imageListPage": "Review",
					"reviewFilePage": "Submit",
					"finish": "Close Page",
					"back": "Back"
				},
				"uploadFailed": "Upload Failed.",
				"fileTooLarge": "File too large.",
				"errorToast": {
					"UPLOAD_SIZE": {
						"title": "File Too Large",
						"message": "Failed to upload some files. One or more files exceed the maximum size limit of {{size}}MB."
					},
					"MAX_FILES_EXCEEDED": {
						"title": "Maximum Files Reached",
						"message": "Failed to upload some files. You have exceeded the maximum number of files allowed for this assessment."
					},
					"FILE_TYPE_NOT_ALLOWED": {
						"title": "File Type Not Supported",
						"message": "This file type is not accepted for this question. Upload a file using one of the supported formats."
					},
					"ASSESSMENT_WINDOW_CLOSED": {
						"title": "Assessment Window Has Closed",
						"message": "The submission window for this assessment has ended, so files can no longer be uploaded."
					},
					"ACCESS_DENIED": {
						"title": "Unable to Access This Assignment",
						"message": "We could not verify your access to this assignment. Sign in with the correct account and try again."
					},
					"CONNECTION_ERROR": {
						"title": "File Upload Interrupted",
						"message": "Your file could not be uploaded due to a connection issue. Check your connection and try uploading the file again."
					},
					"UPLOAD_FAIL": {
						"title": "File Could Not Be Uploaded",
						"message": "Something went wrong while uploading your file. Try again. If the issue continues, contact your instructor for assistance."
					}
				}
			},
			"useCarouselTSX": {
				"previous": "Go To Previous Item",
				"next": "Go To Next Item"
			}
		},
		"webpages": {
			"liveProctoringRootTSX": {
				"unregister": "This assessment is live proctored. Please sign up for a future session and wait until it has begun before starting this assessment. Please contact your instructor if there are no longer any more available sessions.",
				"notStarted": "Your live assessment is scheduled to start at {{time}}. Please wait for the start time to join.",
				"notReady": "Please wait for the proctor to start your session.",
				"expired": "Your session has ended. Please contact your instructor if you require assistance.",
				"ready": "You have been redirected to the wrong page. Please try again. If you receive this error again, please contact YuJa support for help.",
				"error": "An error occurred! Please contact YuJa support for help.",
				"refreshing": "Refreshing data...",
				"refreshSuccess": "Successfully refreshed data.",
				"refreshError": "Error refreshing data! Please try again.",
				"noAssessment": "No valid assessment for saving.",
				"saveFail": "Failed to save some assessment live proctored sessions.",
				"assignFailProctor": "Failed to assign a proctor to a live proctored session sign up.",
				"assignFailGroup": "Failed to assign a proctor group to a live proctored session sign up.",
				"saveSignupFail": "Failed to save some live proctored session sign up.",
				"cannotInviteGroupWithin": "{{groupName}} cannot be invited within {{minHoursNotice}} hours of the session's scheduled start time",
				"errorSaving": "Error while saving!",
				"noId": "No student id.",
				"invalidData": "Invalid active data.",
				"errorRegister": " Error also occurred during re-registration: ",
				"joining": "Joining...",
				"noSessionId": "No liveSessionId to facilitate live session join.",
				"joinFail": "Failed to join the live session. Please try again.",
				"noUserId": "No userId to facilitate live session end."
			},
			"settingsRootTSX": {
				"disableAll": "Disable All",
				"settingsCourseName": "Email Settings",
				"settingsCourseDailyDigestName": "Daily Digest Email",
				"settingsCourseDescription": "Register yourself for a daily digest email with a summary of all proctored sessions submitted",
				"panelCourseName": "Verity Recording Panel",
				"panelCourseDescription": "The Recording Panel offers test-takers a preview of their webcam recording and the option to contact the Verity support team should they require assistance during their assessment.",
				"settingsInstituteName": "Daily Digest Emails",
				"settingsInstitutionEmailName": "Email Subscription",
				"settingsInstituteDescription": "Enable the daily digest emails for all users in the institution",
				"panelInstituteName": "Verity Recording Panel",
				"panelInstituteDescription": "The Recording Panel offers test-takers a preview of their webcam recording and the option to contact the Verity support team should they require assistance during their assessment.",
				"fileInstituteName": "Policy Statement",
				"fileInstituteDescription": "The institutional policy through which test-takers are asked to confirm their adherence to established guidelines",
				"profileInstituteName": "Institution-Wide Profiles",
				"profileInstituteDescription": "Create optional profiles that can be applied to assessments.",
				"approvedProfilesName": "Designated Institution-Wide Profiles",
				"approvedProfilesDescription": "Institution-wide profiles that instructors must use for proctored assessments.",
				"defaultProfileName": "Default Institution-Wide Profile",
				"defaultProfileDescription": "Select a profile that will be applied to all proctored assessments by default.",
				"courseFlagName": "Flag Levels",
				"courseFlagDescription": "Assign custom flag levels for each event recorded during a proctored assessment.",
				"instAssessmentRestrictionName": "Institution-Wide Assessment Settings",
				"instAssessmentRestrictionDesc": "Choose restrictions you would like to make available to instructors. Instructors will only have access to your selected restrictions when creating proctored assessments.",
				"globalSettings": "Global Settings",
				"bypassMode": "Prevent Test-Takers From Continuing",
				"bypassModeDescription": "Prevent test-takers to proceed despite violated restrictions",
				"suffix": "Suffix",
				"scopeSettingsName": "Scope Settings",
				"userSecurityPinName": "Security PIN",
				"userSecurityPinDescription": "The Security PIN is an auto-generated number used to verify your account when contacting YuJa Support for help.",
				"userSettingsName": "User Setting",
				"languageSettingsName": "Language Setting",
				"languageSettingsDescription": "Choose your preferred language.",
				"institutionAccommodationName": "Accommodations",
				"savedGeofencesCourse": "Geofence Locations",
				"savedGeofencesCourseDescription": "Add up to five geofence areas for use in assessment location restrictions.",
				"savedGeofencesCourseAddLocation": "Add Location",
				"savedGeofencesCourseLocationName": "Location Name",
				"recordingMaxAgeMonths": {
					"title": "Months to Retain Videos",
					"description": "Choose the retention period for recorded videos",
					"months_one": "{{count}} month",
					"months_other": "{{count}} months"
				},
				"bypassModeTSX": {
					"turnOnTitle": "Turn on Bypass Mode",
					"turnOnDescription": "Certain Assessment Restrictions can prevent test-takers from continuing their assessments if they fail to meet the requirements. Turn on Bypass Mode to allow test-takers to continue their assessments even if restrictions are violated.",
					"settingDescription": "The setting will allow the test-taker to continue their assessment if:",
					"videoLabel": "Record Video",
					"videoDescription": "Webcam is no longer active.",
					"audioLabel": "Record Audio",
					"audioDescription": "Microphone is no longer active.",
					"handoffLabel": "Disable Handoff",
					"handoffDescription": "The test taker turns on the Handoff feature on their Apple device.",
					"blockLabel": "Block Applications",
					"blockDescription": "Restricted applications are open.",
					"extensionBlockLabel": "Disable Browser Extension",
					"extensionBlockDescription": "The test-taker enables browser extensions that are not allowed.",
					"screenLabel": "Only One Screen",
					"screenDescription": "Multiple displays are connected.",
					"aiLabel": "AI ID Verification",
					"aiDescription": "The test-taker's face does not match their ID."
				},
				"audioTranscriptKeywords": {
					"title": "Flagged Keywords",
					"subtitle": "Add words or phrases that will be flagged when said during assessments.",
					"toolBar": {
						"title": "Add Keyword",
						"placeholder": "Enter a keyword",
						"button": "Add"
					},
					"table": {
						"headers": {
							"keyword": "Keyword",
							"actions": "Actions"
						},
						"noResults": {
							"title": "Start Adding Keywords",
							"subtitle": "Add a word like “Hello” or a short phrase like “What’s the answer” to create your keyword list."
						},
						"row": {
							"actions": {
								"edit": "Edit",
								"save": "Save",
								"remove": "Remove"
							}
						}
					}
				},
				"thirdPartyIntegration": {
					"title": "Integration Setup",
					"description": "Select third-party platforms to integrate Verity with.",
					"cancel": "Cancel",
					"confirm": "Confirm",
					"submitRequest": "Submit Request",
					"otherPlatforms": "Other Third-Party Platforms",
					"searchPlatformPlaceholder": "Search by third-party platform name",
					"settingsBanner": {
						"title": "Third-Party Assessment Integrations",
						"description": "Establish a secure and proctored test-taking environment for assessments created on third-party assessment platforms."
					},
					"integrationModal": {
						"title": "Add {{platform}}",
						"description": "We recommend testing and validating the assessment process before instructors create their assessments to ensure the integration is set up correctly. Follow the steps below to validate your integration with {{platform}}.",
						"noteTxt": "<b>Note:</b> If you encounter any issues during platform setup, please contact your Account Manager for assistance.",
						"stepOneTitle": "Create a Sample {{platform}} Assessment in Verity",
						"stepOneDesc": "Set up a proctored assessment in Verity for your {{platform}} assessment and apply the necessary proctoring settings.",
						"stepTwoTitle": "Ensure the Pre-Assessment Check Page Is Visible",
						"stepTwoDesc": "Preview your assessment and make sure the Pre-Assessment Check page displays correctly.",
						"stepThreeTitle": "Verify Password Auto-Fill",
						"stepThreeDesc": "Confirm that Verity can automatically fill the password for your assessment."
					},
					"requestPlatformModal": {
						"title": "Request Third-Party Platform",
						"description": "If the third-party assessment platform you use is not listed, you can submit a request by entering its details below.",
						"noteTxt": "<b>Note:</b> To add an additional third-party assessment platform, Verity requires instructor and student access to courses where the assessment is set up. After you submit the request, our team will reach out shortly regarding the access requests.",
						"platformName": "Third-Party Platform Name",
						"platformNamePlaceholder": "Enter the name of the third-party platform",
						"url": "Platform Link",
						"urlPlaceholder": "Enter the link of the third-party platform",
						"successToastMsg": "Your request has been submitted successfully.",
						"failureToastMsg": "Something went wrong. Please try again later."
					}
				}
			},
			"activity": {
				"title": "Activity",
				"description": "View past activities on your Verity platform.",
				"updated": "Updated",
				"lastUpdated": "Last updated {{updatedAt}}",
				"dateRange": "Activity date range",
				"startMonth": "Activity start month",
				"endMonth": "Activity end month",
				"from": "From",
				"to": "To",
				"exportReport": "Export Report",
				"refresh": "Refresh",
				"clearFilters": "Clear Filters",
				"loadMore": "Load More",
				"invalidDateRange": "Select a date range of no more than 366 days.",
				"exportProgress": "Preparing export: {{count}} activities loaded…",
				"cancelExport": "Cancel Export",
				"exportError": "Unable to export all activities. Please try again.",
				"summary": "Date-scoped activity summary",
				"totalEvents": "Total Activities",
				"totalLoginEvents": "Total Sign-Ins",
				"totalProctoringEvents": "Total Proctoring Events",
				"totalSessionsStarted": "Total Sessions Started",
				"unavailable": "Unavailable",
				"loadingShort": "Loading...",
				"history": "Activity History",
				"historyRegion": "Scrollable activity history records",
				"historyDescription": "Search and filter activities by type, user, course, assessment, and date.",
				"advancedFilter": "Advanced Filter",
				"noInstitution": "No institution is selected.",
				"error": "Unable to load activity data. Please try again later.",
				"loading": "Loading activities…",
				"noEvents": "No activities match the selected filters.",
				"loadingMore": "Loading more activities…",
				"nextPageError": "Unable to load more activities.",
				"retryNextPage": "Retry loading activities",
				"allLoaded": "End of activity history.",
				"kinds": {
					"auth": "Sign-in",
					"assessment": "Assessment",
					"proctoring": "Proctoring session",
					"setup": "Pre-assessment setup",
					"recording": "Recording",
					"scratch_note": "Assessment Notes",
					"restriction": "Restriction",
					"session": "In-session activity",
					"interrupt": "Interruption",
					"network": "Network",
					"browser": "Browser",
					"live": "Live proctoring",
					"completion": "Completion",
					"institute": "Institution",
					"privilege": "Privilege",
					"privilege_group": "Role",
					"portal": "Portal",
					"results": "Results",
					"reports": "Reports",
					"navigation": "Navigation"
				},
				"kindGroups": {
					"people": "People",
					"assessment": "Assessments",
					"content": "Recordings and Files",
					"safeguards": "Safeguards",
					"organization": "Organization",
					"management": "Access Management",
					"live": "Live Proctoring",
					"results": "Results and Reports"
				},
				"actions": {
					"auth.login": "User Signed In",
					"auth.token.refreshed": "Session Refreshed",
					"assessment.launch.detected": "Assessment Launch Detected",
					"assessment.start.requested": "Assessment Started",
					"assessment.compatibility_check.started": "Compatibility Check Started",
					"assessment.start.blocked": "Assessment Start Blocked",
					"assessment.preview.opened": "Assessment Preview Opened",
					"assessment.preview.option.selected": "Assessment Preview Option Selected",
					"assessment.eligibility.checked": "Assessment Access Confirmed",
					"assessment.exemption.applied": "Proctoring Exemption Applied",
					"assessment.configuration.updated": "Proctoring Settings Updated",
					"assessment.proctoring.toggled": "Proctoring Enabled",
					"assessment.configuration.save.failed": "Proctoring Settings Save Failed",
					"proctoring.setup.opened": "Pre-Assessment Setup Opened",
					"proctoring.setup.system_resources.checked": "System Resources Check Passed",
					"proctoring.setup.connection.checked": "Connection Check Passed",
					"proctoring.setup.geofence.checked": "Location Check Passed",
					"proctoring.setup.incognito.checked": "Incognito Mode Check Passed",
					"proctoring.setup.managed_guest_session.checked": "Managed Guest Session Check Passed",
					"proctoring.setup.blocked_extensions.checked": "Browser Extensions Check Passed",
					"proctoring.setup.side_panel.checked": "Browser Side Panel Check Passed",
					"proctoring.setup.monitor_count.checked": "Display Check Passed",
					"proctoring.setup.browser_supported.checked": "Browser Check Passed",
					"proctoring.setup.screen_share.checked": "Screen Sharing Check Passed",
					"proctoring.setup.camera.checked": "Camera Check Passed",
					"proctoring.setup.microphone.checked": "Microphone Check Passed",
					"proctoring.setup.secondary_camera.checked": "Secondary Camera Check Passed",
					"proctoring.setup.mobile_device.connected": "Mobile Device Connected",
					"proctoring.setup.room_scan.completed": "Room Scan Completed",
					"proctoring.setup.identity.completed": "Identity Verification Completed",
					"proctoring.setup.signature.completed": "Signature Completed",
					"proctoring.setup.cancelled": "Pre-Assessment Setup Cancelled",
					"proctoring.setup.completed": "Pre-Assessment Setup Completed",
					"proctoring.assessment.started": "Proctored Assessment Started",
					"proctoring.assessment.submission.requested": "Assessment Submission Requested",
					"proctoring.assessment.submission.failed": "Assessment Submission Failed",
					"proctoring.assessment.password.rejected": "Assessment Password Not Accepted",
					"proctoring.assessment.submitted": "Assessment Submitted",
					"proctoring.assessment.lms_notified": "Assessment Completion Reported to LMS",
					"proctoring.recording.started": "Proctoring Recording Started",
					"proctoring.recording.stopped": "Proctoring Recording Stopped",
					"proctoring.recording.upload.completed": "Recording Upload Completed",
					"proctoring.recording.upload.failed": "Recording Upload Failed",
					"proctoring.scratch_note.upload.completed": "Assessment Notes Uploaded",
					"proctoring.restriction.new_tabs.applied": "New Tabs Restricted",
					"proctoring.restriction.clipboard.applied": "Copy and Paste Restricted",
					"proctoring.restriction.right_click.applied": "Right-Click Restricted",
					"proctoring.restriction.printing.applied": "Printing Restricted",
					"proctoring.restriction.web_traffic.applied": "Web Navigation Restricted",
					"proctoring.restriction.open_tabs.applied": "Existing Tabs Restricted",
					"proctoring.restriction.right_click.blocked": "Right-Click Attempt Blocked",
					"proctoring.restriction.printing.blocked": "Printing Attempt Blocked",
					"proctoring.navigation.blocked": "Navigation Attempt Blocked",
					"proctoring.restriction.side_panel.detected": "Browser Side Panel Detected",
					"proctoring.restriction.blocked_extension.detected": "Restricted Browser Extension Detected",
					"proctoring.session.started": "Proctoring Session Started",
					"proctoring.session.ended": "Proctoring Session Ended",
					"proctoring.session.focus.lost": "Student Left Assessment Window",
					"proctoring.session.monitor_count.changed": "Number of Screens Changed",
					"proctoring.interrupt.triggered": "Proctoring Session Interrupted",
					"proctoring.interrupt.resolved": "Proctoring Interruption Resolved",
					"proctoring.network.disconnected": "Internet Connection Lost",
					"proctoring.network.connected": "Internet Connection Restored",
					"proctoring.browser.closed": "Assessment Browser Closed",
					"proctoring.live.session.joined": "Live Proctoring Session Joined",
					"proctoring.live.audio_bridge.ready": "Live Audio Bridge Ready",
					"proctoring.live.proctor.joined": "Live Proctor Joined",
					"proctoring.live.proctor.left": "Live Proctor Left",
					"proctoring.live.no_proctor.available": "No Live Proctor Available",
					"proctoring.completion.upload.opened": "Recording Upload Started",
					"proctoring.completion.displayed": "Proctoring Completion Confirmed",
					"proctoring.completion.dismissed": "Completion Page Exited",
					"institute.created": "Institution Created",
					"institute.updated": "Institution Updated",
					"institute.deleted": "Institution Deleted",
					"privilege.created": "Permission Granted",
					"privilege.deleted": "Permission Revoked",
					"privilege_group.created": "Role Created",
					"privilege_group.updated": "Role Updated",
					"privilege_group.deleted": "Role Deleted",
					"portal.launched": "Portal Opened",
					"reports.exported": "Report Exported",
					"results.session.viewed": "Proctoring Results Viewed"
				},
				"columns": {
					"activity": "Activity",
					"description": "Description",
					"time": "Time"
				},
				"search": {
					"label": "Search activity messages, users, courses, or assessments",
					"placeholder": "Search by message, user, course, or assessment",
					"action": "Search",
					"clearMessage": "Clear message search",
					"loading": "Loading suggestions...",
					"error": "Unable to load suggestions.",
					"noResults": "No matching users, courses, or assessments.",
					"searchMessagesFor": "Search messages for “{{query}}”",
					"activeFilters": "Active filters",
					"removeFilter": "Remove {{kind}} filter {{label}}",
					"kinds": {
						"user": "User",
						"course": "Course",
						"assessment": "Assessment"
					}
				},
				"csv": {
					"eventUuid": "Event UUID",
					"action": "Action",
					"message": "Message",
					"source": "Source",
					"actor": "Actor",
					"subject": "Subject",
					"proctoring": "Proctoring context",
					"time": "Time",
					"context": "Technical context",
					"outcome": "Outcome",
					"data": "Data",
					"details": "Details"
				},
				"outcomes": {
					"success": "Success",
					"failure": "Failure"
				},
				"actionFailures": {
					"auth.token.refreshed": "Session Refresh Failed",
					"assessment.eligibility.checked": "Assessment Access Blocked",
					"proctoring.setup.system_resources.checked": "System Check Failed",
					"proctoring.setup.connection.checked": "Connection Check Failed",
					"proctoring.setup.geofence.checked": "Location Check Failed",
					"proctoring.setup.incognito.checked": "Incognito Mode Check Failed",
					"proctoring.setup.managed_guest_session.checked": "Managed Guest Session Check Failed",
					"proctoring.setup.blocked_extensions.checked": "Browser Extensions Check Failed",
					"proctoring.setup.monitor_count.checked": "Display Check Failed",
					"proctoring.setup.browser_supported.checked": "Browser Check Failed",
					"proctoring.setup.screen_share.checked": "Screen Sharing Check Failed",
					"proctoring.setup.camera.checked": "Camera Check Failed",
					"proctoring.setup.microphone.checked": "Microphone Check Failed",
					"proctoring.setup.secondary_camera.checked": "Secondary Camera Check Failed",
					"proctoring.setup.mobile_device.connected": "Mobile Device Connection Failed",
					"proctoring.setup.room_scan.completed": "Room Scan Failed",
					"proctoring.setup.identity.completed": "Identity Verification Incomplete",
					"proctoring.setup.signature.completed": "Signature Failed",
					"proctoring.completion.displayed": "Proctoring Completion Failed",
					"proctoring.recording.upload.completed": "Recording Upload Failed",
					"proctoring.restriction.new_tabs.applied": "New Tab Restriction Failed",
					"proctoring.restriction.clipboard.applied": "Copy and Paste Restriction Failed",
					"proctoring.restriction.right_click.applied": "Right-Click Restriction Failed",
					"proctoring.restriction.web_traffic.applied": "Web Navigation Restriction Failed",
					"proctoring.restriction.open_tabs.applied": "Existing Tab Restriction Failed",
					"proctoring.live.audio_bridge.ready": "Live Audio Bridge Connection Failed",
					"proctoring.setup.side_panel.checked": "Browser Side Panel Check Failed",
					"proctoring.restriction.printing.applied": "Printing Restriction Failed"
				},
				"actionVariants": {
					"proctoringDisabled": "Proctoring Disabled",
					"assessmentAutomaticallySubmitted": "Assessment Automatically Submitted",
					"completionUnknown": "Proctoring Completion Status"
				}
			}
		},
		"portalTSX": {
			"assessments": "Proctored Assessments",
			"automatedProctoring": "Automated Proctoring",
			"liveProctoring": "Live Proctoring",
			"livePopIn": "Live Check-In Proctoring",
			"createAssessment": "Create Assessment",
			"liveActivity": "Live Activity",
			"liveSchedule": "Live Proctoring Schedule",
			"checkInMonitoring": "Live Check-In Monitoring",
			"report": "Reports",
			"institution": "Institution",
			"course": "Course",
			"integration": "Integration",
			"settings": "Settings",
			"setup": "User Setup",
			"browserExtension": "Browser Extension",
			"lockdownApp": "Lockdown App",
			"mobileApp": "Mobile Lockdown App",
			"extensionSetup": "Extension Setup",
			"automatedAssessment": "Automated Assessments",
			"lockdownSetup": "Lockdown Setup",
			"lockdownAssessment": "Lockdown Assessments",
			"liveSession": "Live Sessions",
			"liveAssessment": "Live Assessments",
			"institutionReport": "Institution Report",
			"courseReport": "Course Report",
			"assessmentReport": "Assessment Report",
			"generalSettings": "General Settings",
			"instiSetting": "Institution Settings",
			"proctoringProfiles": "Proctoring Profiles",
			"thirdPartyIntegration": "Third-Party Assessment Integrations",
			"courseSetting": "Course Settings",
			"integrationSetting": "Integration Settings",
			"scopeSettings": "Scope Settings",
			"user": "User",
			"userSettings": "User Settings",
			"rosterManagement": "Roster Management",
			"institutionInformation": "Institution Information",
			"modules": "Modules",
			"marketplace": "Marketplace",
			"latestUpdates": "Latest Updates",
			"activityPage": "Activity",
			"usageReport": "Usage Report",
			"mobileWorkflow": "Continue on Mobile",
			"takeAssessment": "Take Assessment",
			"canvas": "Canvas",
			"BlackboardLearn": "Blackboard",
			"moodle": "Moodle",
			"desire2learn": "D2L Brightspace",
			"mainAriaLabel": "YuJa Verity main content"
		}
	},
	"result": {
		"components": {
			"liveSessionNotes": {
				"noteEditHistoryTableTSX": {
					"content": "Content",
					"editor": "Editor",
					"timeStamp": "Timestamp"
				},
				"noteTableTSX": {
					"note": "Note",
					"student": "Test-Taker",
					"author": "Author",
					"session": "Session",
					"createTime": "Create Time",
					"lastEdit": "Last Edited",
					"viewHistory": "View Edit History",
					"noInstall": "You must have the Verity extension installed and enabled.",
					"noAuth": "Please authenticate yourself using the Verity LTI link.",
					"noResult": "No Results Found"
				},
				"studentNoteTable": {
					"studentName": "Test-Taker Name",
					"numNote": "Number of Notes",
					"firstNote": "First Note",
					"lastNote": "Last Note",
					"viewNote": "View Notes",
					"close": "Close",
					"view": "View",
					"noData": "No Data",
					"noInstall": "You must have the Verity extension installed and enabled.",
					"noAuth": "Please authenticate yourself using the Verity LTI link.",
					"noResult": "No Results Found"
				},
				"indexTSX": {
					"searchStu": "Search Test-Taker Names",
					"searchNote": "Search Notes",
					"search": "Search",
					"groupByStu": "Group by Test-Taker"
				}
			},
			"studentSelection": {
				"dropDownTSX": {
					"unflagged": "Unflagged",
					"flagged": "Flagged",
					"incomplete": "Incomplete",
					"pending": "Pending",
					"error": "Error",
					"noOption": "No options found",
					"select": "Select Attempt"
				},
				"sessionNotesTSX": {
					"failSave": "Failed to save edits to note.",
					"edit": "Edit",
					"delete": "Delete",
					"deleteNote": "Delete Note",
					"no": "No",
					"yes": "Yes",
					"failDelete": "Failed to delete note.",
					"sureDelete": "Are you sure you would like to permanently delete this note?",
					"menuAriaLabel": "Open for more options",
					"sessionNoteAriaLabel": "Jump to {{time}}. Note: ",
					"textAreaAriaLabel": "Proctoring event notes"
				},
				"studentInfo": {
					"studentPopupTSX": {
						"idVeri": "ID Verification"
					},
					"studentWrapTSX": {
						"view": "View ID Verification"
					},
					"studentPhotoTSX": {
						"idDetail": "Candidate ID Details",
						"photoDetail": "Candidate Photo Details",
						"reset": "Reset",
						"scrollZoom": "Scroll to Zoom. Click to Move.",
						"candidateId": "Candidate ID",
						"candidatePhoto": "Candidate Photo"
					}
				},
				"searchBarTSX": {
					"susLevel": "Suspicion Level",
					"minor": "Minor",
					"major": "Major",
					"severe": "Severe",
					"submissionStart": "Submission Start Date",
					"submissionEnd": "Submission End Date",
					"cancel": "Cancel",
					"apply": "Apply",
					"searchName": "Search Test-Taker Names",
					"search": "Search",
					"clear": "Clear"
				},
				"videoPlayer": {
					"seedBarEventsTSX": {
						"sessionNote": "Session Note: ",
						"liveNote": "Live Note: "
					},
					"sessionSummaryTSX": {
						"warning": "Warning: The test-taker ended the recording before submitting the assessment. Further investigation may be required.",
						"wrong": "Something went wrong and test-taker timestamps were not logged properly."
					},
					"timeStampLinksTSX": {
						"openTab": "Test-taker opened a New Tab",
						"disableTabSuccess": "An attempt to open a new tab was blocked",
						"disableTabFail": "An attempt to open a new tab could not be blocked",
						"closeTab": "Test-taker closed a tab",
						"focusChange": "Test-taker navigated away from the assessment page",
						"whitelistTab": "Test-taker accessed a permitted website",
						"closeAllTab": "Test-taker closed all tabs",
						"sidePanelDetected": "Test-taker has attempted to open the browser’s side panel.",
						"rightClickBlocked": "An attempt to right-click was blocked",
						"printingBlocked": "An attempt to print a web page was blocked",
						"toggledBlockMobileAppsDisabled": "Test-taker disabled Pinned Mode (Android) / Guided Access (iOS) in the Lockdown mobile app.",
						"toggledBlockMobileAppsEnabled": "Test-taker enabled Pinned Mode (Android) / Guided Access (iOS) in the Lockdown mobile app.",
						"toggledBlockMobileAppsDisabledAndroid": "Test-taker disabled Pinned Mode in the Lockdown mobile app (Android).",
						"toggledBlockMobileAppsEnabledAndroid": "Test-taker enabled Pinned Mode in the Lockdown mobile app (Android).",
						"toggledBlockMobileAppsDisablediOS": "Test-taker disabled Guided Access in the Lockdown mobile app (iOS).",
						"toggledBlockMobileAppsEnablediOS": "Test-taker enabled Guided Access in the Lockdown mobile app (iOS).",
						"viewDecoySite": "Test-taker visited a decoy website",
						"disableScreenShots": "An attempt to take a screenshot was blocked",
						"disableScreenShotsFail": "An attempt to take a screenshot could not be blocked",
						"detectKeypress": "Test-taker pressed {{keys}} to take a screenshot",
						"beginScreenshot": "Test-taker may have begun a screenshot",
						"endScreenshot": "Test-taker may have ended their screenshot",
						"proctorSessionBegin": "Proctoring session started",
						"proctorSessionBeginFail": "Proctoring session could not start",
						"quizStart": "Test-taker has started the assessment",
						"quizStartFail": "Assessment could not start",
						"webcamRecordBegin": "Webcam recording started",
						"recordBegin": "Screen recording started",
						"micTurnOn": "Audio recording started",
						"startRecordingFail": "Recording could not start ",
						"startWebcamRecordingFail": "Webcam recording could not start",
						"startScreenRecordingFail": "Screen recording could not start",
						"startAudioRecordingFail": "Audio recording could not start",
						"proctorSessionEnd": "Proctoring session ended",
						"proctorSessionEndFail": "Proctoring session could not end",
						"endQuiz": "Test-taker submitted their assessment",
						"endQuizWithoutSubmission": "Test-taker ended their assessment",
						"endRecording": "Recording ended",
						"endWebcamRecording": "Webcam recording ended",
						"endScreenRecording": "Screen recording ended",
						"endAudioRecording": "Audio recording ended",
						"failEndRecording": "Recording could not end",
						"failEndWebcamRecording": "Webcam recording could not end",
						"failEndScreenRecording": "Screen recording could not end",
						"failEndAudioRecording": "Audio recording could not end",
						"webcamUploadIncomplete": "Upload for webcam recording was interrupted because the proctoring session was closed.",
						"displayUploadIncomplete": "Upload for screen recording was interrupted because the proctoring session was closed.",
						"microphoneUploadIncomplete": "Upload for audio recording was interrupted because the proctoring session was closed.",
						"monitorDetectionOn": "Enabled the setting to detect additional monitors",
						"monitorDetectionOnFail": "Could not enable the setting to detect additional monitors",
						"monitorDetected": "An additional monitor has been detected",
						"monitorsDetected": "{{number}} additional monitors have been detected",
						"changesDetect_one": "Number of additional monitors connected has changed: {{number}} monitor connected",
						"changesDetect_other": "Number of additional monitors connected has changed: {{number}} monitors connected",
						"enableIncognito": "Incognito permissions have been enabled",
						"enableIncognitoFail": "Incognito permissions could not be enabled",
						"disableClip": "An attempt to use the clipboard was blocked",
						"detectStudentUsingClipboard": "An attempt to {{keypress}} was blocked",
						"detectStudentUsingClipboardText": "An attempt to {{keypress}} the following text was blocked: {{text}}",
						"detectStudentUsingClipboardImage": "An attempt to {{keypress}} an image was blocked",
						"detectStuTryingto": "Test-taker attempted to ",
						"clearClip": "Clipboard has been cleared",
						"clearClipFail": "Clipboard could not be cleared",
						"stuNavigate": "Test-taker navigated to (from {{event}} ) ",
						"checkConnection": "Test-taker’s internet connection is below requirement. (upload speed: {{speed}} Mbps)",
						"verityConnectionCheck": "Test-taker's internet connection has been restored",
						"verityConnectionCheckFail": "Test-taker's internet connection has been lost",
						"blockingApplicationsFailed": "Verity could not retrieve a list of open applications.",
						"inputAccessCode": "Assessment password has been automatically injected",
						"inputAccessCodeFail": "Assessment password could not be automatically injected",
						"disableSavePassword": "An attempt to save the password to the browser was blocked",
						"disableSavePasswordFail": "An attempt to save the password to the browser could not be blocked",
						"resetSavePassword": "Browser’s default password settings have been reset",
						"resetSavePasswordFail": "Browser’s default password settings could not be reset",
						"videoDetect": "Video Anomaly Detected",
						"videoDetectFail": "Video Anomaly Ended",
						"headMove": "Test-taker’s head has moved away from the center of the camera view.",
						"headMoveEnd": "Test-taker’s head has returned to the center of the camera view.",
						"webcamReconnect": "Webcam or audio device has been reconnected",
						"screenShareResume": "Screen sharing has been resumed",
						"secondMonitorDisconnect": "An additional monitor has been disconnected",
						"faceReenter": "Test-taker’s face has re-entered the camera view",
						"webcamDisconnect": "Webcam or audio device has been disconnected",
						"screenShareStop": "Screen sharing has been stopped",
						"screenShareFrozen": "Screen activity not detected",
						"screenShareResumeFrozen": "Screen has resumed activity",
						"secondMonitorDetect": "An additional monitor has been detected ",
						"faceInvisible": "Test-taker's face is not visible",
						"audioDisturb": "Audio disturbance detected",
						"oldOpensBlockedApp": "A blocked application was opened",
						"opensBlockedApp": "A blocked application was opened: {{appName}}",
						"opensBlockedApps": "{{count}} blocked applications were opened: {{appNames}}",
						"safeEnablesBlockedExtension": "A blocked extension was enabled",
						"enablesBlockedExtension": "A blocked extension was enabled: {{extName}}",
						"enablesBlockedExtensions": "{{count}} blocked extensions were enabled: {{extName}}",
						"enablesHandoff": "Test-taker has turned on Handoff ",
						"proctor": "Proctor",
						"addNote": "The proctor {{name}} has added a live note.",
						"audioBridgeStart": "The proctor started an audio call with the test-taker",
						"proctorJoined": "The proctor has re-entered the session",
						"proctorLeft": "The proctor has left the session",
						"joinWithoutProctor": "The test-taker joined the session without a proctor",
						"noProctors": "There are no proctors in the session",
						"multiplePeopleDetected": "Multiple people are detected",
						"cellPhoneDetected": "Detected a cell phone in the camera view",
						"laptopDetected": "Detected a laptop in the camera view",
						"bookDetected": "Detected a book in the camera view",
						"objectDetected": "Detected a {{object}} in the camera view",
						"objectDetectedMany": "Detected multiple objects in the camera view",
						"keystrokeDetected": "The test-taker has entered the following keystrokes: {{keystrokes}}",
						"recordingMiss": "Recordings may have ended early or begun late.",
						"videoUnavail": "Video is unavailable",
						"videoProcess": "Video is processing",
						"videoNotBegun": "Video recording has not begun at this event",
						"videoEndEarly": "Recordings may have ended early or begun late.",
						"noEvents": "No Events Found",
						"eventsTableAriaLabel": "Session events",
						"expand": "View more details",
						"collapse": "Hide details",
						"type": "Type",
						"eventTimestamp": "Time",
						"eventDescription": "Description",
						"eventLevel": "Level",
						"forDurationSeconds": "for {{duration}} seconds",
						"actions": "Actions",
						"moreActions": "More actions",
						"resolve": "Resolve",
						"edit": "Edit event",
						"resolved": "Resolved",
						"hasComment": "This event has a comment",
						"comment": "Comment",
						"blockedNavigation": "Test-taker navigated to: ",
						"blockedNavigationAccess": "Test-taker attempted to access: ",
						"forceStoppedProctoring": "The test-taker clicked the End Proctoring button.",
						"noSubmission": "The proctoring session ended before the test-taker could submit their assessment.",
						"missingEndQuizVerification": "Submission status could not be verified",
						"faceIdMismatch": "Test-taker’s face does not match their ID card",
						"bypassedAiDetection": "Test-taker was unable to complete AI ID verification and manually uploaded their photos instead",
						"collaborationDetected": "Collaboration detected with {{name}}",
						"viewStudentMessage": "View Details",
						"viewStudentMessageModalTitle": "Test-Taker’s Comment for Ending Proctoring",
						"viewStudentMessageModalDescription": "Comment",
						"restrictedDeviceConnected": "Test-taker’s mobile device has been connected",
						"restrictedDeviceDisconnected": "Test-taker’s mobile device has been disconnected",
						"restrictedDeviceLocked": "Test-taker has enabled Guided Access on their mobile device",
						"restrictedDeviceUnlocked": "Test-taker has disabled Guided Access on their mobile device",
						"restrictedDeviceUnknown": "Test-taker’s mobile device status is unknown",
						"flaggedKeyword": "Keyword Detected: {{keyword}}",
						"createEvent": "Event",
						"typedSignature": "Test-taker has typed their signature: <b>{{signature}}</b>",
						"systemResource": "Test-taker’s system performance is below requirement (CPU: {{cpu}}%, Memory: {{memory}}%)",
						"notInGeofence": "Test-taker’s location is outside the selected geofence.",
						"locationUnknown": "Test-taker’s location could not be detected.",
						"notInIpAddressRange": "Test-taker’s IP address is outside the allowed range for this assessment.",
						"ipAddressUnknown": "Test-taker’s IP address could not be detected.",
						"tableRowAriaLabel": "Navigate to {{time}}",
						"installedExtensionsSnapshot_one": "Test-taker has {{count}} browser extension installed. <a>View the installed extensions list</a>.",
						"installedExtensionsSnapshot_other": "Test-taker has {{count}} browser extensions installed. <a>View the installed extensions list</a>.",
						"runningApplicationsSnapshot_one": "Test-taker had {{count}} application running. <a>View the running applications list</a>.",
						"runningApplicationsSnapshot_other": "Test-taker had {{count}} applications running. <a>View the running applications list</a>."
					},
					"collaborationDetectedEventRowTSX": {
						"answerSimilarityDetected": "Answer similarity detected between two students.",
						"review": "View",
						"resolve": "Resolve",
						"patternMatchDetected": "Pattern Match Detected",
						"patternMatchSubtitleWithGap": "2 independent signals detected, submitted {{seconds}} seconds apart",
						"patternMatchSubtitle": "2 independent signals detected",
						"flaggedQuestions": "Flagged Questions ({{count}})",
						"cancel": "Cancel",
						"close": "Close",
						"markAsResolved": "Mark as Resolved",
						"title": "Potential Collaboration Detected",
						"descriptionTextEssay": "{{studentName}} and {{partnerName}} submitted essay answers with significant matching text on {{matchCount}} question(s).",
						"descriptionText": "{{studentName}} and {{partnerName}} submitted suspicious answers while active during overlapping time windows.",
						"matchingAnswersLabel": "of answers flagged as suspicious",
						"overlapTimeLabel": "of assessment time overlapped",
						"essayMatchConfidenceLabel": "confidence in the essay text match",
						"supportingEvidence": "Supporting Evidence",
						"flaggedQuestionsReviewed": "{{count}} flagged questions reviewed below",
						"viewLessFlaggedQuestions": "View less flagged questions",
						"viewMoreFlaggedQuestions": "View {{count}} more flagged questions"
					},
					"flaggedQuestionTSX": {
						"correctTag": "Correct",
						"incorrectTag": "Incorrect",
						"answersMatchedSimple": "Both answered: {{answer}} · ",
						"answersMatchedMatching": "Both gave identical matches · {{correctCount}} of {{total}} correct",
						"answersMatchedBlanks": "Both gave identical answers · {{correctCount}} of {{total}} blank(s) correct",
						"premise": "Premise",
						"theirAnswer": "Their Answer",
						"correctAnswer": "Correct: {{answer}}",
						"blankLabel": "Blank {{blankId}}: ",
						"questionLabel": "Q{{number}} · ",
						"bothActive": "Both active {{timespan}} · {{studentName}} {{studentDuration}} · {{partnerName}} {{partnerDuration}}",
						"questionTypeTrueFalse": "T/F",
						"questionTypeMultipleChoice": "MC",
						"questionTypeMatching": "Matching",
						"questionTypeFillInBlank": "Fill-blank",
						"questionTypeOrdering": "Ordering",
						"questionTypeEssay": "Essay",
						"essaySimilarityBanner": "Both essays contain identical passages and closely matched phrasing across {{count}} passages, suggesting copied content.",
						"showFullAnswers": "Show full answers",
						"hideFullAnswers": "Hide full answers",
						"studentAnswerLabel": "{{name}}'s Answer:",
						"trueFalseBannerCorrect": "Both students selected the correct answer within {{seconds}} seconds of each other.",
						"trueFalseBannerWrong": "Both students selected the wrong answer within {{seconds}} seconds of each other.",
						"multipleChoiceBannerCorrect": "Both students selected the correct answer within {{seconds}} seconds of each other.",
						"multipleChoiceBannerWrong": "Both students selected the same wrong answer within {{seconds}} seconds of each other.",
						"matchingBannerCorrect": "Both students selected identical pairings.",
						"matchingBannerWrong": "Both students selected identical pairings, including the same incorrect matches.",
						"fillInBlankBannerAllCorrect": "Both students filled in identical responses for all {{count}} blanks.",
						"fillInBlankBannerAllMistake": "Both students filled in identical responses for all {{count}} blanks, including the same error.",
						"fillInBlankBannerSingleCorrect": "Both students filled in identical responses for the blank.",
						"fillInBlankBannerSingleMistake": "Both students filled in identical responses for the blank, including the same error.",
						"orderingBannerCorrect": "Both submitted items in the same order.",
						"orderingBannerIncorrect": "Both submitted items in the same incorrect order.",
						"theirAnswerValue": "Their answer: {{answer}}",
						"theirSubmittedOrder": "Their submitted order:",
						"positionLabel": "Position {{position}}: {{answer}}"
					},
					"videoPlayerTSX": {
						"wrongResponseVideoUrl": "Wrong response for getVideoUrl",
						"failGetNote": "Failed to get session note",
						"failAddNote": "Failed to add session note",
						"failEditNote": "Failed to edit session note",
						"failDeleteNote": "Failed to delete session note",
						"requestDownload": "Requesting Download",
						"downloadRequestSend": "Download Request Sent",
						"downloadRequestSendText": "Your download request has been sent successfully. A link to download the recording will be sent to your email at {{emailDestination}} when it is ready.",
						"downloadRequestNotSend": "Recording Is Processing",
						"downloadRequestNotSendText": "Your requested recording is currently being processed. Once it’s complete, you will receive an email with instructions on how to download it.",
						"close": "Close",
						"sessionNote": "Session Notes",
						"sessionNoteText": "Create and edit notes while reviewing proctoring results.",
						"liveNote": "Live Notes",
						"liveNoteText": "Review notes created by the proctor during the live assessment.",
						"confirmMessage": "The video player will be displayed fullscreen in a new tab. Would you like to continue?",
						"changeFullScreenBtn": "Change Fullscreen Mode Button",
						"centerMode": "Equal split view with screen capture and webcam",
						"screenWebcam": "Large screen capture with small webcam",
						"minimizedWebcam": "Large webcam with small screen capture",
						"screenCaptureOnly": "Show only the screen capture",
						"webcamOnly": "Show only the webcam video",
						"exitFullscreen": "Exit fullscreen",
						"enterFullscreen": "Enter fullscreen",
						"downloadVideo": "Download Video",
						"proctorNoNote": "The live proctor did not add any notes to this video.",
						"youHaventAddNote": "You have not added notes to this video. To begin, navigate to a point in the video and start typing below.",
						"addNoteFail": "Failed to add note.",
						"thumbnail": "Thumbnail",
						"flagLvl": "Flag Level",
						"flagDetail": "Flag Details",
						"timestamp": "Timestamp",
						"attempt": "Attempt",
						"webcam": "Webcam",
						"screen": "Screen Recording",
						"audio": "Audio",
						"webcamAndScreenRecording": "Webcam & Screen",
						"webcamAndAudio": "Webcam & Audio",
						"screenAndAudio": "Screen & Audio",
						"flaggedEvents": "Events",
						"notes": "Notes",
						"roomScan": "Room Scan",
						"idPhotos": "ID Photos",
						"referenceMaterial": {
							"tab": "Reference Material",
							"unavailableTitle": "Reference Material Not Uploaded",
							"unavailableDescription": "The test-taker did not upload any attachments before starting their assessment.",
							"fullScreenAriaLabel": "View reference material in full screen",
							"closeFullScreenAriaLabel": "Close full screen view"
						},
						"scratchNote": {
							"tab": "Attachments",
							"errorTitle": "Image Is Unavailable",
							"errorDescription": "The image may be corrupted. Try checking back later to see if it is available.",
							"unavailableTitle": "No Attachments Submitted",
							"unavailableDescription": "The test-taker has not submitted any attachments for this assessment.",
							"previous": "Previous",
							"next": "Next"
						},
						"signature": {
							"tab": "Signature",
							"errorTitle": "Image of Signature Is Unavailable",
							"errorDescription": "Try checking back later to see if it is available. If you still do not see the image, the file may be corrupted.",
							"imageAltPhoto": "Photo of signature",
							"imageAltDrawn": "Drawn signature"
						},
						"aiSummary": {
							"overallSummary": "Overall Summary",
							"severe": "Severe",
							"major": "Major",
							"minor": "Minor",
							"analyzingProctoringData": "Analyzing proctoring data..."
						},
						"liveProctorSummary": "Proctored Session Summary",
						"summaryButton": "Summary",
						"summaryFieldPlaceholder": "Enter session summary",
						"cancel": "Cancel",
						"save": "Save",
						"configurations": "Configurations",
						"playVideoLabel": "Play",
						"restartVideoLabel": "Restart Video",
						"pauseVideoLabel": "Pause",
						"question": "Question {{number}}",
						"ariaLabels": {
							"unmute": "Unmute audio",
							"mute": "Mute audio",
							"volume": "Volume",
							"seekSlider": "Seek",
							"mediaProgressSlider": "Media Progress",
							"playbackSpeed": "Playback speed ({{speed}}x)",
							"moreOptions": "More options",
							"settings": "Settings",
							"close": "Close",
							"videoPlayerControls": "Video player controls"
						}
					},
					"durationAriaLabel": {
						"hours_one": "{{count}} hour",
						"hours_other": "{{count}} hours",
						"minutes_one": "{{count}} minute",
						"minutes_other": "{{count}} minutes",
						"seconds_one": "{{count}} second",
						"seconds_other": "{{count}} seconds"
					},
					"videoPlayerWrapperTSX": {
						"sessionNum": "Session: {{number}}"
					},
					"settings": {
						"title": "Settings",
						"aiCategory": "Display AI-Confidence Scores",
						"faceDetectionSubcategory": "Face Detected",
						"gestureDetectionSubcategory": "Movement Detected",
						"gazeDirectionSubcategory": "Gaze Direction",
						"objectDetectionSubcategory": "Object Detected"
					},
					"overlay": {
						"faceDetection": "Face",
						"objectDetection": "Object",
						"score": "Confidence"
					},
					"videoLayout": {
						"side": "Sidebar View",
						"bottom": "Bottom View",
						"single": "Carousel Mode",
						"singleVideoLayout": {
							"left": {
								"tooltip": "Previous View",
								"disabledTooltip": "No more items to the left"
							},
							"right": {
								"tooltip": "Next View",
								"disabledTooltip": "No more items to the right"
							}
						}
					},
					"videoLabel": {
						"webcam": "Webcam",
						"microphone": "Audio Recording",
						"screencapture": "Screen Recording"
					}
				},
				"selectionMenuTSX": {
					"currentAttemp": "Current Attempts",
					"unflagged": "Unflagged",
					"flagged": "Flagged",
					"incomplete": "Incomplete",
					"pending": "Pending",
					"error": "Error",
					"reviewAndSee": "Review and see test-takers proctoring sessions. Select an attempt from the drop-down menu.",
					"playSession": "Play Session",
					"studentName": "Test-Taker Name",
					"attempts": "Attempt(s)",
					"attemptFirst": "First Attempt",
					"attempLast": "Last Attempt",
					"flagLvl": "Flag Level",
					"pendingg": "Pending...",
					"none": "Info",
					"minor": "Minor",
					"major": "Major",
					"severe": "Severe",
					"late": "(Late)",
					"viewDetail": "View Details",
					"close": "Close",
					"view": "View",
					"noData": "No Data",
					"needExtension": "You must have the Verity extension installed and enabled.",
					"authUser": "Please authenticate yourself using the Verity LTI link.",
					"noResult": "No Results Found",
					"complete": "Complete",
					"unavailable": "Unavailable",
					"startDateAndTime": "Start Date and Time",
					"duration": "Duration",
					"viewResults": "View Results",
					"actions": "Actions",
					"viewConfigurations": "View Configurations",
					"viewIdVerification": "View ID Verification",
					"status": "Status",
					"flags": "Flags",
					"verityConfig": "Verity Configurations",
					"verityOptionFailToastMsg": "Failed to get Verity Configurations.",
					"allNotes": "All Notes",
					"videoNotes": "Recording Notes",
					"roomScanNotes": "Room Scan Notes",
					"testTaker": "Test-Taker",
					"attemptsCount": "Attempts",
					"startDate": "Start Date",
					"testTakerAnalytics": "Test-Taker Analytics",
					"viewAssessmentAttempts": "View the assessment attempts submitted by test-takers.",
					"searchByTestTakers": "Search by test-taker",
					"averageDuration": {
						"seconds_one": "{{count}} second",
						"seconds_other": "{{count}} seconds",
						"minutes_one": "{{count}} minute",
						"minutes_other": "{{count}} minutes",
						"hours_one": "{{count}} hour",
						"hours_other": "{{count}} hours"
					}
				}
			},
			"testResultsTSX": {
				"missCourse": "Missing course",
				"liveNote": "Live Session Notes",
				"noAuthUser": "Could not get authentication user"
			},
			"resultsPage": {
				"testResultsWrapperTSX": {
					"unamedAssessment": "Unnamed Assessment",
					"unknownStudent": "Unknown Student",
					"course": "Select Course",
					"assessment": "Select Assessment",
					"selectCoursePrompt": "Please select a course",
					"selectAssessmentPrompt": "Please select an assessment",
					"assessmentResultWithName": "Assessment Result ({{name}})",
					"assessmentResult": "Assessment Result",
					"overviewMsg": "An overview of key analytics for the assessment results.",
					"switchAssessment": "Switch Assessment",
					"totalAssessmentCompleted": "Total Assessments Completed",
					"severeFlaggedUsers": "Test-Takers with Severe Flag Level",
					"majorFlaggedUsers": "Test-Takers with Major Flag Level",
					"minorFlaggedUsers": "Test-Takers with Minor Flag Level",
					"courseID": "Course ID",
					"courseName": "Course Name",
					"selectCourse": "Select Course",
					"confirm": "Confirm",
					"searchForCourse": "Search for course",
					"noCoursesFound": "No Courses Found.",
					"assessmentID": "Assessment ID",
					"assessmentName": "Assessment Name",
					"selectAssessment": "Select Assessment",
					"searchForAssessment": "Search for an assessment",
					"noAsessmentsFound": "No Asessments Found."
				},
				"eventTypeSelectorTSX": {
					"allEvents": "All Events",
					"tabNotActive": "Tab Not Active",
					"copyandPaste": "Copy and Paste",
					"handoffEnabled": "Handoff Enabled",
					"WebNav": "Web Navigation",
					"screenshot": "Screenshot",
					"webcamAndAudio": "Webcam and Audio",
					"screenshareInterrupted": "Screen Share Interrupted",
					"screenshareInactive": "Screen Activity Not Detected",
					"multipleDisplays": "Multiple Displays",
					"faceNotDetected": "Face Not Detected",
					"multiplePeopleDetected": "Multiple People Detected",
					"severalPeopleDetected": "Several People Detected",
					"objectDetected": "Object Detected",
					"audioDetected": "Audio Detected",
					"blockedAppOpened": "Blocked Application Opened",
					"blockedExtensionEnabled": "Blocked Extension Enabled",
					"navBlocked": "Navigation Blocked",
					"sidePanelDetected": "Side Panel Detected",
					"rightClickAttempt": "Attempted to Right Click",
					"printAttempt": "Attempted to Print",
					"toggledMobileLockdown": "Pinned Mode / Guided Access Toggled",
					"visitedDecoySite": "Visited Decoy Website",
					"noSubmission": "No Submission",
					"connectionInterrupted": "Connection Interrupted",
					"sessionStart": "Session Start",
					"sessionEnd": "Session End",
					"quizStart": "Quiz Start",
					"quizEnd": "Quiz End",
					"recordingStart": "Recording Start",
					"recordingEnd": "Recording End",
					"uploadIncomplete": "Upload Incomplete",
					"codeAutofill": "Access Code Autofill",
					"audioBridge": "Audio Bridge",
					"live": "Live",
					"connectionStatus": "Connection Status",
					"blockAppsFailed": "Block Applications Failed",
					"faceIdMismatch": "Face Not Matched with ID Card",
					"IdSkippedAi": "AI ID Verification Skipped",
					"collaborationDetected": "Collaboration Detected",
					"recordAppsActivity": "Record Applications Activity",
					"humanFlaggedEvent": "Human-Flagged Event",
					"restrictedDevice": "Restricted Device",
					"flaggedKeyword": "Flagged Keyword"
				},
				"indexTSX": {
					"eventType": "Event Type",
					"flagType": "Flag Type",
					"flagLevel": "Flag Level",
					"none": "Info",
					"minor": "Minor",
					"major": "Major",
					"severe": "Severe",
					"updateVideo": "Refresh Video",
					"updateVideoTooltip": "Manually refresh the video to the current time",
					"livePopIn": "Live Check-In",
					"joinPopInFailed": "An error occurred while joining the live check-in session."
				},
				"proctoringResultsHeaderTSX": {
					"profilePicture": "profile picture",
					"course": "Course",
					"assessment": "Assessment",
					"startDate": "Start Date",
					"overall": "Overall",
					"severe": "Severe",
					"major": "Major",
					"minor": "Minor",
					"flags": "Flags",
					"backButtonAriaLabel": "Go back to Assessment Results page"
				},
				"proctoringResultsViewTSX": {
					"mainTabsAriaLabel": "Assessment content tabs",
					"secondaryTabsAriaLabel": "Session details tabs",
					"thirdPartyAssessmentDetails": "Third-Party Assessment Details",
					"assessmentUrl": "Assessment Url: {{url}}",
					"assessmentPassword": "Assessment Password: {{password}}",
					"details": "Details",
					"platforms": "Platform: {{platforms}}",
					"settingsSelected": "Settings Selected",
					"idPhoto": "ID Photo",
					"idPhotoAlt": "Photo of Student ID",
					"verificationPhoto": "Verification Photo",
					"verificationPhotoAlt": "Photo of Test-Taker",
					"deleteRecording": "Delete Recording",
					"unknownAssessment": "Unknown Assessment",
					"unnamedStudent": "Unnamed Test-Taker",
					"attemptStatus": "Attempt Status:",
					"attempt": "Attempt {{current}}/{{total}}",
					"attempt2": "Attempt {{attempt}}/{{total}}",
					"testTakerSelectorLabel": "Test-Taker",
					"attemptSelectorLabel": "Attempt",
					"syncedToLmsTooltip": "This attempt has been successfully synced with your LMS",
					"previous": "Previous",
					"next": "Next",
					"noNotesAdded": "No Notes Added",
					"enterNotes": "Enter your notes",
					"saveNotes": "Save notes",
					"roomScanNotes": "Room Scan Notes",
					"emailRecording": "Email Recording",
					"receiverInfoTxt": "Enter the name and email you would like to send the recording to.",
					"fullName": "Full Name",
					"email": "Email",
					"cancel": "Cancel",
					"send": "Send",
					"method": "Method: {{method}}",
					"proctoringMethods": {
						"live": "Live Proctoring",
						"popin": "Live Check-In",
						"automated": "Automated Proctoring"
					},
					"saveLater": "Save Draft",
					"saveGrade": "Save Grade",
					"submittedFiles": "Submitted Files: {{count}}",
					"unlimitedAttempts": "Unlimited Attempts",
					"limitedAttempts": "{{count}} Attempts Allowed",
					"assignmentInstructions": "Assignment Instructions",
					"questions": {
						"questionLabel": "Question {{n}}",
						"navLabel": "Q{{n}}",
						"navItemAriaLabel": "Question {{n}}",
						"scrollLeft": "Scroll questions left",
						"scrollRight": "Scroll questions right",
						"emptyState": "No questions found for this session.",
						"questionSection": "Question:",
						"answerSection": "Answer:",
						"pointsLabel": "Points: {{count}}",
						"scoredLabel": "Scored: {{count}}",
						"unanswered": "Unanswered",
						"ungradedLabel": "Ungraded",
						"correctAnswer": "Correct Answer:",
						"blankLabel": "Blank {{n}}.",
						"aiJustificationLabel": "Why AI Scored This:",
						"viewGradingGuideline": "View Grading Guideline",
						"aiGradedBadge": "AI Graded",
						"playAudio": "Play",
						"pauseAudio": "Pause",
						"replayAudio": "Replay",
						"MultipleChoice": {
							"label": "Multiple Choice"
						},
						"TrueFalse": {
							"label": "True or False"
						},
						"Matching": {
							"label": "Matching"
						},
						"FillInTheBlank": {
							"label": "Fill in the Blank"
						},
						"Essay": {
							"label": "Essay"
						},
						"Ordering": {
							"label": "Ordering"
						},
						"AudioRecording": {
							"label": "Recording"
						},
						"FileSubmission": {
							"label": "File Submission"
						},
						"DragAndDrop": {
							"label": "Drag & Drop"
						},
						"Dropdown": {
							"label": "Dropdown"
						},
						"Spreadsheet": {
							"label": "Spreadsheet"
						},
						"Coding": {
							"label": "Coding"
						},
						"gradeTitle": "You can adjust the points",
						"gradeDescription": "Override the graded result for this question.",
						"gradeDescriptionForUngraded": "Grade this question.",
						"updateManualGradeQuestionDescription": "Override the graded result for this question.",
						"correct": "Correct ({{points}} pts)",
						"incorrect": "Incorrect (0 pts)",
						"statusTooltip": {
							"correct": "Correct: Full points awarded.",
							"partial": "Partially Correct: Some points awarded.",
							"incorrect": "Incorrect: No points awarded.",
							"ungraded": "Ungraded: This question requires manual grading.",
							"unanswered": "Unanswered: No response was submitted."
						}
					},
					"answer": "Answer:",
					"gradedByPoints": "Graded by points",
					"gradedByPointsDesc": "Grade this assignment by typing points.",
					"noFiles": "No Files Submitted",
					"goToFile": "Go to file number (total: {{total}})",
					"fullScreenAriaLabel": "View file in full screen",
					"zoomInAriaLabel": "Zoom in",
					"zoomOutAriaLabel": "Zoom out",
					"closeFullScreenAriaLabel": "Close full screen view",
					"unsavedChanges": {
						"title": "Save Attempt {{number}}?",
						"description": "You have unsaved changes for this attempt. Would you like to save them as a draft or finalize the grade before switching?",
						"saveDraft": "Save as Draft",
						"finalizeGrade": "Save and Finalize",
						"cancel": "Discard Changes"
					},
					"saveSuccessDraft": "Draft Saved Successfully",
					"saveSuccessFinal": "Grade Saved and Finalized Successfully",
					"saveSyncError": "Grades saved to Verity, but LMS synchronization failed. Please try again to sync the grade with your LMS.",
					"saveFail": "Failed to save grades. Please try again.",
					"writeNotePlaceholder": "Write your feedback for the response...",
					"invalidScore": "Please enter a valid score.",
					"scoreExceedsMax": "Score exceeds the maximum points for this question.",
					"scoreNegative": "Score cannot be negative.",
					"scoreRequired": "Score is required.",
					"fixErrorsToast": "The following questions contain issues: {{questionNumbers}}. Please check each question and resolve the issues to continue.",
					"previewImage": "Preview {{fileName}}",
					"gradeSyncBanner": "The latest version has been successfully synced to Verity",
					"gradeSyncLmsBanner": "This attempt has been successfully synced with your LMS",
					"unsavedChangesBanner": "This grade is unpublished. Students will see their previously published score until you publish these changes",
					"ungradedQuestionsBanner": "There are ungraded questions in this attempt. Please grade all questions before publishing.",
					"integrityBadge": "Integrity score"
				},
				"proctoringEventsTableTSX": {
					"type": "Type",
					"flagDescription": "Flag Description",
					"flagLevel": "Flag Level",
					"none": "Info",
					"severe": "Severe",
					"major": "Major",
					"minor": "Minor",
					"flags": "Flags",
					"time": "Time",
					"actions": "Actions",
					"resolve": "Resolve",
					"errorLoading": "Error loading events.",
					"noEvents": "No Events",
					"noFlags": "No Flagged Events",
					"flagFilterTooltip": "{{count}} {{level}}"
				},
				"videoPlayerCard": {
					"recordingDeletedTitle": "Recording Deleted",
					"recordingErrorTitle": "Recording Is Unavailable",
					"recordingIncompleteTitle": "Assessment in Progress",
					"recordingEndedTitle": "Video Finished Playing",
					"recordingDeletedText": "A course admin has deleted the recording.",
					"recordingIncompleteText": "The recording will be available once the assessment is submitted. Please check back later.",
					"recordingErrorText": "The recording may be corrupted. Try checking back later to see if it is available.",
					"recordingEndedText": "You can click the play button to rewatch the video.",
					"recordingExpiredTitle": "Proctoring Recording Unavailable",
					"recordingExpiredText": "The proctoring recording is no longer available. Recordings are permanently removed after the retention period configured by your institution.",
					"recordingLimitReachedTitle": "Recording Ended",
					"recordingLimitReachedText": "The recording ended based on your institution’s recording settings. You can continue reviewing flagged events, but video is not available beyond this point."
				},
				"proctoringResultsReport": {
					"unavailableName": "Unavailable",
					"title": "Proctoring Results Report",
					"testTakerName": "Test-Taker Name:",
					"exportedBy": "Exported By:",
					"tableOfContents": "Table of Contents",
					"sessionSummary": "Session Summary",
					"sessionSummaryBody": "View a summary of the test-taker's session",
					"flaggedEvents": "Flagged Events",
					"flaggedEventsBody": "View a summary of the flagged events",
					"sessionNotes": "Session Notes",
					"sessionNotesBody": "View notes for this session",
					"roomScanNotes": "Room Scan Notes",
					"roomScanNotesBody": "View notes for the test-taker's room scan recording",
					"keystrokeLog": "Keystroke Log",
					"keystrokeLogBody": "View all keystrokes entered by thetest-taker",
					"thumbnail": "Thumbnail",
					"event": "Event Details",
					"time": "Time",
					"resolved": "Resolved",
					"comment": "Comment",
					"generateReport": "Generate Report",
					"generating": "Generating",
					"downloadReport": "Download Report",
					"downloading": "Downloading",
					"regenerateButtonAriaLabel": "Regenerate report",
					"regenerateReport": "Regenerate Report"
				},
				"pdfGenerator": {
					"screenRecording": "Screen Recording",
					"scanRoom": "Room Scan",
					"videoRecordingMode": "Record Video",
					"blockVirtualMachines": "Block Virtual Machines",
					"recordApplicationsActivity": "Record Applications Activity",
					"recordWebTraffic": "Record Web Traffic",
					"detectSidePanel": "Detect Side Panel",
					"closeOpenTabs": "Close Open Tabs",
					"disableClipboardMode": "Disable Clipboard",
					"enableGuidedAccessMode": "Enable Guided Access",
					"restrictHandoffMode": "Disable Handoff",
					"disableDownloadFiles": "Disable Download Files",
					"disableNewTab": "Disable New Tab",
					"disablePrinting": "Disable Printing",
					"disableRightClick": "Disable Right Click",
					"extensionBlockMode": "Block Other Extensions",
					"logInstalledExtensions": "View Installed Browser Extensions",
					"logRunningApplications": "View Running Applications",
					"disableSpellcheck": "Disable Spell Check",
					"faceTrackingMode": "Face Tracking",
					"hideOtherWindows": "Hide Other Applications",
					"idVerification": "ID Verification",
					"objectDetectionMode": "Object Detection",
					"oneScreenEnforcementMode": "One Screen Enforcement",
					"recordInput": "Record Input",
					"audioRecordingMode": "Record Audio",
					"enableCalculator": "Calculator",
					"enableWhiteboard": "White Board",
					"uploadSignature": "Signature",
					"bodyText": {
						"details": "Proctored Session Details",
						"requirements": "Proctoring Requirements",
						"summary": "Summary of requirements the test-taker provided",
						"methods": "Methods",
						"methodsSummary": "Summary of methods the test-taker used",
						"extension": "Browser Extension",
						"lockdownModule": "Lockdown App"
					}
				},
				"ariaLabels": {
					"studentComboBox": "Select test-taker to view",
					"attemptComboBox": "Select attempt to view",
					"eventComboBox": "Select events to view",
					"flagLevelComboBox": "Select flag levels to view"
				},
				"deleteModal": {
					"description": "Are you sure you want to permanently delete this recording?",
					"success": "The recording has been successfully deleted.",
					"error": "The recording could not be deleted. Please try again.",
					"title": "Delete Recording",
					"cancel": "Cancel"
				},
				"deleteAttemptModal": {
					"title": "Delete Attempt",
					"description": "Are you sure you want to remove <b>Attempt {{attempt}}</b> for <b>{{studentName}}</b>? This action cannot be undone and all associated proctoring data will be permanently deleted.",
					"cancel": "Cancel",
					"delete": "Delete Attempt",
					"success": "The attempt has been successfully deleted.",
					"error": "The attempt could not be deleted. Please try again."
				},
				"eventComboBoxName": "Events",
				"flagLevelComboBoxName": "Flag level",
				"downloadKeystrokes": "Download Keystrokes",
				"downloadAppsActivity": "Download App Activity Log",
				"downloadAudioTranscript": "Download Audio Transcript",
				"downloadStudentActivity": "Download Keystroke and App Activity Log",
				"viewInstalledBrowserExtensions": "View Installed Browser Extensions",
				"viewRunningApplications": "View Running Applications",
				"extensionModal": {
					"title": "Installed Browser Extensions",
					"description": "View the browser extensions installed before the assessment.",
					"search": "Search by browser extension name",
					"tableHeader": "Browser Extension ({{count}})",
					"noResults": "No Matching Results",
					"emptyTitle": "No Browser Extensions Detected",
					"emptyDescription": "No browser extensions were found on the test-taker’s device before the assessment.",
					"close": "Close"
				},
				"runningApplicationsModal": {
					"title": "Running Applications",
					"description": "View the applications running before the assessment.",
					"search": "Search by application name",
					"tableHeader": "Application ({{count}})",
					"noResults": "No Matching Results",
					"emptyTitle": "No Running Applications Detected",
					"emptyDescription": "No running applications were found on the test-taker’s device before the assessment.",
					"close": "Close"
				}
			},
			"resolveModalTSX": {
				"title": "Resolve Flagged Event",
				"description": "Mark the event as resolved. You may also enter a comment if you want to provide additional details.",
				"comment": "Comment",
				"enterComment": "Enter a comment for this flagged event",
				"cancel": "Cancel",
				"resolve": "Resolve",
				"textAreaAriaLabel": "Comment"
			},
			"customEventModalTSX": {
				"createEvent": "Add New Event",
				"createDescription": "Create an event to flag an unusual behavior in a test-taker’s session.",
				"editEvent": "Edit Event",
				"editDescription": "Update the flag level and details of this human-flagged event.",
				"time": "Event Time",
				"flagLevel": "Flag Level",
				"none": "Info",
				"minor": "Minor",
				"major": "Major",
				"severe": "Severe",
				"message": "Event Details",
				"addMessage": "Describe details about the event…",
				"create": "Add Event",
				"save": "Save Changes",
				"cancel": "Cancel",
				"eventCreated": "The human-flagged event has been successfully added.",
				"createEventFailed": "The human-flagged event could not be added. Please try again.",
				"eventUpdated": "The event has been successfully updated.",
				"updateEventFailed": "The event could not be updated. Please try again."
			}
		}
	},
	"scopeTestFramework": {
		"components": {
			"modal": {
				"title": "Test API Access",
				"information": "Your institution’s API access allows Verity to create and delete assessments. If the API fails, please update your key. ",
				"link": "Learn more",
				"instituteTestsHeader": "Institution",
				"courseTestsHeader": "Course",
				"buttons": {
					"requestTests": "Test API",
					"cancel": "Cancel",
					"testConnectionAgain": "Test Connection Again"
				},
				"initiatorCourseIdHeader": "Course ID",
				"howToFixHeader": "How to Fix"
			}
		},
		"errors": {
			"alreadyQueued": "The tests have already been requested!",
			"pipelineError": "An error has occurred during test execution. Please try again.",
			"tokenError": "Unable to generate LMS OAuth token. Please try again.",
			"invalidScope": {
				"title": "Your LMS key is missing the permissions needed to connect to Verity",
				"howToFix": "Please follow the setup guide steps to authorize the required permissions inside your LMS. If issues persist, please contact support."
			},
			"oauthCancelled": {
				"title": "Authorization Cancelled",
				"description": "You cancelled the authorization with your LMS. Click Test Connection Again to try again.",
				"howToFix": "Test connection again and click on Authorize. If issues persist, please contact support."
			},
			"unknownOAuthError": {
				"title": "An unknown OAuth error occurred",
				"howToFix": "Please contact your Account Manager to resolve this issue."
			}
		},
		"tests": [
			{
				"key": "ReadAccounts",
				"title": "Read Accounts",
				"description": "Allow Verity to see accounts associated with this organization."
			},
			{
				"key": "ReadCourses",
				"title": "Read Courses",
				"description": "Allow Verity to see courses associated with this organization."
			},
			{
				"key": "CreateQuizzes",
				"title": "Create Assessments",
				"description": "Allow Verity to create assessments for the specified course."
			},
			{
				"key": "ReadQuizzes",
				"title": "Read Assessments",
				"description": "Allow Verity to read assessments for the specified course."
			},
			{
				"key": "UpdateQuizzes",
				"title": "Update Assessments",
				"description": "Allow Verity to update assessments for the specified course."
			},
			{
				"key": "DeleteQuizzes",
				"title": "Delete Assessments",
				"description": "Allow Verity to delete assessments for the specified course."
			}
		],
		"defaults": {
			"testTitle": "Verity API Test",
			"testDescription": "Allow Verity access to the required resource."
		}
	},
	"language": {
		"English": "English",
		"French": "French"
	},
	"settings": {},
	"setup": {
		"beforeAssessment": {
			"verityDisabled": "Verity Is Disabled for the Course",
			"unableToConnect": "Unable to Connect With Verity Browser Extension.",
			"askToEnable": "Please ask your instructor to enable Verity for the course to continue with your assessment.",
			"askToReinstall": "Please try uninstalling the Verity Browser Extension and reinstalling it from the Chrome Web Store."
		},
		"components": {
			"extensionSetupInstructionsTSX": {
				"test": {
					"replaceWith": "Replace with your actual content <0></0>",
					"replaceWith2": "Replace with your actual content <0></0>"
				},
				"title": "Set Up Your YuJa Verity Test Proctoring Experience",
				"description": "Follow the steps below to help you get started.",
				"videoTitles": {
					"canvas": "Yuja Verity Test Proctoring Video guide. First Time Verity Authentication for Canvas",
					"moodle": "Yuja Verity Test Proctoring Video guide. First Time Verity Authentication for Moodle",
					"desire2learn": "Yuja Verity Test Proctoring Video guide. First Time Verity Authentication for D2L",
					"BlackboardLearn": "Yuja Verity Test Proctoring Video guide. First Time Verity Authentication for Blackboard",
					"BlackboardLearnUltra": "Yuja Verity Test Proctoring Video guide. First Time Verity Authentication for Blackboard Ultra"
				},
				"steps": {
					"browser": {
						"incomplete": {
							"title": "Launch in a Supported Browser",
							"description": "You are using an browser that is not supported by Verity. Please launch YuJa Verity in one of the following browsers: Chrome, Brave, Edge, Opera, Firefox or Safari."
						},
						"complete": {
							"title": "Supported Browser",
							"description": "You are on a supported browser."
						}
					},
					"extension": {
						"incomplete": {
							"title": "Download the Browser Extension",
							"description": "Download the Verity Browser Extension from the {{store}}.",
							"download": "Download Extension",
							"updateTitle": "Update the Browser Extension",
							"updateDescription": "Update the Verity Browser Extension to the latest version from the {{store}}.",
							"update": "Update Extension"
						},
						"complete": {
							"title": "Extension Downloaded",
							"description": "You have downloaded the YuJa Verity Browser Extension."
						},
						"store": {
							"chromium": "Chrome Web Store",
							"firefox": "Firefox Add-ons store",
							"safari": "App Store"
						}
					},
					"managedGuestSession": {
						"incomplete": {
							"title": "Log in to a Managed Guest Session Account",
							"description": "Verity requires your Chromebook to be set up with a managed guest session by your institution. Please sign out of your device and log in with the guest session account on the sign-in screen.",
							"description2": "If this is your personal device, please take this assessment on a Windows or Mac device."
						},
						"complete": {
							"title": "Managed Guest Session",
							"description": "You are logged in to a managed guest session account."
						}
					},
					"incognito": {
						"incomplete": {
							"title": "Enable Incognito Mode for the Browser Extension",
							"description": {
								"step1": "Click the Extensions icon at the top-right of the browser.",
								"step2": "Locate YuJa Verity and click More options > Manage extension.",
								"step3": "Enable Allow in Incognito.",
								"paragraph": "Click the Extensions icon at the top-right of the browser, locate YuJa Verity and click More options > Manage extension, then enable Allow in Incognito"
							},
							"watch": "Watch our <a>step-by-step tutorial</a> video to learn more."
						},
						"complete": {
							"title": "Incognito Mode Enabled",
							"description": "You have enabled Incognito mode for the Verity Browser Extension."
						}
					},
					"authentication": {
						"incomplete": {
							"title": "Connect with {{lms}}",
							"description": "Click the button below to connect your Verity account with {{lms}}.",
							"authenticate": "Connect"
						},
						"complete": {
							"title": "Connected with {{lms}}",
							"description": "Your Verity account is connected with {{lms}}."
						}
					},
					"start": {
						"assessments": {
							"title": "You're All Set!",
							"description": "You can click the button below to go to your assessments.",
							"button": "Assessments"
						},
						"startAssessment": {
							"title": "You're All Set!",
							"description": "You can click the button below to start your assessment.",
							"button": "Begin Setup"
						},
						"checkCompatibility": {
							"title": "You're All Set!",
							"description": "You can click the button below to start the compatibility check.",
							"button": "Compatibility Check"
						}
					}
				}
			},
			"lockdownSetupInstructionsTSX": {
				"title": "Is This Your First Time Using the Verity Lockdown App?",
				"description": "Check to make sure your system meets the <a>minimum requirements</a>.",
				"options": {
					"mac": {
						"title": "Download the Verity Lockdown App for Mac",
						"downloadIntel": "Download for Intel Mac {{size}}",
						"downloadMSeries": "Download for M-Series Mac {{size}}",
						"ifUnsure": "Unsure of which Mac you have?",
						"learnMore": "Learn more"
					},
					"windows": {
						"title": "Download the Verity Lockdown App for Windows",
						"downloadExe": "Download EXE Version {{size}}",
						"downloadMsi": "Download MSI Version {{size}}",
						"singleDevice": "Download the EXE version if installing on a single device."
					}
				},
				"notFound": "We encountered an issue when retrieving the download link. Please try again."
			},
			"mobileSetupInstructionsTSX": {
				"title": "Is This Your First Time Using Verity Lockdown Mobile?",
				"description": "Download the app on your mobile device, then watch the video to learn more.",
				"options": {
					"ios": {
						"title": "Download the Verity Mobile App for iOS",
						"download": "Download for iOS",
						"requirement": "The app requires iOS 14 or later."
					},
					"android": {
						"title": "Download the Verity Mobile App for Android",
						"download": "Download for Android",
						"requirement": "The app requires Android 10 or later."
					}
				},
				"notFound": "Download URL not found"
			},
			"ProctoringSetupPage": {
				"proctoringRequired": "YuJa Verity Proctoring",
				"loading": "Loading setup",
				"loadingPreview": "Loading preview…",
				"FailedStepsBanner": {
					"title": "A previous check was interrupted.",
					"description": "Return to the affected check to complete it again.",
					"viewAndFix": "View and fix",
					"step": {
						"general": "One or more system checks need attention.",
						"payment": "Your payment needs to be completed again.",
						"camera": "Your camera check needs to be completed again.",
						"microphone": "Your microphone check needs to be completed again.",
						"display": "Screen recording needs to be set up again.",
						"mobile": "Your mobile device check needs to be completed again.",
						"roomScan": "Your room scan needs to be completed again.",
						"idPhoto": "Your ID card needs to be scanned again.",
						"facePhoto": "Your ID needs to be captured again.",
						"signature": "Your signature needs to be provided again.",
						"referenceMaterial": "Your reference material needs to be uploaded again."
					}
				},
				"SetupBanner": {
					"close": "Close"
				},
				"VideoGuideButton": {
					"watch": "Watch guide"
				},
				"RecordingIndicator": {
					"label": "Recording",
					"description": "Your camera feed is being recorded for proctoring."
				},
				"SetupSteps": {
					"title": "YuJa Verity Setup",
					"description": "Complete the checks below before starting your proctored assessment.",
					"stepPosition": "{{stepNumber}} of {{total}}",
					"completed": "Completed"
				},
				"StepPage": {
					"back": "Previous step",
					"continue": "Continue",
					"handover": "This check is complete. You can continue now.",
					"handoverPending": "Continuing to the next step…"
				},
				"GeneralSubstepEntry": {
					"substepFailed": "One thing needs your attention"
				},
				"RetryButton": {
					"retry": "Try Again",
					"continue": "Continue Anyway"
				},
				"MediaDeviceSelector": {
					"noDevices": {
						"audio": "No Audio Source Detected",
						"video": "No Video Source Detected"
					},
					"mobileCamera": "Use my mobile as a camera",
					"mobileCameraSelected": "Mobile Device Selected",
					"source": "Source"
				},
				"AudioLevelIndicator": {
					"loading": "Listening...",
					"detected": "Audio Detected",
					"microphoneLevel": "Microphone level"
				},
				"PhotoSubstepContent": {
					"videoSource": "Video Source",
					"selectWebcam": "Select Webcam",
					"retake": "Retake"
				},
				"SupportChatWindow": {
					"title": "Guided Support",
					"closeSupport": "Close support chat",
					"fetchingResponse": "Fetching response from support...",
					"askAboutIssue": "Ask about an issue",
					"send": "Send message",
					"specialElements": {
						"DISABLE_EXTENSION": "Disabling Browser Extension",
						"ENABLE_INCOGNITO": "Enabling Incognito Mode",
						"DISABLE_HANDOFF": "Disabling Handoff",
						"CLOSE_APPS": "Manually Closing an Application",
						"HELP_CENTER": "Verity Help Center",
						"ESCALATE": "Get Help"
					},
					"openSupport": "Open guided support",
					"notification": "Click here to get assistance."
				},
				"step": {
					"initialization": {
						"StartPage": {
							"description": "You will be guided through a short setup before your assessment.",
							"setupGuide": {
								"title": "Preview The Assessment",
								"description": "Preview the readiness check your students will complete before starting the exam. This runs the full setup process so you can verify the experience."
							},
							"startProctoring": "Start Assessment"
						}
					},
					"general": {
						"title": "System Check",
						"passed": "Checks passed",
						"completed": {
							"title": "",
							"description": "All system checks passed"
						}
					},
					"payment": "Payment",
					"camera": "Camera",
					"microphone": "Microphone",
					"display": "Screen Share",
					"mobile": "Mobile Camera",
					"mobileDevice": "Mobile Device",
					"roomScan": "Room Scan",
					"idPhoto": "ID Photo",
					"facePhoto": "Face Photo",
					"signature": "Signature",
					"referenceMaterial": "Reference Material",
					"finish": {
						"title": {
							"complete": "Finish",
							"incomplete": "Setup Incomplete"
						},
						"contentTitle": {
							"complete": "Great, everything’s good to go. You can start your assessment now.",
							"incomplete": "Almost There"
						},
						"contentSubtitle": {
							"complete": "Every readiness check has passed. You may now begin your assessment.",
							"incomplete_one": "You still have {{count}} step to complete before starting.",
							"incomplete_other": "You still have {{count}} steps to complete before starting."
						},
						"start": "Continue",
						"starting": "Starting assessment…",
						"goBack": "Resolve Issues"
					}
				},
				"substep": {
					"platformInfo": {
						"ExtensionSetupInstructions": {
							"InstallInstructions": {
								"install": {
									"description": "A short setup will run before you can begin.",
									"download": "Download Extension"
								},
								"update": {
									"title": "Extension Update Required",
									"description": "Please update the Verity Browser Extension to continue with your assessment.",
									"download": "Update Extension"
								}
							},
							"IncorrectPlatformInstructions": {
								"lockdown": {
									"description": "This assessment must be completed using the Verity Browser Extension. It cannot be taken using the Verity Desktop App."
								}
							},
							"ChromeOsUnsupportedInstructions": {
								"title": "Chromebooks Not Supported",
								"description": "Your instructor has limited this assessment to Windows and Mac devices. To continue, please use a Windows or Mac device."
							},
							"UnsupportedBrowserInstructions": {
								"title": "Unsupported Browser",
								"description": "This assessment requires a supported browser. Please switch to {{supportedBrowsers}} to proceed.",
								"browsers": {
									"chromium": "Chrome",
									"firefox": "Firefox",
									"safari": "Safari"
								}
							},
							"ManagedGuestSessionInstructions": {
								"title": "Managed Guest Session Required",
								"description": "You can only access this assessment on a Chromebook with a managed guest session set up by your instructor. Please sign out and log in with the guest session account.",
								"note": "Note: If this is your personal device, please use a Windows or Mac device instead."
							},
							"IncognitoInstructions": {
								"pageDescription": "Complete the step below before starting your proctored assessment.",
								"incomplete": {
									"title": "Requires Incognito Mode Access",
									"description": "In the settings page, find <b>\"Allow in Incognito\"</b> and toggle it on.",
									"openSettings": "Open Settings"
								},
								"complete": {
									"title": "Incognito Access Enabled",
									"description": "Your settings have been updated successfully. Please reload the page to start your readiness check.",
									"reload": "Reload and Continue"
								}
							},
							"ReconnectInstructions": {
								"title": "Refresh Required",
								"description": "Your browser settings have changed. Please refresh the page so Verity can re-check your setup before the assessment begins.",
								"reload": "Reload and Continue"
							}
						},
						"LockdownSetupInstructions": {
							"LaunchInstructions": {
								"unsupported": {
									"title": "Unsupported Device",
									"description": "The Lockdown App is not supported on this device. Use a Windows or macOS device and install the Lockdown App to continue."
								},
								"launch": {
									"description": "Launch the <b>Verity Desktop Lockdown App</b> to start your assessment.",
									"launch": "Launch Desktop Lockdown App"
								},
								"launched": {
									"description": "If you do not have the app installed, please click <b>Download App</b>. If you already have it, click <b>Launch App</b>.",
									"download": "Download App",
									"downloading": "Downloading...",
									"launch": "Launch App"
								},
								"downloaded": {
									"description": "App downloaded successfully. Once installed, it will launch automatically or select <b>Launch App</b>.",
									"downloaded": "Downloaded",
									"installInstructions": {
										"title": "Next steps to complete installation:",
										"1": "Locate the downloaded file in your browser's download bar or your computer's <b>Downloads</b> folder.",
										"2": "Double-click the file to run the installer and follow the prompts.",
										"3": "Once the installation is complete, it will automatically launch or click the <b>Launch App</b> button here."
									}
								},
								"downloadError": {
									"title": "Download Unavailable",
									"description": "We could not retrieve the Lockdown App download link. Try again later or contact your administrator if the issue persists."
								},
								"launchError": {
									"title": "Unable to Launch Lockdown",
									"description": "The Lockdown App couldn't be launched. Ensure it is installed, then try again."
								},
								"launching": "Launching...",
								"tryAgain": "Try Again"
							},
							"LmsAuthorizeInstructions": {
								"description": "This assessment requires the Verity Desktop Lockdown App. Connect your Verity account with Canvas by authenticating."
							},
							"UpdateInstructions": {
								"title": "Lockdown Update Required",
								"description": "An update to the Lockdown App is required before you can continue. Update the app and try again.",
								"update": "Update Lockdown"
							}
						},
						"AuthenticationInstructions": {
							"title": "Verity Access Required",
							"description": "You have not yet accessed Verity for this course. Complete the steps below before starting your assessment.",
							"steps": {
								"1": "Locate the <b>YuJa Verity</b> link within your course and click it.",
								"2": "Return to this page and <b>reload it</b> to continue."
							}
						},
						"BrowserSetupInstructions": {
							"unsupportedDevice": {
								"title": "Unsupported Device",
								"description": "This assessment is proctored in your browser, which requires a desktop, laptop, or Chromebook. Please switch devices to continue."
							},
							"disconnected": {
								"title": "Proctoring Not Responding",
								"description": "Proctoring stopped responding. Please reload the page to continue."
							}
						}
					},
					"live": {
						"error": {
							"title": "Unable to Load Live Session",
							"description": "We were not able to find your proctoring session details. Check your connection and try again. If this keeps happening, contact your instructor before your assessment window closes."
						},
						"notStarted": {
							"title": "Live Session Has Not Started",
							"description": "Please come back when your session starts.",
							"days": "Days",
							"hours": "Hours",
							"minutes": "Minutes",
							"seconds": "Seconds",
							"switchInstructions": "You can switch your registration to another available time slot.",
							"showRegistration": "Change Registration"
						},
						"ended": {
							"title": "Assessment Has Ended",
							"description": "The live assessment is no longer available to register for and join."
						},
						"register": {
							"title": "Registration Required for Live Assessment",
							"description": "Choose a date and time slot to register for your assessment session.",
							"currentSessions": {
								"header": "Select a Session",
								"registrationWindow": "Registration open"
							},
							"futureSessions": {
								"header": "Upcoming Registration",
								"notOpen": "Registration Not Yet Open",
								"registrationWindow": "Registration opens"
							},
							"registered": "Registered Session",
							"remainingSpots": "{{registered}}/{{total}} spots remaining",
							"register": "Register",
							"cancel": "Cancel"
						}
					},
					"displayInfo": {
						"pending": "Checking your display configuration…",
						"multipleDisplays": {
							"title": "Multiple Screens Detected",
							"description": "More than one screen was detected. Please unplug any additional monitors and try again."
						},
						"unknown": {
							"title": "Display Setup Could Not Be Checked",
							"description": "We were not able to detect your connected displays. Disconnect any extra monitors and try again."
						}
					},
					"installedExtensions": {
						"pending": "Checking installed browser extensions…",
						"disallowedExtensions": {
							"title": "Blocked Browser Extensions Detected",
							"description": "The following browser extensions are enabled. Please disable them in your Extension settings to continue.",
							"disableExtension": "Disable {{extensionName}}. Opens in a new tab."
						},
						"unknown": {
							"title": "Extensions Could Not Be Checked",
							"description": "We were not able to read your installed extensions. Make sure the Verify extension is active and try again."
						},
						"guide": {
							"title": "Need Help with Disabling Browser Extensions?",
							"description": "Watch the video to learn how to disable browser extensions for the assessment.",
							"videoTitle": "How to disable browser extensions"
						}
					},
					"tabs": {
						"pending": "Checking open browser tabs…",
						"disallowedTabs": {
							"title": "Additional Tabs Detected",
							"description": "Some tabs are still open. Please close all additional tabs to continue.",
							"closeAll": "Close All Tabs"
						},
						"unknown": {
							"title": "Open Tabs Could Not Be Checked",
							"description": "We were not able to see how many tabs you have open. Close all other tabs and try again."
						}
					},
					"sidePanel": {
						"pending": "Checking browser side panel…",
						"sidePanelOpen": {
							"title": "Side Panel Activities Detected",
							"description": "Your browser’s side panel is currently open. Please close it to continue your assessment."
						},
						"unknown": {
							"title": "Side Panel Could Not Be Checked",
							"description": "We were not able to tell if a side panel is open. Close any side panels and try again."
						}
					},
					"runningApplications": {
						"pending": "Checking open applications…",
						"disallowedApplications": {
							"title": "Unauthorized applications detected",
							"description": "The following applications must be closed before you can continue:",
							"forceQuitAll": "Force Quit All Applications",
							"adminPrivilegesError": "You must provide admin privileges to force-quit applications."
						},
						"unknown": {
							"title": "",
							"description": ""
						}
					},
					"systemSettings": {
						"pending": "Checking system settings…",
						"invalidSettings": {
							"title": "Handoff Detected",
							"description": "This assessment requires <b>Handoff</b> to be turned off before proceeding with the proctoring readiness check. You may disable Handoff in your device settings and try again, or select Disable Handoff below to turn it off automatically. <a>Learn more</a>.",
							"disableHandoff": "Disable Handoff"
						},
						"unknown": {
							"title": "",
							"description": ""
						}
					},
					"display": {
						"title": {
							"unstarted": "Ready to Share",
							"started": "Choose your screen",
							"failed": {
								"noPermission": "Permission Denied",
								"wrongDisplaySurface": "Full Screen Not Selected",
								"unknown": "Screen Sharing Unavailable"
							}
						},
						"description": {
							"unstarted": "Your proctor needs a live view of your screen for this assessment.",
							"started": "Choose Entire Screen in the prompt to continue.",
							"completed": "Your screen is now visible to your proctor.",
							"failed": {
								"noPermission": "Go to System Settings, enable screen sharing, then try again.",
								"wrongDisplaySurface": "You selected a window or browser tab. Select your entire screen to continue.",
								"unknown": "We’re unable to access your screen. Check your screen sharing settings and try again."
							}
						},
						"selectScreen": "Share My Screen",
						"tryAgain": "Try Again",
						"connecting": "Connecting…",
						"waitingForConfirmation": "Waiting for you to confirm…",
						"lockdown": {
							"title": {
								"started": "Preparing screen recording"
							},
							"description": {
								"started": "Your screens are being captured automatically."
							},
							"startScreen": "Start Screen Recording"
						},
						"shared": "Shared",
						"guide": {
							"title": "Need Help with Screen Sharing?",
							"description": "Watch the video to learn how to set up screen sharing for Windows devices.",
							"videoTitle": "How to set up Screen Share"
						}
					},
					"camera": {
						"title": {
							"unstarted": "A Verity window is waiting for your response",
							"completed": {
								"secondary": {
									"mobile": "Mobile Device Selected"
								}
							},
							"failed": {
								"noPermission": {
									"single": "Camera Access Blocked",
									"primary": "Primary Camera Access Blocked",
									"secondary": "Secondary Camera Access Blocked"
								},
								"notFound": {
									"single": "Camera Not Detected",
									"primary": "Primary Camera Not Detected",
									"secondary": "Secondary Camera Not Detected"
								},
								"deviceInUse": {
									"single": "Camera in Use",
									"primary": "Primary Camera in Use",
									"secondary": "Secondary Camera in Use"
								},
								"noMotion": "No Movement Detected",
								"unknown": {
									"single": "Camera Not Available",
									"primary": "Primary Camera Not Available",
									"secondary": "Secondary Camera Not Available"
								}
							}
						},
						"description": {
							"unstarted": "Allow camera access in your browser to continue.",
							"started": "Setting up your camera. This will only take a moment.",
							"completed": {
								"single": "Keep your face clearly visible.",
								"primary": "Primary camera connected. Keep your face clearly visible.",
								"secondary": {
									"physical": "Secondary camera connected.",
									"mobile": "Mobile selected as your camera source. You will connect it in a later step."
								}
							},
							"failed": {
								"noPermission": "Open System Settings and enable camera access for your browser.",
								"notFound": "Check the connection and try again.",
								"deviceInUse": "Another application is using your camera. Close it and try again.",
								"noMotion": "We’re not detecting movement from your camera. Make sure your camera is working and try again.",
								"unknown": "We’re unable to access your camera. Check your camera and try again."
							}
						},
						"videoSource": "Video source",
						"source": {
							"primary": "Primary Camera",
							"secondary": "Secondary Camera"
						},
						"errorUnavailable": "Camera unavailable",
						"selectWebcam": "Select Webcam",
						"waitingForPermission": "Waiting for camera permission…",
						"connecting": "Connecting…",
						"connected": "Connected",
						"guide": {
							"primary": {
								"title": "Need Help with Setting Up Your Camera?",
								"description": "Watch the video to learn how to set up your camera for the assessment.",
								"videoTitle": "How to set up your camera"
							},
							"secondary": {
								"title": "Need Help with Setting Up Your Secondary Camera?",
								"description": "Watch the video to learn how to set up your secondary camera for the assessment.",
								"videoTitle": "How to set up your secondary camera"
							}
						}
					},
					"microphone": {
						"title": {
							"unstarted": "A Verity window is waiting for your response",
							"failed": {
								"noPermission": "Microphone Access Blocked",
								"notFound": "Microphone Not Detected",
								"deviceInUse": "Microphone in Use",
								"unknown": "Microphone Not Available"
							}
						},
						"description": {
							"unstarted": "Allow microphone access in your browser to continue.",
							"started": "Setting up your microphone. This will only take a moment.",
							"completed": "Speak normally. You should see the bars move.",
							"failed": {
								"noPermission": "Open System Settings and enable microphone access for your browser.",
								"notFound": "Check the connection and try again.",
								"deviceInUse": "Another application is using your microphone. Close it and try again.",
								"unknown": "We’re unable to access your microphone. Check your microphone and try again."
							}
						},
						"errorUnavailable": "Microphone unavailable",
						"audioSource": "Audio source",
						"selectMicrophone": "Select Microphone",
						"waitingForPermission": "Waiting for microphone permission…",
						"connecting": "Connecting…",
						"connected": "Connected",
						"guide": {
							"title": "Need Help with Setting Up Your Microphone?",
							"description": "Watch the video to learn how to set up your microphone for the assessment.",
							"videoTitle": "How to set up your microphone"
						}
					},
					"mobile": {
						"title": {
							"unstarted": "Connect your phone",
							"started": "Finish phone setup",
							"failed": "Phone connection unavailable"
						},
						"description": {
							"unstarted": "Scan this code with the Verity app to connect your phone.",
							"unstartedCamera": "Grab your phone and scan this code to add it as a second camera.",
							"started": "Your phone is connected. Follow the steps below to finish setup.",
							"completed": "Your phone is connected and ready for the assessment.",
							"completedRestricted": "Your phone is connected and its required restrictions are on.",
							"preparing": "Setting up a secure connection for your phone…",
							"waitingForRestrictions": "Your phone is connected. Follow the instructions in the Verity app to enable the required restrictions.",
							"waitingForCamera": "Your phone is connected. Follow the instructions in the Verity app to start its camera.",
							"failed": "We couldn’t start the mobile connection. Try again."
						},
						"qrCodeAlt": "QR code to connect your phone to Verity",
						"waiting": {
							"preparing": "Preparing a secure phone connection…",
							"phone": "Waiting for your phone to connect…",
							"finishing": "Finish setup on your phone…",
							"restrictions": "Waiting for phone restrictions…",
							"camera": "Waiting for your phone camera to start…"
						},
						"waitingForPhone": "Waiting for your phone…",
						"connected": "Phone connected",
						"connectedAndRestricted": "Phone and restrictions ready",
						"retry": "Try Again"
					},
					"payment": {
						"description": {
							"unstarted": "Complete your payment to continue.",
							"completed": "Your payment has been received."
						},
						"stripeCheckout": "Stripe Checkout"
					},
					"performance": {
						"pending": "Checking system performance…",
						"insufficientResources": {
							"title": "Other Running Applications Are Impacting System Performance",
							"description": "Verity detected applications that may impact performance. Close any unnecessary applications and run the check again."
						},
						"unknown": {
							"title": "Performance Could Not Be Checked",
							"description": "We were not able to measure your processor and memory usage. Close other applications and try again."
						},
						"guide": {
							"title": "Need Help with Improving System Performance?",
							"description": "Watch the video to learn how to improve your system performance for the assessment.",
							"videoTitle": "How to improve system performance"
						}
					},
					"network": {
						"pending": "Checking your network connection…",
						"insufficientUploadSpeed": {
							"title": "Internet Connection Issues Detected",
							"description": "The upload speed of your internet does not meet the minimum requirement. Try moving closer to your Wi-Fi or disconnecting other devices on your network.",
							"metricSuccess": "Excellent",
							"metricFailed": "Needs Attention",
							"networkSpeedValue": "~{{value}} Mbps",
							"requiredUploadSpeed": "Required Upload Speed",
							"detectedUploadSpeed": "Your Upload Speed"
						},
						"unknown": {
							"title": "Connection Could Not Be Checked",
							"description": "We were not able to test your internet connection. Make sure you are connected and click Retry."
						}
					},
					"vm": {
						"pending": "Checking for virtual machines…",
						"inVm": {
							"title": "Virtual Machine Detected",
							"description": "The Lockdown app is running inside a virtual machine. Please close the virtual machine and restart the check outside of it."
						},
						"unknown": {
							"title": "",
							"description": ""
						}
					},
					"location": {
						"pending": "Verifying location access…",
						"wrongLocation": {
							"title": "Location Outside Geofence",
							"description": "Your location is outside the approved geofence for this assessment. You can continue with the assessment."
						},
						"unknown": {
							"title": "Location Not Detected",
							"description": "Your location could not be detected. Please enable location access in your browser settings, then try again."
						},
						"guide": {
							"title": "Need Help with Enabling Location Access?",
							"description": "Watch the video to learn how to enable location access in your browser and device settings.",
							"videoTitle": "How to share location"
						}
					},
					"ipAddress": {
						"pending": "Verifying IP address...",
						"notInIpAddressRange": {
							"title": "IP Address Not Allowed",
							"description": "Your IP address is outside the approved range for this assessment. You can continue with the assessment."
						},
						"unknown": {
							"title": "IP Address Not Detected",
							"description": "Your IP address could not be verified. Please check your network connection, then try again."
						}
					},
					"roomScan": {
						"title": {
							"unstarted": "Ready to Record",
							"uploading": "Uploading",
							"failed": "Upload Failed"
						},
						"description": {
							"unstarted": "Slowly pan your camera around your workspace before you begin.",
							"started": "Keep going. Capture your whole desk and surroundings.",
							"uploading": "Uploading your recording...",
							"completed": "Your workspace has been recorded.",
							"failed": "Check your connection and try again."
						},
						"selectWebcam": "Select Webcam",
						"selectWebcamPending": "Waiting for camera permission…",
						"start": "Start Room Scan",
						"finish": "Finish Recording",
						"recorded": "Recorded",
						"retake": "Retake",
						"uploading": "Uploading…",
						"retryUpload": "Try Again",
						"guide": {
							"title": "Need Help with Room Scanning?",
							"description": "Watch the video to learn how to complete a room scan for your assessment.",
							"videoTitle": "How to Perform a Room Scan"
						}
					},
					"idPhoto": {
						"title": {
							"pending": "Ready to Scan"
						},
						"description": {
							"connecting": "Getting your camera ready…",
							"pending": "Hold your government-issued ID flat inside the frame.",
							"completed": "Your ID photo is clear and ready."
						},
						"take": "Scan ID Card",
						"captured": "Captured",
						"photoLabel": "Test-taker ID card"
					},
					"facePhoto": {
						"title": {
							"pending": "Ready to Capture"
						},
						"description": {
							"connecting": "Getting your camera ready…",
							"pending": "Look directly into the camera and keep your face centered in the circle",
							"completed": "Perfect, that’s a great shot"
						},
						"take": "Take Photo",
						"captured": "Captured",
						"photoLabel": "Test-taker photo"
					},
					"id": {
						"videoSource": "Video Source",
						"continue": "Continue",
						"attempt": "Attempt {{attempt}} of {{total}}",
						"title": {
							"pending": "Uploading",
							"failed": "Upload Failed"
						},
						"description": {
							"pending": "Saving your photos.",
							"failed": "Check your connection and try again."
						},
						"errorTitle": "ID Verification Failed",
						"errorDescription": "Identity could not be confirmed from the photo provided. Review the requirements below and retake the photo.",
						"errors": {
							"idInFace": "Remove your ID card from the face photo.",
							"phoneDetected": "Remove all electronic devices from the photos.",
							"noIdInId": "Make sure exactly one ID card is fully visible in the ID photo.",
							"missingFace": "Make sure each photo contains exactly one clear face.",
							"manyIdInId": "Show only one ID card in the photo."
						},
						"face": "Face",
						"id": "ID",
						"failed": "Failed",
						"uploading": "Uploading…",
						"retryUpload": "Try Again",
						"retake": "Retake Photos"
					},
					"referenceMaterial": {
						"description": "You may attach reference material permitted for this assessment. This step is optional.",
						"upload": "Click to upload (PDF, JPG or PNG)",
						"remove": "Remove file",
						"invalidFileType": "Choose a PDF, JPG, or PNG file.",
						"fileTooLarge": "The file exceeds the allowed size. Choose a smaller file.",
						"loadFailed": "Your saved reference material could not be loaded. Try again before continuing.",
						"retry": "Try Again",
						"uploadFailed": "The reference material could not be saved. Try again before continuing."
					},
					"signature": {
						"title": {
							"failed": "Upload Failed"
						},
						"description": {
							"unstarted": "Sign below to confirm you will follow the assessment rules.",
							"started": "Uploading…",
							"completed": "Your signature has been saved.",
							"failed": "Check your connection and try again."
						},
						"photoLabel": "Test-taker signature",
						"resign": "Re-sign",
						"draw": {
							"placeholder": "Sign here",
							"switchMode": "Type instead",
							"clear": "Clear"
						},
						"type": {
							"placeholder": "Type your full name",
							"switchMode": "Draw instead"
						},
						"submit": "Submit",
						"uploading": "Uploading…",
						"uploaded": "Uploaded",
						"retryUpload": "Try Again"
					}
				},
				"supportChat": {
					"defaultGreeting": "Hello! I'm here to help you with your Verity proctoring setup. What issue are you experiencing?",
					"defaultResponse": "Looks like you’re having an issue. Click the button below to get help with your issue and resolve it to complete your pre-assessment check."
				},
				"completeInitializationError": {
					"liveSessionEnded": "The session has ended. You can register for a new session that has not started if allowed.",
					"wrongRole": "Please switch to student view to preview the live session as a test-taker or use a separate student account.",
					"reloadExtension": "An Extension Error Occurred. Please reload the Verity Extension, restart your browser, or reinstall the Verity Extension to resolve this issue.",
					"noVerityExtension": "Your assessment could not be started. Please enable Verity Browser Extension in your Extension settings, and try again.",
					"unknownError": "Your assessment could not be accessed. Please check your internet connection and try again."
				}
			}
		}
	},
	"standalone": {
		"assessmentDetails": "Assessment Details: {{title}}",
		"routes": {
			"LoginPage": {
				"title": "YuJa Verity Test Proctoring Platform",
				"description": "To access the assessment, please enter your name and the access code provided in the invitation email.",
				"firstName": "First Name",
				"lastName": "Last Name",
				"accessCode": "Access Code",
				"close": "Close",
				"startAssessment": "Start Assessment",
				"tipMsg": "You can find the access code in the invitation email",
				"exitConfirmMsg": "Are you sure you want to leave the instruction page?",
				"error": {
					"invalidLink": {
						"title": "Invalid link",
						"body": "Please contact the administrator if you think this is an error."
					},
					"authenticationFailed": {
						"title": "Failed to validate your identity!",
						"body": "Please contact the administrator if you think this is an error."
					},
					"expired": {
						"title": "The Link Has Expired!",
						"body": "Please contact the administrator if you think this is an error."
					},
					"alreadyAttempted": {
						"title": "Assessment Completed",
						"body": "You have already submitted this assessment. Please contact your assessment administrator for further assistance."
					},
					"extensionRequired": {
						"title": "Enable Verity",
						"body": "Please download and enable the Verity browser extension."
					},
					"chromeOsNotAllowed": {
						"title": "Platform Not Supported",
						"body1": "Your instructor has limited this assessment to <b>Windows and Mac</b> devices. Chromebook access is not available.",
						"body2": "To continue, please use a Windows or Mac device."
					},
					"lockdownRequired": {
						"title": "Unsupported Browser!",
						"body": "Please open the assessment in the Verity Lockdown App. The link to download the app is available in the email you received."
					},
					"noRegisteredSession": {
						"title": "No Registered Session Found",
						"body": "Please register for a live session. The link to register is available in the email you received."
					},
					"liveSessionNotActive": {
						"title": "Live Session Not Active",
						"body": "The live session is not active yet. Please wait for the session to start."
					},
					"unknown": {
						"title": "Unable to Access Assessment",
						"body": "This might be due to an unstable internet connection. Please check your connection and try again. If the issue persists, please contact YuJa Support."
					}
				}
			},
			"standaloneRegisterTSX": {
				"timerPageTitle": "Registration Completed",
				"timerPageDescription": "You have successfully registered for the assessment.\nPlease check your email for further instructions to begin your exam."
			}
		}
	},
	"types": {},
	"warning": {
		"device": {
			"title": "Chromebooks Not Supported",
			"instructions1": "Your instructor has limited this assessment to Windows and Mac devices. Chromebook access isn’t available for this assessment.",
			"instructions2": "To continue, please use a Windows or Mac device."
		},
		"sessionType": {
			"title": "Log in to a Managed Guest Session",
			"instructions1": "You can only access this assessment on a Chromebook with a managed guest session set up by your institution. Please sign out of your device and log in with the guest session account on the sign-in screen.",
			"instructions2": "If this is your personal device, please take this assessment on a Windows or Mac device."
		},
		"updateLockdown": {
			"description": "Click the button below to download the latest version of the Verity Lockdown App. Once the installation is complete, launch Verity Lockdown to access your assessment.",
			"updateTitle": "Verity Lockdown Update Required",
			"downloadTitle": "Verity Lockdown Required",
			"download": "Download Verity Lockdown"
		},
		"updateExtension": {
			"title": "Verity Extension Update Required",
			"canvas": {
				"description": "To start your assessment, please update the Verity Browser Extension. Click the YuJa Verity link in the sidebar or use the button below, then follow the instructions to complete the update.",
				"descriptionNoLink": "To start your assessment, please update the Verity Browser Extension. Click the YuJa Verity link in the sidebar then follow the instructions to complete the update.",
				"button": "Go to YuJa Verity"
			},
			"desire2learn": {
				"description": "To start your assessment, please update the Verity Browser Extension. Click the button below to return to your course content page, then select the YuJa Verity link and follow the on-screen instructions to complete the update.",
				"descriptionNoLink": "To start your assessment, please update the Verity Browser Extension. Go to your course content page, select the YuJa Verity link, and follow the instructions to complete the update.",
				"button": "Back to Course Content"
			},
			"moodle": {
				"description": "To start your assessment, please update the Verity Browser Extension. Click the button below to return to your course main page, then select the YuJa Verity link and follow the on-screen instructions to complete the update.",
				"descriptionNoLink": "To start your assessment, please update the Verity Browser Extension. Go to your course main page, select the YuJa Verity link, and follow the instructions to complete the update.",
				"button": "Back to Main Page"
			},
			"BlackboardLearnOriginal": {
				"description": "To start your assessment, please update the Verity Browser Extension. Go to your course main page, select the YuJa Verity link, and follow the instructions to complete the update."
			},
			"BlackboardLearn": {
				"description": "To start your assessment, please update the Verity Browser Extension. Go to your course main page, select the YuJa Verity link, and follow the instructions to complete the update."
			},
			"fallback": ""
		},
		"auth": {
			"title": "YuJa Verity Required for This Assessment",
			"quickLinkDesc": "Your instructor has enabled proctoring for this assessment. Complete a quick setup to get started.",
			"desc": "This is a Verity-proctored assessment. Please follow the instructions below to proceed.",
			"quickLinkButton": "Start Setup",
			"browserSetupManualDesc": "Open YuJa Verity from your course, then select this assessment to start setup.",
			"lockdownDesc": "This is a Verity-proctored lockdown assessment. Please follow the instructions below to proceed.",
			"steps": {
				"canvas": {
					"stepOne": {
						"title": "Access YuJa Verity",
						"desc": "From the course navigation menu, click on the <b>YuJa Verity</b> tab."
					},
					"lockdown": {
						"title": "Start Your Assessment",
						"desc": "Within <b>YuJa Verity</b>, select your assessment to begin, or return to the <b>Quiz</b> tab in the side tab and choose your assessment to begin."
					}
				},
				"d2l": {
					"stepOne": {
						"title": "Access YuJa Verity",
						"desc": "From the top navigation menu, click Content, then select <b>YuJa Verity</b>."
					},
					"stepTwo": {
						"title": "Install the YuJa Verity Extension",
						"desc": "On the home page Click <b>Install Extension</b>, which will open the Chrome Web Store in a new tab. Select Add to Chrome, then click Add extension when prompted. Once the extension is installed, close the tab and return to Brightspace."
					},
					"stepThree": {
						"title": "Start Your Quiz",
						"desc": "Navigate to the <b>Quizzes or Content</b> tab within your course and select your quiz to begin."
					},
					"lockdown": {
						"title": "Start Your Assessment",
						"desc": "Within <b>YuJa Verity</b>, select your assessment to begin, or navigate to the <b>Quizzes or Content</b> tab within your course and select your assessment to begin."
					}
				},
				"moodle": {
					"stepOne": {
						"title": "Access YuJa Verity",
						"desc": "Navigate to the Course content tab and select <b>YuJa Verity</b>."
					},
					"stepTwo": {
						"title": "Install the YuJa Verity Extension",
						"desc": "Click <b>Install Extension</b>, which will open the Chrome Web Store in a new tab. Select Add to Chrome, then click Add extension when prompted. Once the extension is installed, close the tab and return to Moodle."
					},
					"stepThree": {
						"title": "Start Your Quiz",
						"desc": "Navigate to the <b>Course</b> tab within your course and select your assessment to begin."
					},
					"lockdown": {
						"title": "Start Your Assessment",
						"desc": "Within <b>YuJa Verity</b>, select your assessment to begin, or navigate to the <b>Content</b> tab within your course and select your assessment to begin."
					}
				},
				"blackboardOriginal": {
					"stepOne": {
						"title": "Access YuJa Verity",
						"desc": "From the side navigation menu, click Content, then select <b>YuJa Verity</b>."
					},
					"stepTwo": {
						"title": "Install the YuJa Verity Extension",
						"desc": "Click <b>Install Extension</b>, which will open the Chrome Web Store in a new tab. Select Add to Chrome, then click Add extension when prompted. Once the extension is installed, close the tab and return to Blackboard."
					},
					"stepThree": {
						"title": "Start Your Quiz",
						"desc": "Navigate to the <b>Content</b> tab within your course and select your assessment to begin."
					},
					"lockdown": {
						"title": "Start Your Assessment",
						"desc": "Within <b>YuJa Verity</b>, select your assessment to begin, or navigate to the <b>Content</b> tab within your course and select your assessment to begin."
					}
				}
			}
		},
		"wrongBrowser": {
			"title": "You’re Using an Unsupported Browser",
			"subTitle": "Your current browser is not supported by Verity. Please follow the steps below to get started.",
			"stepOneTitle": "Open a Supported Browser",
			"stepOneDesc": "Download and open one of the following browsers: Chrome (Recommended), Brave, Edge, Opera, Firefox, or Safari.",
			"stepTwoTitle": "Log in to {{lms}}",
			"stepTwoDesc": "Log in to {{lms}} using a supported browser and open your assessment again.",
			"chromeAriaLabel": "Download Google Chrome (opens in a new tab).",
			"operaAriaLabel": "Download Opera Browser (opens in a new tab).",
			"edgeAriaLabel": "Download Microsoft Edge (opens in a new tab).",
			"braveAriaLabel": "Download Brave Browser (opens in a new tab).",
			"firefoxAriaLabel": "Download Firefox (opens in a new tab)."
		}
	},
	"400Html": {},
	"401Html": {},
	"403Html": {},
	"404Html": {},
	"500Html": {},
	"503Html": {},
	"portalHtml": {},
	"settingsHtml": {},
	"institutionDisabledHtml": {
		"title": "Institution Disabled",
		"description": "This institution has been disabled and is no longer accessible. Please contact your institution administrator or YuJa Support for more information.",
		"closeTab": "Close Tab"
	},
	"helpers": {
		"assessmentNameTS": {
			"notFound": "Unknown Assessment (Assessment's Name Not Found)"
		}
	},
	"subAccount": {
		"sync": "Sync {{type}}",
		"syncMessage": "We are syncing all {{plural}}. Please return in 1 hour to view the updated {{singular}} list.",
		"syncFailMsg": "Something went wrong while syncing. Please contact YuJa Support.",
		"manage": "Manage {{type}}",
		"searchLabel": "Search by {{type}} Name or ID",
		"notSeeingAll": "Not seeing all {{type}}?",
		"listTitle": "{{type}} List",
		"addAriaLabel": "Add {{name}}",
		"removeAriaLabel": "Remove {{name}}",
		"noneFound": "No {{type}} Found",
		"noneAddedMessage": "Added {{type}} Will Appear Here",
		"singular": {
			"canvas": "Canvas Account",
			"desire2learn": "D2L Brightspace Organization Unit",
			"moodle": "Moodle Category",
			"BlackboardLearn": "Blackboard Node",
			"default": "Sub-Account"
		},
		"plural": {
			"canvas": "Canvas Accounts",
			"desire2learn": "D2L Brightspace Organization Units",
			"moodle": "Moodle Categories",
			"BlackboardLearn": "Blackboard Nodes",
			"default": "Sub-Accounts"
		}
	},
	"home": {
		"navbar": {
			"defaultTitle": "Home",
			"actions": {
				"menu": {
					"items": {
						"institutions": "Institutions",
						"install": "Install",
						"accountManagers": "Account Managers",
						"applications": "Applications",
						"liveProctoring": "Live Proctoring",
						"feedback": "Feedback",
						"events": "Events",
						"signOut": "Sign Out"
					}
				}
			}
		},
		"pages": {
			"institutions": {
				"navbar": {
					"title": "Institution Management"
				},
				"search": {
					"placeholder": "Search by institution name, domain, or LMS type"
				},
				"table": {
					"columns": {
						"instituteName": "Institution Name",
						"productType": "Product Type",
						"institutePlatform": "LMS Type",
						"domain": "Domain",
						"identifierKey": "Identifier Key",
						"createdDate": "Created",
						"accessLevel": "Access Level",
						"actions": "Actions"
					},
					"noResults": {
						"message": "No Institutions Found",
						"description": "Try adjusting your search criteria"
					},
					"row": {
						"invalid": "Unspecified",
						"lmsType": {
							"canvas": "Canvas",
							"desire2learn": "D2L Brightspace",
							"moodle": "Moodle",
							"BlackboardLearn": "Blackboard Learn"
						},
						"ariaLabel": "Open the portal for {{institutionName}}.",
						"accessLevel": {
							"read": "View Only",
							"write": "Institution Admin",
							"admin": "YuJa Admin"
						},
						"productType": {
							"verity": "Verity",
							"candidate": "Candidate AI"
						},
						"editInstitutionSettings": "Edit Institution Settings"
					}
				}
			},
			"install": {
				"navbar": {
					"title": "Institution Installation"
				},
				"edit": {
					"institutionSettings": "Institution Settings",
					"createSuccessToast": "Successfully installed institution {{name}}",
					"createFailToast": "Failed to install institution {{name}}",
					"discardSuccessToast": "Successfully discarded changes",
					"discardFailToast": "Failed to discard changes",
					"discardConfirm": "Are you sure you want to discard all changes?",
					"discard": {
						"button": "Discard Changes",
						"tooltip": "There are no changes to discard."
					},
					"save": {
						"createButton": "Install Institution",
						"tooltip": "Fields marked with an asterisk (*) are required."
					}
				}
			},
			"csmManagement": {
				"navbar": {
					"title": "Account Management"
				},
				"deleteModal": {
					"title": "Delete User",
					"description": "Are you sure you want to delete {{name}}?",
					"delete": "Delete",
					"cancel": "Cancel",
					"deleteAccount": "Also delete the associated account"
				},
				"proctorAvailModal": {
					"avail": "Available",
					"unavail": "Unavailable",
					"loadFail": "Failed to load proctor availability. Please refresh the page to try again.",
					"proctAvail": "Proctoring Availability ({{timezone}})",
					"cancel": "Cancel",
					"procAvailUpdate": "Proctoring availability updated",
					"updateFail": "Failed to update proctoring availability",
					"save": "Save"
				},
				"manageInstituteModal": {
					"title": "Manage Institution Access for {{name}}",
					"close": "Cancel",
					"save": "Save",
					"searchPlaceholder": "Search by institution name, LMS type, or domain",
					"institutionName": "Institution Name",
					"lmsType": "LMS Type",
					"productType": "Product Type",
					"domain": "Domain",
					"accessLevel": "Access Level",
					"proctor": "Proctor",
					"allInstitutions": "All Institutions",
					"institutionsManaged": "Institutions Managed",
					"noResults": "No Institutions Found",
					"read": "View Only",
					"write": "Institution Admin",
					"admin": "YuJa Admin",
					"proctorAriaLabel": "Is Proctor for {{institutionName}}",
					"saveError": "Failed to save account manager access. Please refresh the page or try again.",
					"saveSuccess": "Successfully Updated Account Manager Institutions!",
					"addUserPermissionError": "You do not have permission to manage access for this user."
				},
				"proctorConfirmModal": {
					"titleAssign": "Confirm Proctor Assignment",
					"titleRemove": "Remove Proctor Assignment",
					"descAssign": "Are you sure you want to assign {{name}} as a proctor?",
					"descRemove": "Are you sure you want to remove {{name}} as a proctor?",
					"assignProctorSuccessToast": "{{name}} has been assigned as a proctor",
					"assignProctorFailToast": "Failed to assign {{name}} as a proctor",
					"removeProctorSuccessToast": "{{name}} has been removed as a proctor",
					"removeProctorFailToast": "Failed to remove {{name}} as a proctor"
				},
				"indexTSX": {
					"edit": "Manage Institution Access",
					"delete": "Delete",
					"viewAvail": "View Availability",
					"assignAsProctor": "Assign as Proctor",
					"removeAsProctor": "Remove as Proctor",
					"loadFail": "Failed to load users. Please refresh the page to try again.",
					"searchLabel": "Search Users",
					"noResult": "No results were found",
					"role": "Role",
					"name": "Name",
					"email": "Email",
					"numInstitutions": "Institutions Managed",
					"actions": "Actions",
					"userDeleted": "User deleted",
					"userDeleteFail": "Failed to delete user",
					"accountManager": "Account Manager",
					"yujaAdmin": "YuJa Admin",
					"proctor": "Proctor",
					"notAssigned": "Not Assigned Yet"
				}
			},
			"applications": {
				"navbar": {
					"title": "Applications"
				},
				"search": {
					"placeholder": "Search Application",
					"create": "Create Application"
				},
				"toast": {
					"fetchError": "Failed to fetch applications"
				},
				"table": {
					"columns": {
						"id": "Number / ID",
						"name": "Application Name",
						"processName": "Process Name",
						"iconSvg": "Application Icon",
						"type": "Category Type",
						"actions": "Actions"
					},
					"noResults": {
						"title": "No Matching Results Found",
						"description": "Try adjusting your search to find what you're looking for."
					},
					"noApplications": {
						"title": "No Applications Created",
						"description": "Create a new application to manage process monitoring during proctored exams."
					},
					"row": {
						"edit": "Edit",
						"delete": "Delete"
					}
				},
				"edit": {
					"createTitle": "Create Application",
					"editTitle": "Edit Application",
					"createDescription": "Add a new application by providing the details below.",
					"editDescription": "Update the application details and settings below.",
					"cancel": "Cancel",
					"apply": "Apply Changes",
					"create": "Create Application",
					"applySuccessToast": "Successfully applied changes.",
					"applyFailToast": "Failed to apply changes.",
					"createSuccessToast": "Successfully created application.",
					"createFailToast": "Failed to create application.",
					"name": "Application Name",
					"namePlaceholder": "e.g., Google Chrome",
					"nameDescription": "Enter the display name of the application as you want it to appear to users.",
					"alreadyExists": "An application with this name already exists",
					"processName": "Process Name",
					"processNameDescription": "Enter the exact process name(s) used by the operating system (e.g., chrome). Multiple entries can be added if needed.",
					"processNamesList": {
						"placeholder": "e.g., chrome",
						"add": "Add",
						"edit": "Edit",
						"remove": "Remove",
						"discard": "Discard",
						"save": "Save"
					},
					"addProcessName": "Add Process Name",
					"iconSvg": "Application Icon",
					"iconSvgDescription": "Upload an SVG file to visually represent this application in the console.",
					"iconSvgUploadArea": "<a>Choose Media</a> to Upload",
					"preview": "Preview",
					"replaceIcon": "Replace Icon",
					"fileUploadSuccess": "The icon file was successfully uploaded.",
					"fileUploadError": "There was an error while uploading the icon file. Please ensure that the file type is .svg.",
					"type": "Category Type",
					"typePlaceholder": "Select a category",
					"typeDescription": "Select the category that best represents this application.",
					"browser": "Browser",
					"communication": "Communication",
					"screenSharing": "Screen Sharing",
					"other": "Other",
					"updateSuccess": "Successfully applied changes.",
					"updateError": "Failed to apply changes.",
					"createSuccess": "Successfully created application.",
					"createError": "Failed to create application."
				},
				"deleteModal": {
					"title": "Delete Application",
					"body": "Are you sure you want to delete {{name}}?",
					"cancel": "Cancel",
					"delete": "Delete",
					"deleteSuccess": "Successfully deleted application.",
					"deleteError": "Failed to delete application"
				}
			},
			"feedback": {
				"navbar": {
					"title": "Feedback Management"
				},
				"search": {
					"placeholder": "Search Feedback",
					"satisfaction": "Satisfaction",
					"category": "Category",
					"status": "Status",
					"satisfactionFilter": {
						"all": "All",
						"poor": "Poor",
						"satisfied": "Satisfied",
						"good": "Good",
						"excellent": "Excellent"
					},
					"categoryFilter": {
						"all": "All",
						"suggestion": "Suggestion",
						"bug": "Bug",
						"comment": "Comment",
						"other": "Other"
					},
					"statusFilter": {
						"all": "All",
						"notStarted": "Not Started",
						"inProgress": "In Progress",
						"completed": "Completed"
					},
					"searchButton": "Search"
				},
				"table": {
					"columns": {
						"email": "Email",
						"name": "Name",
						"summary": "Feedback",
						"satisfaction": "Satisfaction",
						"category": "Category",
						"date": "Date",
						"institutionName": "Institution Name",
						"status": "Status",
						"actions": "Actions"
					},
					"noResults": {
						"message": "No Matching Results",
						"description": "Feedback will appear here as users submit feedback."
					},
					"row": {
						"invalid": "Unspecified",
						"removeButton": "Remove",
						"satisfaction": {
							"poor": "Poor",
							"satisfied": "Satisfied",
							"good": "Good",
							"excellent": "Excellent"
						},
						"category": {
							"suggestion": "Suggestion",
							"bug": "Bug",
							"comment": "Comment",
							"other": "Other"
						},
						"status": {
							"notStarted": "Not Started",
							"inProgress": "In Progress",
							"completed": "Completed"
						}
					}
				},
				"toast": {
					"feedbackFetchError": "Failed to fetch feedback",
					"statusUpdateSuccess": "Successfully updated feedback status",
					"statusUpdateFail": "Unable to updated feedback status",
					"feedbackRemoveSuccess": "Successfully deleted feedback",
					"feedbackRemoveFail": "Unable to delete feedback"
				},
				"removeModal": {
					"title": "Remove Feedback",
					"description": "Are you sure you want to remove feedback with title:",
					"feedback": "\"{{feedback}}\"?",
					"cancelButton": "Cancel",
					"removeButton": "Remove"
				}
			},
			"events": {
				"navbar": {
					"title": "Event Banner"
				},
				"header": {
					"title": "Event Banner",
					"description": "Create event banners to inform users about upcoming events and webinars.",
					"createBanner": "Create Banner"
				},
				"search": {
					"placeholder": "Search by event name"
				},
				"view": {
					"filter": {
						"startDate": "Start Date",
						"endDate": "End Date",
						"roles": {
							"title": "User Role",
							"admin": "Admin",
							"instructor": "Instructor",
							"student": "Student",
							"all_roles": "All Roles"
						}
					},
					"card": {
						"bannerScheduled": "Banner Scheduled:",
						"to": "to",
						"upcoming": "Upcoming",
						"past": "Past",
						"actions": {
							"tooltip": "More Actions",
							"edit": "Edit",
							"delete": "Delete"
						}
					},
					"deleteModal": {
						"title": "Delete Event Banner",
						"cancelButton": "Cancel",
						"deleteButton": "Delete",
						"description": "Are you sure you want to delete the event banner \"<b>{{title}}</b>\"?"
					},
					"noResults": {
						"emptyTitle": "Create Your First Banner Event",
						"emptyDescription": "There is no event banner yet. Create a banner for your event to view it here.",
						"noMatchesTitle": "No Matching Results",
						"noMatchesDescription": "Try adjusting the filter or broadening your search criteria to find what you are looking for.",
						"createBanner": "Create Banner"
					},
					"toast": {
						"deleteEventSuccess": "Successfully deleted event",
						"deleteEventFail": "Error deleting event. Please try again."
					}
				},
				"edit": {
					"description": "Create a banner to notify clients about upcoming webinars or events.",
					"locationHeader": "Banner Display Location",
					"locationDescription": "Show the banner to all institutions or specific institutions.",
					"roleHeader": "Role",
					"roleDescription": "Select which user roles can view the banner.",
					"titleHeader": "Banner Description",
					"titleDescription": "Enter a description for the webinar, which will be displayed on the banner.",
					"titlePlaceholder": "E.g., Learning Inclusive Design on Nov 10, 10:00 AM ET",
					"linkHeader": "Registration Link",
					"linkDescription": "Provide the link to register for the event or webinar.",
					"linkPlaceholder": "Enter registration link",
					"buttonHeader": "Banner's Registration Button",
					"buttonDescription": "Enter text for the banner's button, which will open the registration link.",
					"buttonPlaceholder": "E.g., Register Now",
					"dateHeader": "Schedule Banner",
					"dateDescription": "Set the start and end date for when the banner will appear.",
					"institutions": {
						"allInstitutions": "All Institutions",
						"selectInstitutions": "Select Institutions"
					},
					"institutionsModal": {
						"selectedInstitutions": "({{selected}} selected)",
						"selectAtLeastOne": "Please select at least one institution",
						"noInstitutions": "You do not have permission to publish banners for any institution.",
						"title": "Select Institutions",
						"selectedTitle": "Selected Institutions",
						"cancel": "Cancel",
						"noResults": {
							"message": "No institutions found",
							"description": "No institutions found"
						},
						"columns": {
							"institutionName": "Institution Name",
							"institutionPlatform": "LMS Type"
						},
						"rows": {
							"invalid": "Unspecified",
							"lmsType": {
								"canvas": "Canvas",
								"desire2learn": "D2L Brightspace",
								"moodle": "Moodle",
								"BlackboardLearn": "Blackboard Learn"
							}
						}
					},
					"roles": {
						"admin": "Admin",
						"instructor": "Instructor",
						"student": "Student",
						"all_roles": "All Roles"
					},
					"link": {
						"validDomain": "Valid domain",
						"required": "This field is required",
						"domainError": "Invalid domain"
					},
					"toast": {
						"instituteFetchError": "Failed to fetch available institutions",
						"createEventSuccess": "Successfully created event",
						"createEventFail": "Failed to create event",
						"updateEventSuccess": "Successfully modified event",
						"updateEventFail": "Failed to update event"
					}
				},
				"confirmation": {
					"title": "Preview and Confirmation",
					"confirmationHeader": "Banner Publish Confirmation",
					"confirmationDescription": "You acknowledge that you have received approval to create this banner and that you have reviewed the selected institutions where the banner will be published. Type “I understand” to continue.",
					"confirmationPlaceholder": "Enter “I understand”"
				},
				"footer": {
					"back": "Back",
					"next": "Next",
					"confirmChanges": "Confirm Changes",
					"cancel": "Cancel",
					"create": "Create"
				}
			},
			"pendingInstitutionDeletion": {
				"navbar": {
					"title": "Disabled Institutions"
				},
				"search": {
					"placeholder": "Search by institution name or initiated by"
				},
				"table": {
					"columns": {
						"instituteName": "Institution Name",
						"lmsType": "LMS Type",
						"domain": "Domain",
						"initiatedBy": "Initiated By",
						"status": "Status",
						"deletionDate": "Deletion Date",
						"createdAt": "Created",
						"updatedAt": "Last Updated",
						"actions": "Actions"
					},
					"noResults": {
						"message": "No Pending Deletions Found",
						"description": "Try adjusting your search criteria"
					},
					"row": {
						"ariaLabel": "Pending deletion row for {{institutionName}}.",
						"restore": "Restore",
						"resendFinanceEmail": "Resend Approval Email",
						"alreadyDeletedTooltip": "This institution has already been deleted and cannot be reverted.",
						"status": {
							"pendingFinanceApproval": "Pending Finance Approval",
							"pendingArchitectApproval": "Pending Architect Approval",
							"pendingDeletion": "Scheduled for Deletion",
							"deleted": "Deleted"
						}
					}
				},
				"toast": {
					"fetchError": "Failed to fetch pending institution deletions",
					"restoreSuccess": "Successfully restored institution",
					"restoreError": "Unable to restore institution",
					"resendFinanceEmailSuccess": "Finance approval email resent",
					"resendFinanceEmailError": "Unable to resend finance approval email"
				},
				"restoreModal": {
					"title": "Restore Disabled Institution",
					"description": "Restoring this institution will allow it to be accessed and able to process data again.",
					"cancelButton": "Cancel",
					"restoreButton": "Restore"
				},
				"resendFinanceEmailModal": {
					"title": "Resend Approval Email",
					"description": "Are you sure you want to resend the deletion approval email?",
					"cancelButton": "Cancel",
					"confirmButton": "Resend Email"
				}
			}
		},
		"toast": {
			"portalFetchError": "Failed to fetch available portals",
			"portalLaunchError": "Failed to launch the portal"
		}
	},
	"login": {
		"pages": {
			"root": {
				"title": "Welcome to YuJa Verity",
				"candidateTitle": "Welcome to YuJa Candidate AI",
				"description": "Please sign in to your account.",
				"fields": {
					"strategies": {
						"label": "Sign-In Options"
					}
				},
				"strategies": {
					"credentials": {
						"title": "YuJa Credentials",
						"candidateTitle": "Candidate AI Credentials",
						"fields": {
							"email": {
								"label": "Email",
								"placeholder": "Enter email"
							},
							"password": {
								"label": "Password",
								"placeholder": "Enter password",
								"showPassword": "Show password",
								"hidePassword": "Hide password"
							}
						},
						"actions": {
							"remember": "Remember me",
							"submit": "Sign In",
							"forgotPassword": "Forgot Password?",
							"submitting": "Signing In..."
						}
					},
					"sso": {
						"title": "SAML Single Sign-On",
						"candidateTitle": "SAML Single Sign-On",
						"actions": {
							"submit": "Sign In With SSO",
							"submitting": "Signing In..."
						}
					}
				}
			},
			"forgot": {
				"title": "Forgot Password",
				"description": "Enter your email, and we will send you a link to reset your password.",
				"fields": {
					"email": {
						"label": "Email",
						"placeholder": "Enter email"
					}
				},
				"actions": {
					"submit": "Send Reset Link",
					"submitting": "Sending Reset Link...",
					"back": "Go Back"
				},
				"status": {
					"missingLink": "Did not receive password reset link?",
					"debounceText": "Request a new link in",
					"resendLink": "Request a new link"
				}
			},
			"reset": {
				"title": "Welcome to YuJa Verity",
				"candidateTitle": "Welcome to YuJa Candidate AI",
				"description": "Please sign in to your account.",
				"fields": {
					"password": {
						"label": "New Password",
						"placeholder": "Enter new password"
					},
					"confirmPassword": {
						"label": "Confirm New Password",
						"placeholder": "Enter new password to confirm"
					}
				},
				"validation": {
					"length": "At least 14 characters in length",
					"lowercase": "At least one lowercase character",
					"uppercase": "At least one uppercase character",
					"number": "At least one number",
					"special": "At least one special character",
					"match": "Passwords must match"
				},
				"actions": {
					"submit": "Reset Password"
				},
				"error": {
					"title": "Password Reset Failed",
					"descriptionTemplate": "{{cause}}. Please make sure this is the most recent password reset link.",
					"generic": "Invalid password reset link",
					"actions": {
						"back": "Back to Log In Page"
					}
				}
			},
			"mfa": {
				"setup": {
					"title": "Set Up Two-Factor Authentication",
					"scan": {
						"description": "Step 1 - Use an authentication app (such as Google Authenticator or Microsoft Authenticator) to scan the QR code below.",
						"fallback": "Having trouble scanning the QR code? Try the code below instead.",
						"qrCodeAlt": "QR code for setting up two-factor authentication",
						"button": {
							"next": "Next"
						},
						"toast": {
							"copied": "Copied to clipboard"
						}
					},
					"verify": {
						"description": "Step 2 - Enter the 6-digit verification code generated by your authenticator app.",
						"button": {
							"back": "Back"
						}
					}
				},
				"verify": {
					"titleVerity": "Welcome to YuJa Verity",
					"titleCandidate": "Welcome to Candidate AI",
					"description": "Enter the 6-digit verification code generated by your authenticator app.",
					"emailDescription": "Enter the 6-digit verification code sent to your email."
				},
				"code": {
					"prompt": "Enter Verification Code",
					"error": "Invalid Verification Code",
					"resend": "Resend Code",
					"resendCountdown": "Resend Code ({{seconds}}s)",
					"button": {
						"submit": "Verify",
						"loading": "Verifying..."
					}
				},
				"toast": {
					"resendSuccess": "A new verification code has been sent to your email.",
					"resendFailed": "Unable to send a new verification code. Please try again.",
					"resendLimitReached": "Too many verification codes requested. Please try again later.",
					"tooManyAttempts": "Too many incorrect attempts. Please sign in again.",
					"challengeExpired": "Your sign-in session expired. Please sign in again."
				}
			}
		},
		"toast": {
			"ssoFetchFailed": "Failed to fetch SSO registration",
			"ssoRegistrationMissing": "Unable to find SSO registration",
			"loginFailed": "Login failed",
			"passwordResetFailed": "Password reset failed",
			"forgotEmailFailed": "Failed to send reset password email",
			"passwordResetSuccess": "Password reset successfully"
		},
		"validation": {
			"email": "Invalid Email",
			"password": "Invalid Password"
		}
	},
	"payment": {
		"title": "Complete Your Payment",
		"description": "Based on your institution’s licensing agreement, a fee is required to take this assessment. Click the button below to view the total fee and securely make your payment.",
		"button": "Pay Now",
		"complete": {
			"title": "Payment Successful",
			"description": "You are all set! Click <b>Next</b> to proceed with the Proctoring Readiness Check for your assessment."
		},
		"completeInline": {
			"title": "Payment Successful",
			"description": "Your payment has been recorded. Proceed with the proctoring readiness check for your assessment."
		},
		"launchLockdown": {
			"description": "Go back to the Verity Lockdown browser to proceed with the Readiness Check for your assessment."
		}
	},
	"instructionEditorTSX": {
		"fontSize": {
			"small": "Small",
			"normal": "Normal",
			"large": "Large",
			"huge": "Huge"
		},
		"heading": {
			"h1": "Heading 1",
			"h2": "Heading 2",
			"h3": "Heading 3",
			"h4": "Heading 4",
			"h5": "Heading 5",
			"h6": "Heading 6",
			"normal": "Normal"
		},
		"font": {
			"sansSerif": "Sans serif",
			"serif": "Serif",
			"monospace": "Monospace"
		},
		"align": {
			"left": "Left",
			"center": "Center",
			"right": "Right",
			"justify": "Justify"
		},
		"ariaLabels": {
			"toolbar": "Text editor",
			"group": {
				"textFormattingOptions": "Text formatting options",
				"blockFormattingOptions": "Block formatting options",
				"insertOptions": "Insert options",
				"headingButtons": "Heading buttons",
				"listOptions": "List options",
				"superscriptSubscript": "Superscript and subscript",
				"indentation": "Indentation",
				"sizeAndHeadingLevel": "Text size and heading level",
				"textAndBackgroundColor": "Text and background color",
				"textFormatting": "Text formatting"
			},
			"button": {
				"bold": "Bold",
				"italic": "Italic",
				"underline": "Underline",
				"strikethrough": "Strikethrough",
				"blockquote": "Blockquote",
				"codeBlock": "Code block",
				"insertLink": "Insert link",
				"insertImage": "Insert image",
				"insertVideo": "Insert video",
				"insertFile": "Insert file",
				"heading1": "Heading 1",
				"heading2": "Heading 2",
				"orderedList": "Ordered list",
				"bulletList": "Bullet list",
				"checklist": "Checklist",
				"subscript": "Subscript",
				"superscript": "Superscript",
				"decreaseIndent": "Decrease indent",
				"increaseIndent": "Increase indent",
				"rtlText": "Right-to-left text",
				"removeFormatting": "Remove formatting"
			},
			"select": {
				"fontSize": "Font size",
				"headingLevel": "Heading level",
				"textColor": "Text color",
				"backgroundColor": "Background color",
				"font": "Font",
				"textAlignment": "Text alignment"
			}
		}
	},
	"candidate": {
		"productName": "YuJa Candidate AI",
		"sidebar": {
			"adminInterviews": "All Interviews",
			"instructorInterviews": "My Interviews",
			"results": "Results",
			"reports": "Reports",
			"configuration": "Configuration"
		},
		"instructorHomePage": {
			"welcomeText": {
				"title": "Welcome to the YuJa Candidate AI",
				"description": "Schedule live interviews to assess candidates and provide through evaluations afterward"
			},
			"infoCards": {
				"monitoring": "Real-Time Monitoring",
				"support": "Multi-Platform Support",
				"rating": "Post-Interview Ratings"
			},
			"actionCard": {
				"title": "Ready to get started?",
				"description": "Schedule an interview and see all features in action",
				"buttonText": "Schedule Interview"
			}
		},
		"instructorDashboard": {
			"status": {
				"all": "All Interviews",
				"total": "Total Interviews",
				"upcoming": "Upcoming Interviews",
				"completed": "Completed Interviews",
				"active": "Active Interviews"
			},
			"instructorTitle": "My Interviews",
			"adminTitle": "All Interviews",
			"description": "View and manage all your secure interviews.",
			"searchPlaceholder": "Search by interview name",
			"interviewCard": {
				"panel": "Panel: {{count}} interviewer",
				"panel_plural": "Panel: {{count}} interviewers",
				"platform": "Conference: {{platform}}",
				"tooltip": {
					"cancel": "Cancel Interview",
					"complete": "Mark as Complete",
					"disabled": "You are not on the panel for this interview"
				},
				"toast": {
					"completeSuccess": "Interview completed",
					"completeFail": "Failed to mark interview as complete"
				},
				"buttons": {
					"edit": "Edit Details",
					"join": "Join Interview",
					"results": "View Results"
				},
				"time": {
					"active": "Started {{time}} ago",
					"completed": "Ended {{time}} ago",
					"upcoming": "Starts in {{time}}"
				}
			},
			"deleteModal": {
				"title": "Cancel Interview",
				"description": "Do you want to cancel the interview with <strong>{{candidateName}}</strong> scheduled for <strong>{{time}}</strong>. The candidate and associated interviewers will be notified via email about the cancellation.",
				"button": {
					"cancel": "Keep",
					"delete": "Yes, Cancel"
				}
			}
		},
		"scheduleInterview": {
			"buttonText": "Schedule Interview",
			"steps": {
				"details": "Interview Details",
				"platform": "Video Conference"
			},
			"navigation": {
				"next": "Next",
				"cancel": "Cancel",
				"back": "Back",
				"schedule": "Schedule",
				"submit": "Submit"
			},
			"toast": {
				"saveFail": "Interview Failed To Save",
				"saveSuccess": "The interview for the {{positionName}} position has been successfully scheduled."
			},
			"sidePanel": {
				"video": {
					"title": "Watch: Scheduling Walkthrough",
					"description": "A quick guide to scheduling an interview with a candidate.",
					"duration": "{{time}} Minutes"
				},
				"tip": {
					"title": "Pro Tip",
					"description": "Make sure the Position Name exactly matches your career site so candidates recognize the invite instantly."
				}
			},
			"detailsStep": {
				"title": "Interview Details",
				"description": "Fill in the details below. The candidate will receive an email with instructions to download the proctoring app before joining the video conference.",
				"fields": {
					"interviewTitle": {
						"label": "Interview Title",
						"placeholder": "Enter interview title"
					},
					"candidateName": {
						"label": "Candidate Name",
						"placeholder": "Enter candidate name"
					},
					"candidateEmail": {
						"label": "Candidate Email",
						"placeholder": "Enter candidate email"
					},
					"positionName": {
						"label": "Position Name",
						"placeholder": "Enter position name"
					},
					"interviewerEmail": {
						"label": "Interviewer Email",
						"placeholder": "Search by name or email"
					},
					"date": {
						"label": "Date"
					},
					"time": {
						"label": "Time"
					},
					"duration": {
						"label": "Duration"
					}
				}
			},
			"platformStep": {
				"title": "Video Conference",
				"description": "Fill in the details below. The candidate will receive an email with instructions to download the proctoring app before joining the video conference.",
				"fields": {
					"videoPlatform": {
						"label": "Video Platform",
						"placeholder": "Video Platform"
					},
					"meetingLink": {
						"label": "Meeting Link",
						"placeholder": "Meeting Link"
					},
					"additionalNotes": {
						"label": "Additional Notes",
						"placeholder": "Any special instructions or requirements for the interview..."
					}
				}
			},
			"configurationStep": {
				"title": "Configuration",
				"description": "Fill in the details below. The candidate will receive an email with instructions to download the proctoring app before joining the video conference"
			},
			"reviewStep": {
				"title": "Review the Interview Details",
				"description": "Before scheduling the interview, please review and confirm the following details.",
				"edit": "Edit",
				"detailsTitle": "Interview Details",
				"platformTitle": "Video Platform",
				"configurationsTitle": "Configurations",
				"detailsValues": {
					"candidateName": "Candidate Name",
					"candidateEmail": "Candidate Email",
					"positionName": "Position Name",
					"dateAndTime": "Date & Time"
				},
				"platformValues": {
					"videoPlatform": "Video Conference Name",
					"meetingLink": "Meeting Link",
					"notes": "Additional Notes"
				},
				"card": {
					"title": "An overview to kick off the interview process",
					"line1": "The candidate will receive instructions for setting up the YuJa Candidate AI App.",
					"line2": "A meeting link will be sent to both the candidate and the interviewers on the day of the interview.",
					"line3": "The candidate will receive an automated email reminder about the interview two hours in advance."
				}
			},
			"successPage": {
				"title": "Interview Scheduled!",
				"description": "The interview has been successfully created and the process has started.",
				"headers": {
					"candidate": "Candidate:",
					"position": "Position:",
					"date": {
						"invalid": "Invalid Date"
					}
				},
				"nextSteps": {
					"title": "What Happens Next?",
					"steps": {
						"step1": {
							"title": "App Setup Instructions Sent",
							"description": "The candidate will receive an email with instructions for downloading and setting up the YuJa Candidate AI App. They must complete the security verification before the interview."
						},
						"step2": {
							"title": "Meeting Link Delivered",
							"description": "On the day of the interview, a meeting link will be sent to both the candidate and the interviewers. The candidate will only be able to access the link through the proctoring app."
						},
						"step3": {
							"title": "Automated Reminder",
							"description": "The candidate will receive an automated email reminder about the interview two hours before the scheduled start time, ensuring they are prepared and ready."
						}
					}
				},
				"buttons": {
					"schedule": "Schedule Another Interview",
					"dashboard": "Go to Dashboard"
				}
			}
		},
		"instructorInterviewPage": {
			"title": "{{title}} for {{candidateName}}",
			"status": "Live Session",
			"buttons": {
				"back": "Back",
				"end": "End Interview"
			},
			"waiting": {
				"message": "Candidate may have joined the interview without going through the YuJa Candidate AI app. Ask them to leave the call and rejoin through the app so their session can be set up properly.",
				"title": "Waiting for the Candidate to Join...",
				"description": "The candidate has not joined the interview yet. We are waiting for candidate to complete setup and connect to the Interview.",
				"launchCall": "Launch {{videoPlatform}}"
			},
			"inProgress": {
				"title": "Video Interview in Progress",
				"description": "Conducting interview on {{videoPlatform}} • Use dual monitors for best experience",
				"launchCall": "Launch {{videoPlatform}}",
				"tabs": {
					"info": {
						"name": "Session Info",
						"title": "Session Information",
						"candidateName": "Candidate",
						"duration": "Duration",
						"videoPlatform": "Platform",
						"notes": {
							"title": "Interview Notes",
							"placeholder": "Add notes about the interview or proctoring events..."
						}
					},
					"live": {
						"name": "Live Events",
						"video": "Live Screen View",
						"events": "Flagged Events"
					}
				}
			},
			"completed": {
				"title": "Interview Call Ended",
				"description": "The interview has ended. You can resume the call to rejoin or finalize the interview to view the results.",
				"buttons": {
					"resume": "Resume Interview",
					"complete": "Mark Interview as Complete"
				},
				"toast": {
					"success": "Interview completed",
					"fail": "Failed to mark interview as complete"
				}
			}
		},
		"resultsPage": {
			"title": "Interview Results",
			"description": "Review recordings, flagged events, and proctoring results of past completed interviews.",
			"button": {
				"loadMore": "Load More",
				"back": "Back"
			},
			"unattended": {
				"message": "<bold>Candidate No-Show:</bold> The scheduled time has passed and the candidate did not join the interview. No proctoring data or recordings were captured.",
				"header": {
					"candidate": "Candidate:",
					"position": "Position:",
					"date": {
						"today": "Today",
						"yesterday": "Yesterday",
						"invalid": "Invalid Date"
					}
				},
				"nextSteps": {
					"title": "Next Steps Required",
					"description": "Since this interview did not take place, you need to follow up with the candidate or schedule a new time."
				},
				"button": {
					"reschedule": "Reschedule Interview"
				}
			},
			"empty": {
				"title": "No Completed Interviews Yet",
				"description": "Once a candidate finishes their proctored interview, their recording, flags, and overall result will appear here for your review.",
				"button": {
					"dashboard": "Back to Homepage",
					"schedule": "Schedule an Interview"
				}
			}
		},
		"candidateLandingPage": {
			"title": "Launch YuJa Candidate AI from Your Email",
			"description1": "YuJa Candidate AI is your interview proctoring tool. Check your email and click the Launch Interview button to open the app on the device you will use for your interview.",
			"description2": "Watch the instructional video below if you need additional information."
		},
		"candidatePreInterview": {
			"precheckPage": {
				"title": "Your Interview Starts in...",
				"description": "Your interview has not started yet. We recommend completing the Pre-Interview Check to ensure your system meets the requirements and to help prevent technical issues.",
				"button": {
					"startCheck": "Start Pre-Interview Check"
				}
			},
			"postcheckPage": {
				"title": "Your pre-interview check is complete",
				"description": "Your Pre-Interview Check is complete. Once your interview becomes available, click the Start Interview button below to join."
			},
			"interviewReadyPage": {
				"title": "Your interview Is Now Available",
				"description": "Your Pre-Interview Check is complete and your interview is now available to join.\nClick the Start Interview button below to begin."
			},
			"startInterviewPage": {
				"title": "Your Interview Is Now Available",
				"description1": "When you click Start Interview button below, YuJa Candidate AI will check your system to ensure it meets the required specifications and help prevent technical issues.",
				"description2": "Click Start Interview when you are ready to begin."
			},
			"countdown": {
				"days": "Days",
				"hours": "Hours",
				"minutes": "Minutes",
				"seconds": "Seconds"
			},
			"button": {
				"startInterview": "Start Interview",
				"checkAgain": "Test Again"
			}
		},
		"candidateInterviewPage": {
			"title": "Your Interview Has Started",
			"description": "Your interview has started successfully. Click Open Video Call when you are ready. Good luck!",
			"timer": "Interview Starts in <strong><highlight>{{time}}</highlight> mins</strong>",
			"button": {
				"launchCall": "Launch Video Call"
			}
		},
		"bridgePage": {
			"title": "Your Interview Starts in...",
			"description": "To begin your interview, you will need to set up the Candidate AI app. If you haven't downloaded it yet, click a button below to download and install the app on your device, then click <strong>Open Candidate AI App</strong> to continue.",
			"button": {
				"download": "Download for",
				"openApp": "Open Candidate AI App"
			}
		}
	},
	"ltiErrorHtml": {
		"title": "LMS Connection Needs Attention",
		"description": {
			"clientId": "The Client ID in Verity does not match the one provided by your LMS. Ask your institution administrator to update the Client ID in Verity and try again.",
			"iss": "The Issuer (ISS) in Verity does not match your LMS configuration. Ask your administrator to update it and try again.",
			"clientIdOrIss": "The Client ID and/or the Issuer (ISS) in Verity do not match your LMS configuration. Ask your administrator to update them and try again.",
			"deploymentId": "The Deployment ID in Verity does not match your LMS configuration. Ask your administrator to update it and try again.",
			"jwks": "The JWKS Endpoint in Verity does not match your LMS configuration. Ask your administrator to check it and try again.",
			"unknown": "Your Verity and LMS configurations do not match. Ask your administrator to review the settings and try again."
		}
	},
	"components": {
		"compositeTableTSX": {
			"sortTooltip": "Sort {{columnName}}"
		},
		"recordingPlaybackPlayerTSX": {
			"play": "Play",
			"pause": "Pause",
			"replay": "Replay",
			"playAudioLabel": "Play audio",
			"pauseAudioLabel": "Pause audio",
			"replayAudioLabel": "Replay audio",
			"mute": "Mute",
			"unmute": "Unmute",
			"volumeSlider": "Volume",
			"enterFullscreen": "Enter fullscreen",
			"exitFullscreen": "Exit fullscreen",
			"seekSlider": "Seek",
			"audioPlaybackControlsLabel": "Audio playback controls",
			"audioPosterHint": "Recording saved. Play back to confirm, or re-record.",
			"audioPosterHintReadOnly": "Recording saved. Play back to confirm."
		}
	},
	"lumina": {
		"configure": {
			"unavailable": {
				"header": "This configurator is unavailable",
				"body": "Please contact your administrator."
			},
			"ineligible": {
				"header": "Verity is not enabled for this institution",
				"body": "Please contact site admin to enable Verity for all courses within this institution."
			}
		},
		"student": {
			"connected": {
				"body": "Setup is complete. Return to your quiz to begin."
			},
			"expired": {
				"title": "This setup link has expired",
				"body": "Close this page and open the quiz again to set up proctoring."
			},
			"failed": {
				"title": "Setup could not be completed"
			},
			"ineligible": {
				"header": "This quiz cannot be set up here",
				"body": "This quiz is configured for a proctoring method this page does not support. Please contact your instructor."
			},
			"unavailable": {
				"header": "Proctoring setup is unavailable",
				"body": "Please contact your instructor."
			},
			"unregistered": {
				"title": "You are not registered for a proctored session",
				"body": "This quiz is no longer open for registration. Contact your instructor to be added to a session before you take it."
			}
		},
		"results": {
			"empty": {
				"header": "No proctoring sessions yet",
				"body": "This student has not attempted this quiz. Their proctoring sessions will appear here once they do."
			},
			"unavailable": {
				"header": "These results are unavailable",
				"body": "Please reopen this student's results. If the problem continues, contact your administrator."
			}
		}
	}
}
